import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  until1jbpn0z3f8lbg as until,
  to2cs3ny02qtbcb as to,
  listOf1jh22dvmctj1r as listOf,
  sum2dx8v93g9zr2l as sum,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  sum1ib1hqt64m6qf as sum_0,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  emptyList1g2z5xcrvp2zy as emptyList,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortWith4fnm6b3vw03s as sortWith,
  contains3ue2qo8xhmpf1 as contains_0,
  toLongw1zpgk99d84b as toLong,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  slice2g43wio9c6zdv as slice,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  lastOrNull1aq5oz189qoe1 as lastOrNull_0,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  lastOrNulllcnpzslswkag as lastOrNull_1,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart5ewg8zf6cs5u as trimStart,
  trimEnd17pt8cbotbalj as trimEnd,
  contains2el4s70rdq4ld as contains_1,
  Regexxgw0gjiagf4z as Regex,
  drop3na99dw9feawf as drop,
  plus20p0vtfmu0596 as plus_1,
  removeLast3759euu1xvfa3 as removeLast,
  dropLast1vpiyky649o34 as dropLast,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  substringAfter1hku067gwr5ve as substringAfter,
  substringBefore3n7kj60w69hju as substringBefore,
  withIndex37cl61h9v5txo as withIndex,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instanceeeaudfwfrq87 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  arc$default4sjbw0e0mkug as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  splitInRows1cyiez6sz0yy1 as splitInRows,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  _SliceOrientation___get_raw__impl__tj3u8w1oalkydpnsgkf as _SliceOrientation___get_raw__impl__tj3u8w,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  rectlvaio1p4o04e as rect_2,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  plus1r33v70e4ipd7 as plus_2,
  get_immutablepxpdoj6e54ll as get_immutable,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_1,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstance2yu48324co92b as Companion_getInstance_6,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_7,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_0,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  toFastList32ukjb68l6wd7 as toFastList,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  getExtra307y0o9pd6mp3 as getExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  clamp1qclpmpfxm7xb as clamp_1,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  hasBitSet141smdymg86x0 as hasBitSet,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Companion_instance3g6ghp1wfgmk3 as Companion_instance_2,
  IntMaskRange__extractSigned_impl_s8qphq8ygd3tlk981r as IntMaskRange__extractSigned_impl_s8qphq,
  maskkmj9g5rvi2pr as mask,
  umod164hvijxhfi8p as umod,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_9,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod_0,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_3,
  Companion_instance3ldriv9x4zcjm as Companion_instance_4,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  toLinkedMap37vdtde5j2z8d as toLinkedMap,
  toDeque2gx2crptp8sro as toDeque,
  TGenDeque2zx9g0ftfbw19 as TGenDeque,
  BaseDelegatedStackedArray2i6xcy52y4r2o as BaseDelegatedStackedArray2,
  StackedInt53Array22b4kxb7j3a5rc as StackedInt53Array2,
  IStackedArray2Baseutd8qm80cz0q as IStackedArray2Base,
  get2pw1zlgv5zypd as get,
  set2vuztm9k7ubgo as set,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS32Array39c2ui7l3wxdu as getS32Array,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_11,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  splitInChunks2h1zfocl4rvqy as splitInChunks,
  splitKeep2hxk3xif9u3vx as splitKeep,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get_0,
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_12,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readBytesExact2w7t0p09xkbt6 as readBytesExact,
  readU16LE24dnvocwt4zgx as readU16LE,
  readS32LE3aqh95gxznf4n as readS32LE,
  readU32LE336f0p4nkvbi as readU32LE,
  readU82o15i0epsnmc5 as readU8,
  readS16LE375f28fer5dhk as readS16LE,
  readStreamp6bgvjd275ek as readStream,
  readAvailablecuh5du6kum51 as readAvailable,
  readString20u8kjncp0xlx as readString,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString_0,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact_0,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_1,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream_0,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_14,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_5,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import {
  Int53__extract_impl_ikc3evljmx5jz12lam as Int53__extract_impl_ikc3ev,
  Int53__extract_impl_ikc3evy2evy7i0ffff as Int53__extract_impl_ikc3ev_0,
  Int53__extractSigned_impl_v59qt9d1lcr64lbdej as Int53__extractSigned_impl_v59qt9,
  Companion_getInstance2fdy01ctwk4tu as Companion_getInstance_15,
  Int53__insertNoClear_impl_aaadnr3l30mzmlgy6ww as Int53__insertNoClear_impl_aaadnr,
  Int53__insertNoClear_impl_aaadnr2g6a491qumb9d as Int53__insertNoClear_impl_aaadnr_0,
} from './korlibs-number-root-korlibs-number.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.h55_1 = slice;
    this.i55_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.h55_1.toString() + ', data=' + toString(this.i55_1) + ')';
  }
  hashCode() {
    var result = this.h55_1.hashCode();
    result = imul(result, 31) + (this.i55_1 == null ? 0 : hashCode(this.i55_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.h55_1.equals(tmp0_other_with_cast.h55_1))
      return false;
    if (!equals(this.i55_1, tmp0_other_with_cast.i55_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static m56(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.j55_1 = binPacker;
    $this.k55_1 = border;
    $this.l55_1 = premultiplied;
    $this.m55_1 = allowToGrow;
    $this.n55_1 = growMethod;
    $this.o55_1 = MarginInt.v3l($this.k55_1);
    $this.p55_1 = Bitmap32.k56($this.f3u(), $this.g3u(), VOID, $this.l55_1);
    $this.q55_1 = arrayListOf([$this.p55_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r55_1 = ArrayList.z();
    $this.s55_1 = LinkedHashMap.wc();
    $this.t55_1 = null;
    return $this;
  }
  static n56(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.m56(Companion_instance_0.c4q(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  f3u() {
    return numberToInt(this.j55_1.f3u());
  }
  g3u() {
    return numberToInt(this.j55_1.g3u());
  }
  g1() {
    return this.r55_1.g1();
  }
  o56(bmp, data, name) {
    return this.l56(slice_0(bmp, VOID, name), data, name);
  }
  p56(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.g1() : name;
    return $super === VOID ? this.o56(bmp, data, name) : $super.o56.call(this, bmp, data, name);
  }
  l56(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.o56(extract_0(bmp).d57(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.g1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.t55_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.t55_1).h55_1;
        if (bigEmptySlice.r4r_1 >= bmp.r4r_1 && bigEmptySlice.s4r_1 >= bmp.s4r_1) {
          entry = new Entry(bigEmptySlice.b4t(RectangleInt.j3r(0, 0, bmp.r4r_1, bmp.s4r_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.j55_1.u44(bmp.r4r_1 + imul(this.k55_1, 2), bmp.s4r_1 + imul(this.k55_1, 2));
        var slice = sliceWithSize(this.p55_1, numberToInt(rect.i3j() + this.k55_1), numberToInt(rect.d3q() + this.k55_1), bmp.r4r_1, bmp.s4r_1, rname);
        var dstX = slice.i3j();
        var dstY = slice.d3q();
        var boundsWithBorder = get_bounds_0(slice).k3r(this.o55_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.p55_1;
        if (true) {
          this_0.e57();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.p55_1.f57(bmp, dstX, dstY);
          expandBorder(this.p55_1, slice.j4r_1, this.k55_1);
        }finally {
          result = true ? this_0.g57(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.t55_1 == null || bmp.x3r() > ensureNotNull(this.t55_1).h55_1.x3r()) {
          this.t55_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.r55_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.s55_1;
      var value = entry;
      this_2.k3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.m55_1)
          throw e;
        growAtlas(this, bmp);
        return this.l56(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  h57(bmp, data, name, $super) {
    name = name === VOID ? bmp.m4r_1 : name;
    return $super === VOID ? this.l56(bmp, data, name) : $super.l56.call(this, bmp, data, name);
  }
}
class Bitmap {
  static i57(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.q56_1 = new Mixin();
    $this.r56_1 = width;
    $this.s56_1 = height;
    $this.t56_1 = bpp;
    $this.u56_1 = backingArray;
    $this.v56_1 = RectangleInt.j3r(0, 0, $this.r56_1, $this.s56_1);
    $this.w56_1 = null;
    $this.x56_1 = premultiplied;
    $this.y56_1 = false;
    var tmp = $this;
    tmp.z56_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.a57_1 = 0;
    $this.b57_1 = null;
    $this.c57_1 = false;
    return $this;
  }
  c28(_set____db54di) {
    this.q56_1.c28(_set____db54di);
  }
  d28() {
    return this.q56_1.d28();
  }
  g1() {
    return SizeInt.x3s(this.r56_1, this.s56_1);
  }
  j57() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z56_1;
    tempInts$factory();
    return this_0.w1();
  }
  k57() {
    return _RgbaArray___init__impl__oib4y4(this.j57());
  }
  l57() {
    return imul(this.r56_1, this.t56_1) / 8 | 0;
  }
  x3r() {
    return imul(this.r56_1, this.s56_1);
  }
  m57(x, y) {
    return imul(y, this.r56_1) + x | 0;
  }
  n57() {
    if (!(this.b57_1 == null)) {
      this.b57_1 = null;
    }
  }
  e57() {
    return Unit_instance;
  }
  g57(rect) {
    if (this.b57_1 == null)
      this.b57_1 = rect;
    else
      this.b57_1 = Companion_instance_1.q3r(ensureNotNull(this.b57_1), rect);
    this.a57_1 = this.a57_1 + 1 | 0;
    return this.a57_1;
  }
  o57(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.p57(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  q57(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.r57(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  s57(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.q57(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.q57.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  t57(x, y, v) {
    if (this.x56_1) {
      this.r57(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.r57(x, y, v);
    }
  }
  u57(x, y) {
    var tmp;
    if (this.x56_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.p57(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.p57(x, y);
    }
    return tmp;
  }
  v57(x, y, color) {
    this.r57(x, y, _RGBA___init__impl__lqpay5(color));
  }
  w57(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.p57(x, y));
  }
  x57(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.r56_1 || y0 >= this.s56_1)
      return Colors_getInstance().d58_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.r56_1 - 1 | 0);
    var y1Inside = y1 < (this.s56_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.p57(x0, y0);
    var c10 = x1Inside ? this.p57(x1, y0) : c00;
    var c01 = y1Inside ? this.p57(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.p57(x1, y1) : c01;
    return Companion_getInstance_24().v5d(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  w5d(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.x5d(srcX);
    var srcX1 = src.x5d(srcX + width | 0);
    var srcY0 = src.y5d(srcY);
    var srcY1 = src.y5d(srcY + height | 0);
    var dstX0 = dst.x5d(dstX);
    var dstX1 = dst.x5d(dstX + width | 0);
    var dstY0 = dst.y5d(dstY);
    var dstY1 = dst.y5d(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.z5d(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  z5d(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o57(srcX, srcY + y | 0, width, 1, this.j57(), 0);
        dst.q57(dstX, dstY + y | 0, width, 1, this.j57(), 0);
      }
       while (inductionVariable < height);
  }
  a5e(x) {
    return x >= 0 && x < this.r56_1;
  }
  b5e(y) {
    return y >= 0 && y < this.s56_1;
  }
  c5e(x, y) {
    return this.a5e(x) && this.b5e(y);
  }
  d5e(x) {
    return clamp(x, 0, this.r56_1 - 1 | 0);
  }
  e5e(y) {
    return clamp(y, 0, this.s56_1 - 1 | 0);
  }
  x5d(x) {
    return clamp(x, 0, this.r56_1);
  }
  y5d(y) {
    return clamp(y, 0, this.s56_1);
  }
  f5e() {
    var inductionVariable = 0;
    var last = this.s56_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g5e(y, (this.s56_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  h5e() {
    var inductionVariable = 0;
    var last = this.r56_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i5e(x, (this.r56_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  j5e(rotation) {
    var tmp;
    switch (rotation.p3_1) {
      case 0:
        tmp = this.z27();
        break;
      case 1:
        tmp = this.k5e().h5e();
        break;
      case 2:
        tmp = this.k5e().h5e().k5e().h5e();
        break;
      case 3:
        tmp = this.k5e().f5e();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  l5e(orientation) {
    var out = this.z27();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.h5e();
    }
    return out.j5e(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  k5e() {
    var temp = new IntArray2(this.r56_1, this.s56_1, readPixelsUnsafe(this, 0, 0, this.r56_1, this.s56_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.s56_1;
    var height = this.r56_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.s56_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.r56_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.l3u(y, x, temp.z3k(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.m5e(this.s56_1, this.r56_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.s57(0, 0, this.s56_1, this.r56_1, out.e3u_1);
    return this_0;
  }
  g5e(y0, y1) {
    var inductionVariable = 0;
    var last = this.r56_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.w57(x, y0);
        var c1 = this.w57(x, y1);
        this.v57(x, y0, c1);
        this.v57(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  i5e(x0, x1) {
    var inductionVariable = 0;
    var last = this.s56_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.w57(x0, y);
        var c1 = this.w57(x1, y);
        this.v57(x0, y, c1);
        this.v57(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  n5e(antialiasing) {
    throw UnsupportedOperationException.sa('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  m5e(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  d57() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.k56(this.r56_1, this.s56_1, VOID, this.x56_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.o57(0, 0, this.r56_1, this.s56_1, this_0.h56_1, 0);
    return this_0;
  }
  o5e() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.d57();
    }
    return tmp;
  }
  z27() {
    var out = this.m5e(this.r56_1, this.s56_1);
    this.z5d(0, 0, out, 0, 0, this.r56_1, this.s56_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_6 = this;
    this.y5e_1 = Bitmap32.k56(0, 0, VOID, true);
  }
  z5e(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.k56(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.h56_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  a5f(width, height, premultiplied) {
    return Bitmap32.k56(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  b5f(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.f5f_1;
    var dstShift = dstChannel.f5f_1;
    var dstClear = dstChannel.h5f_1;
    var dstData = dst.h56_1;
    var srcData = src.h56_1;
    var inductionVariable = 0;
    var last = dst.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  i5f(src, dst, dstChannel) {
    var destShift = imul(dstChannel.e5f_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.d5g()[n] & 255;
        dst.h56_1[n] = dst.h56_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  e5g(src, srcChannel, dst) {
    var shift = srcChannel.f5f_1;
    var inductionVariable = 0;
    var last = src.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.d5g()[n] = toByte((src.h56_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
  f5g(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.w5d(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.w5e_1 = this$0;
  }
  g5g($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  le(p1, $completion) {
    return this.g5g(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static k56(width, height, ints, premultiplied) {
    Companion_getInstance_16();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.i57(width, height, 32, premultiplied, ints);
    $this.h56_1 = ints;
    if ($this.h56_1.length < imul(width, height))
      throw RuntimeException.bb('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.h56_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.i56_1 = new Int32Array(tmp$ret$0);
    $this.j56_1 = RectangleInt.j3r(0, 0, width, height);
    return $this;
  }
  static h5g(width, height, value) {
    Companion_getInstance_16();
    return this.k56(width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
  }
  m5e(width, height) {
    return Bitmap32.k56(width, height, VOID, this.x56_1);
  }
  z5d(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.z5d(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.h56_1;
    var dstArray = dst.h56_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.m57(srcX, srcY + y | 0), dstArray, dst.m57(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  i5g(x, y, color) {
    this.t57(x, y, color);
  }
  j5g(x, y) {
    return this.u57(x, y);
  }
  v57(x, y, color) {
    this.h56_1[this.m57(x, y)] = color;
  }
  w57(x, y) {
    return this.h56_1[this.m57(x, y)];
  }
  p57(x, y) {
    return _RGBA___init__impl__lqpay5(this.w57(x, y));
  }
  r57(x, y, v) {
    return this.v57(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  k5g(n, color) {
    this.h56_1[n] = this.x56_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  l5g(n, color) {
    var tmp;
    if (this.x56_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.h56_1[n] = tmp;
  }
  x5e(n) {
    var tmp;
    if (this.x56_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.h56_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.h56_1[n]);
    }
    return tmp;
  }
  m5g(n) {
    return this.x56_1 ? _RGBAPremultiplied___init__impl__uos02x(this.h56_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.h56_1[n]));
  }
  n5g(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.m57(dx, dy + y | 0);
        var srcOffset = src.m57(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.l5g(dstOffset + x | 0, mix(dst.m5g(dstOffset + x | 0), src.m5g(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.x56_1 === src.x56_1) {
            arraycopy(src.h56_1, srcOffset, dst.h56_1, dstOffset, width);
          } else if (!dst.x56_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.k5g(dstOffset + x_0 | 0, src.x5e(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.l5g(dstOffset + x_1 | 0, src.m5g(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  o5g(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.r56_1 - dx_0 | 0;
    var availableHeight = this.s56_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.n5g(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  p5g(mix, other, _dx, _dy) {
    this.o5g(other, _dx, _dy, 0, 0, other.r56_1, other.s56_1, mix);
  }
  q5g(color, x, y, width, height) {
    var x1 = this.d5e(x);
    var x2 = this.d5e((x + width | 0) - 1 | 0);
    var y1 = this.e5e(y);
    var y2 = this.e5e((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.x56_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.h56_1, colorInt, this.m57(x1, cy), this.m57(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  r5g(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.r56_1 - x | 0 : width;
    height = height === VOID ? this.s56_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.q5g(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.q5g.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  s5g(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.o5g(get_bmp(src), dx, dy, b.i3j(), b.d3q(), b.j3j(), b.c3q(), mix);
  }
  t5g(src, dx, dy) {
    return this.p5g(false, src, dx, dy);
  }
  u5g(src, dx, dy) {
    return this.p5g(true, src, dx, dy);
  }
  v5g(src, dx, dy) {
    return this.s5g(src, dx, dy, false);
  }
  f57(src, dx, dy) {
    return this.s5g(src, dx, dy, true);
  }
  w5g(destination, input, source) {
    return Companion_getInstance_16().b5f(input, source, this, destination);
  }
  x5g(destination, input) {
    return Companion_getInstance_16().i5f(input, this, destination);
  }
  y5g(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_16().e5g(this, channel, out);
    return out;
  }
  z5g(channel, out, $super) {
    out = out === VOID ? Bitmap8.u5h(this.r56_1, this.s56_1) : out;
    return $super === VOID ? this.y5g(channel, out) : $super.y5g.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.gc('Bitmap32(');
    this_0.rh(this.r56_1);
    this_0.gc(', ');
    this_0.rh(this.s56_1);
    if (!(this.w56_1 == null)) {
      this_0.gc(', name=');
      this_0.gc(this.w56_1);
    }
    this_0.gc(')');
    return this_0.toString();
  }
  g5e(y0, y1) {
    var s0 = this.m57(0, y0);
    var s1 = this.m57(0, y1);
    arraycopy(this.h56_1, s0, this.i56_1, 0, this.r56_1);
    arraycopy(this.h56_1, s1, this.h56_1, s0, this.r56_1);
    arraycopy(this.i56_1, 0, this.h56_1, s1, this.r56_1);
  }
  z27() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h56_1.slice();
    return Bitmap32.k56(this.r56_1, this.s56_1, tmp$ret$1, this.x56_1);
  }
  n5e(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  v5h() {
    return this.x56_1 ? this : this.copyPremultiplied();
  }
  w5h() {
    return !this.x56_1 ? this : this.x5h();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.z27();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.y5h();
    return this_0;
  }
  x5h() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.z27();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.z5h();
    return this_0;
  }
  y5h() {
    if (this.x56_1)
      return Unit_instance;
    this.x56_1 = true;
    var inductionVariable = 0;
    var last = this.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.h56_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.h56_1[n])));
      }
       while (inductionVariable < last);
  }
  z5h() {
    if (!this.x56_1)
      return Unit_instance;
    this.x56_1 = false;
    var inductionVariable = 0;
    var last = this.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.h56_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.h56_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  b1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  a5i(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.h56_1, this.m57(x, y), width);
    } else {
      var m = this.m57(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.h56_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  d57() {
    return this;
  }
}
class Companion_0 {
  b5i(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.w5d(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static d5i(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_13.c5i(1 << bpp) : palette;
    var $this = this.i57(width, height, bpp, false, bytes);
    $this.w5f_1 = bytes;
    $this.x5f_1 = palette;
    if ($this.w5f_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.bb('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.d5g().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.y5f_1 = new Int8Array(tmp$ret$0);
    $this.z5f_1 = _UByteArrayInt___init__impl__xif7bu($this.d5g());
    $this.a5g_1 = 8 / bpp | 0;
    $this.b5g_1 = ilog2($this.a5g_1);
    $this.c5g_1 = $this.a5g_1 - 1 | 0;
    return $this;
  }
  d5g() {
    return this.w5f_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.t56_1 + ', width=' + this.r56_1 + ', height=' + this.s56_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.x5f_1) + ')';
  }
  w57(x, y) {
    return this.f5i(this.m57(x, y));
  }
  v57(x, y, color) {
    return this.e5i(this.m57(x, y), color);
  }
  f5i(n) {
    var iD = this.h5i(n);
    var iM = this.i5i(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.z5f_1, iD), imul(this.t56_1, iM), this.t56_1);
  }
  e5i(n, color) {
    var iD = this.h5i(n);
    var iM = this.i5i(n);
    UByteArrayInt__set_impl_gn4532(this.z5f_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.z5f_1, iD), color, imul(this.t56_1, iM), this.t56_1));
  }
  p57(x, y) {
    var tmp = this.x5f_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.w57(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  r57(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  g5i(x, y) {
    return this.h5i(this.m57(x, y));
  }
  h5i(n) {
    return n >>> this.b5g_1 | 0;
  }
  i5i(n) {
    return n & this.c5g_1;
  }
  g5e(y0, y1) {
    var s0 = this.g5i(0, y0);
    var s1 = this.g5i(0, y1);
    arraycopy_0(this.d5g(), s0, this.y5f_1, 0, this.l57());
    arraycopy_0(this.d5g(), s1, this.d5g(), s0, this.l57());
    arraycopy_0(this.y5f_1, 0, this.d5g(), s1, this.l57());
  }
  j5i(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.d5g(), this.m57(x, y), width / this.a5g_1 | 0);
    } else {
      var m = this.m57(x, y);
      var inductionVariable = 0;
      var last = width / this.a5g_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.d5g()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  d57() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.k56(this.r56_1, this.s56_1, VOID, this.x56_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.h56_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.x5f_1);
    var inductionVariable = 0;
    var last = this.x3r();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.f5i(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static u5h(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_13.c5i(256) : palette;
    return this.d5i(8, width, height, data, palette);
  }
  m5e(width, height) {
    return Bitmap8.u5h(width, height, VOID, this.x5f_1);
  }
  v57(x, y, color) {
    return this.e5i(this.m57(x, y), color);
  }
  w57(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.z5f_1, this.m57(x, y));
  }
  p57(x, y) {
    var tmp = this.x5f_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.w57(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  f5i(n) {
    return UByteArrayInt__get_impl_px6q8a(this.z5f_1, n);
  }
  e5i(n, color) {
    UByteArrayInt__set_impl_gn4532(this.z5f_1, n, color);
  }
  z5d(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.z5d(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.d5g();
        var tmp_0 = this.m57(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).d5g(), dst.m57(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  z27() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.d5g().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.x5f_1).slice();
    return Bitmap8.u5h(this.r56_1, this.s56_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.r56_1 + ', ' + this.s56_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.x5f_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_8 = this;
    this.k5i_1 = values();
  }
  h1(index) {
    return this.k5i_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.e5f_1 = index;
    this.f5f_1 = imul(this.e5f_1, 8);
    this.g5f_1 = 255 << this.f5f_1;
    this.h5f_1 = ~this.g5f_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.l5i_1 = 1.0;
    this.m5i_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.n5i_1 = width;
    this.o5i_1 = height;
    this.p5i_1 = d;
    this.q5i_1 = px;
    this.r5i_1 = py;
    this.s5i_1 = imul(this.n5i_1, this.o5i_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.p5i_1.length >= this.s5i_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q5i_1.length >= this.s5i_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.r5i_1.length >= this.s5i_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_1));
    }
  }
  a5e(x) {
    return x >= 0 && x < this.n5i_1;
  }
  b5e(y) {
    return y >= 0 && y < this.o5i_1;
  }
  c5e(x, y) {
    return this.a5e(x) && this.b5e(y);
  }
  m57(x, y) {
    return imul(y, this.n5i_1) + x | 0;
  }
  x5i(x, y) {
    return this.c5e(x, y) ? this.p5i_1[this.m57(x, y)] : Infinity;
  }
  u5i(x, y) {
    return this.c5e(x, y) ? this.q5i_1[this.m57(x, y)] : -1;
  }
  v5i(x, y) {
    return this.c5e(x, y) ? this.r5i_1[this.m57(x, y)] : -1;
  }
  w5i(x, y, d) {
    if (!this.c5e(x, y))
      return Unit_instance;
    this.p5i_1[this.m57(x, y)] = d;
  }
  y5i(x, y, px, py) {
    if (!this.c5e(x, y))
      return Unit_instance;
    var index = this.m57(x, y);
    this.q5i_1[index] = px;
    this.r5i_1[index] = py;
  }
  t5i(x, y, px, py) {
    return this.y5i(x, y, this.u5i(px, py), this.v5i(px, py));
  }
  z5i(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.n5i_1 === bmp.r56_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.o5i_1 === bmp.s56_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.h5(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.o5i_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.n5i_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.w5i(x, y, Infinity);
            this.y5i(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.o5i_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.n5i_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.w5i(x_0, y_0, 0.0);
              this.y5i(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.o5i_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.n5i_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.o5i_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.n5i_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.o5i_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.n5i_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.w5i(x_3, y_3, -this.x5i(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static o5j(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.i57(width, height, 32, premultiplied, data);
    $this.n5j_1 = data;
    return $this;
  }
  r57(x, y, v) {
    var rindex = index4(this, x, y);
    this.n5j_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.n5j_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.n5j_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.n5j_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  p57(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_24().p5j(this.n5j_1[rindex + 0 | 0], this.n5j_1[rindex + 1 | 0], this.n5j_1[rindex + 2 | 0], this.n5j_1[rindex + 3 | 0]);
  }
  q5j(x, y) {
    return this.n5j_1[index4(this, x, y) + 0 | 0];
  }
  r5j(x, y) {
    return this.n5j_1[index4(this, x, y) + 1 | 0];
  }
  s5j(x, y) {
    return this.n5j_1[index4(this, x, y) + 2 | 0];
  }
  t5j(x, y) {
    return this.n5j_1[index4(this, x, y) + 3 | 0];
  }
  u5j(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.n5j_1[rindex + 0 | 0] = r;
    this.n5j_1[rindex + 1 | 0] = g;
    this.n5j_1[rindex + 2 | 0] = b;
    this.n5j_1[rindex + 3 | 0] = a;
  }
  v5j(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.n5j_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.n5j_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.n5j_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.n5j_1[rindex + 3 | 0]);
    return out;
  }
  w5j(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r56_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s56_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m57(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.v5j(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  x5j(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.w5j(out) : $super.w5j.call(this, out);
  }
  y5j(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r56_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s56_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m57(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.v5j(x, y, out);
            this.u5j(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  z5j(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.y5j(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.y5j.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  a5k() {
    var _destruct__k2r9zo = this.x5j();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.z5j(-range, +range);
  }
  b5k(scale) {
    return this.c5k(scale, scale, scale, scale);
  }
  c5k(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r56_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s56_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m57(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.u5j(x, y, this.q5j(x, y) * scaleRed, this.r5j(x, y) * scaleGreen, this.s5j(x, y) * scaleBlue, this.t5j(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  d5k(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r56_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s56_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m57(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.q5j(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.r5j(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.s5j(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.t5j(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.u5j(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static s5k(width, height, data, premultiplied) {
    var $this = this.i57(width, height, 32, premultiplied, null);
    $this.r5k_1 = data;
    return $this;
  }
  d57() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_16().a5f(this.r56_1, this.s56_1, this.x56_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.o57(0, 0, this.r56_1, this.s56_1, this_0.h56_1, 0);
    return this_0;
  }
  r57(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.k57(), 0, v);
    this.q57(x, y, 1, 1, this.j57(), 0);
  }
  p57(x, y) {
    this.o57(x, y, 1, 1, this.j57(), 0);
    return RgbaArray__get_impl_nzyo1o(this.k57(), 0);
  }
  v57(x, y, color) {
    return this.r57(x, y, _RGBA___init__impl__lqpay5(color));
  }
  w57(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.p57(x, y));
  }
  f5e() {
    var tmp = this.d57().f5e();
    this.s57(0, 0, this.r56_1, this.s56_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).h56_1);
    return this;
  }
  h5e() {
    var tmp = this.d57().h5e();
    this.s57(0, 0, this.r56_1, this.s56_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).h56_1);
    return this;
  }
  g5e(y0, y1) {
    this.o57(0, y0, this.r56_1, 1, this.j57(), 0);
    this.o57(0, y1, this.r56_1, 1, this.j57(), this.r56_1);
    this.q57(0, y1, this.r56_1, 1, this.j57(), 0);
    this.q57(0, y0, this.r56_1, 1, this.j57(), this.r56_1);
  }
  i5e(x0, x1) {
    this.o57(x0, 0, 1, this.s56_1, this.j57(), 0);
    this.o57(x1, 0, 1, this.s56_1, this.j57(), this.r56_1);
    this.q57(x1, 0, 1, this.s56_1, this.j57(), 0);
    this.q57(x0, 0, 1, this.s56_1, this.j57(), this.r56_1);
  }
  m5e(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.q3() + '(' + this.r56_1 + ', ' + this.s56_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class Companion_3 {
  w5k(bmp, left, top, right, bottom) {
    return new NinePatchBmpSlice(bmp, NinePatchInfo.n5l(bmp.r4r_1, bmp.s4r_1, left, top, right, bottom, bmp));
  }
}
class NinePatchBmpSlice {
  constructor(content, info, bmpSlice) {
    bmpSlice = bmpSlice === VOID ? content : bmpSlice;
    this.o5l_1 = content;
    this.p5l_1 = info;
    this.q5l_1 = bmpSlice;
  }
  r5l(segment) {
    return ensureNotNull(segment.z5l_1);
  }
}
class AxisSegment {
  constructor(scaled, range) {
    this.b5m_1 = scaled;
    this.c5m_1 = range;
  }
  d5m() {
    return !this.b5m_1;
  }
  a() {
    return get_length(this.c5m_1);
  }
  e5m(axis, boundsLength) {
    var scale = clamp_1(boundsLength / axis.g5m_1, 0.0, 1.0);
    var tmp;
    if (this.d5m()) {
      tmp = this.a() * scale;
    } else {
      var variableSize = boundsLength - axis.i5m_1 * scale;
      tmp = variableSize * (this.a() / axis.j5m_1);
    }
    return tmp;
  }
}
class AxisInfo {
  constructor(ranges, totalLen) {
    this.f5m_1 = ranges;
    this.g5m_1 = totalLen;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f5m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.segments.<anonymous>' call
      var tmp$ret$0 = new AxisSegment(item.nm_1, item.om_1);
      destination.h(tmp$ret$0);
    }
    tmp.h5m_1 = toFastList(destination);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = this.h5m_1;
    var destination_0 = ArrayList.z();
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      if (element.d5m()) {
        destination_0.h(element);
      }
    }
    var sum = 0;
    var tmp0_iterator_1 = destination_0.b1();
    while (tmp0_iterator_1.c1()) {
      var element_0 = tmp0_iterator_1.d1();
      var tmp_1 = sum;
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      sum = tmp_1 + element_0.a() | 0;
    }
    var b = sum;
    tmp_0.i5m_1 = Math.max(1, b);
    var tmp_2 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = this.h5m_1;
    var destination_1 = ArrayList.z();
    var tmp0_iterator_2 = this_2.b1();
    while (tmp0_iterator_2.c1()) {
      var element_1 = tmp0_iterator_2.d1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      if (element_1.b5m_1) {
        destination_1.h(element_1);
      }
    }
    var sum_0 = 0;
    var tmp0_iterator_3 = destination_1.b1();
    while (tmp0_iterator_3.c1()) {
      var element_2 = tmp0_iterator_3.d1();
      var tmp_3 = sum_0;
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      sum_0 = tmp_3 + element_2.a() | 0;
    }
    var b_0 = sum_0;
    tmp_2.j5m_1 = Math.max(1, b_0);
  }
  toString() {
    return 'AxisInfo(ranges=' + toString_0(this.f5m_1) + ', totalLen=' + this.g5m_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.f5m_1);
    result = imul(result, 31) + this.g5m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AxisInfo ? other : THROW_CCE();
    if (!equals(this.f5m_1, tmp0_other_with_cast.f5m_1))
      return false;
    if (!(this.g5m_1 === tmp0_other_with_cast.g5m_1))
      return false;
    return true;
  }
}
class Segment {
  constructor(info, rect, x, y) {
    this.s5l_1 = new Mixin();
    this.t5l_1 = info;
    this.u5l_1 = rect;
    this.v5l_1 = x;
    this.w5l_1 = y;
    this.x5l_1 = this.v5l_1.b5m_1;
    this.y5l_1 = this.w5l_1.b5m_1;
    var tmp = this;
    var tmp20_safe_receiver = this.t5l_1.b5l_1;
    tmp.z5l_1 = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.b4t(this.u5l_1);
    var tmp_0 = this;
    tmp_0.a5m_1 = lazy(NinePatchInfo$Segment$bmp$delegate$lambda(this));
  }
  c28(_set____db54di) {
    this.s5l_1.c28(_set____db54di);
  }
  d28() {
    return this.s5l_1.d28();
  }
}
class NinePatchInfo {
  static k5m(xranges, yranges, width, height, content) {
    content = content === VOID ? null : content;
    var $this = createThis(this);
    $this.x5k_1 = xranges;
    $this.y5k_1 = yranges;
    $this.z5k_1 = width;
    $this.a5l_1 = height;
    $this.b5l_1 = content;
    $this.c5l_1 = new AxisInfo($this.x5k_1, $this.z5k_1);
    $this.d5l_1 = new AxisInfo($this.y5k_1, $this.a5l_1);
    $this.e5l_1 = $this.c5l_1.h5m_1;
    $this.f5l_1 = $this.d5l_1.h5m_1;
    $this.g5l_1 = $this.c5l_1.i5m_1;
    $this.h5l_1 = $this.d5l_1.i5m_1;
    $this.i5l_1 = $this.c5l_1.j5m_1;
    $this.j5l_1 = $this.d5l_1.j5m_1;
    var tmp = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.f5l_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = $this.e5l_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.b1();
      while (tmp0_iterator_0.c1()) {
        var item_0 = tmp0_iterator_0.d1();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Segment($this, Companion_instance_1.p3q(item_0.c5m_1.f2_1, item.c5m_1.f2_1, item_0.c5m_1.g2_1 + 1 | 0, item.c5m_1.g2_1 + 1 | 0), item_0, item);
        destination_0.h(tmp$ret$0);
      }
      var tmp$ret$3 = toFastList(destination_0);
      destination.h(tmp$ret$3);
    }
    tmp.k5l_1 = toFastList(destination);
    $this.l5l_1 = new Int32Array(64);
    $this.m5l_1 = new Int32Array(64);
    return $this;
  }
  static n5l(width, height, left, top, right, bottom, content) {
    content = content === VOID ? null : content;
    return this.k5m(listOf([to(false, until(0, left)), to(true, until(left, right)), to(false, until(right, width))]), listOf([to(false, until(0, top)), to(true, until(top, bottom)), to(false, until(bottom, height))]), width, height, content);
  }
  l5m() {
    return imul(this.e5l_1.g1(), this.f5l_1.g1());
  }
  m5m(bounds, new_0, callback) {
    var tmp;
    if (new_0) {
      this.o5m(bounds, callback);
      tmp = Unit_instance;
    } else {
      this.n5m(bounds, callback);
      tmp = Unit_instance;
    }
    return tmp;
  }
  p5m(bounds, new_0, callback, $super) {
    new_0 = new_0 === VOID ? true : new_0;
    var tmp;
    if ($super === VOID) {
      this.m5m(bounds, new_0, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5m.call(this, bounds, new_0, callback);
    }
    return tmp;
  }
  n5m(bounds, callback) {
    var ry = 0;
    var iterator = this.f5l_1.b1();
    var index = 0;
    while (iterator.c1()) {
      var yindex = index;
      index = index + 1 | 0;
      var y = iterator.d1();
      var segHeight = numberToInt(y.e5m(this.d5l_1, bounds.i3r_1));
      var rx = 0;
      var iterator_0 = this.e5l_1.b1();
      var index_0 = 0;
      while (iterator_0.c1()) {
        var xindex = index_0;
        index_0 = index_0 + 1 | 0;
        var x = iterator_0.d1();
        var segWidth = numberToInt(x.e5m(this.c5l_1, bounds.h3r_1));
        var seg = this.k5l_1.h1(yindex).h1(xindex);
        var segLeft = rx + bounds.i3j() | 0;
        var segTop = ry + bounds.d3q() | 0;
        callback(seg, segLeft, segTop, segWidth, segHeight);
        rx = rx + segWidth | 0;
      }
      ry = ry + segHeight | 0;
    }
  }
  o5m(bounds, callback) {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_0 = this.f5l_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
      var index = n;
      this_0.h1(n);
      this.m5l_1[index] = 2147483647;
      n = n + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_1 = this.e5l_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
      var index_0 = n_0;
      this_1.h1(n_0);
      this.l5l_1[index_0] = 2147483647;
      n_0 = n_0 + 1 | 0;
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_2 = this.f5l_1;
    var n_1 = 0;
    while (n_1 < this_2.g1()) {
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
      var yindex = n_1;
      var y = this_2.h1(n_1);
      var segHeight = y.e5m(this.d5l_1, bounds.i3r_1);
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
      var this_3 = this.e5l_1;
      var n_2 = 0;
      while (n_2 < this_3.g1()) {
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>.<anonymous>' call
        var xindex = n_2;
        var x = this_3.h1(n_2);
        var segWidth = x.e5m(this.c5l_1, bounds.h3r_1);
        if (x.d5m() && y.d5m()) {
          var xScale = segWidth / x.a();
          var yScale = segHeight / y.a();
          // Inline function 'kotlin.math.min' call
          var minScale = Math.min(xScale, yScale);
          // Inline function 'kotlin.math.min' call
          var a = this.l5l_1[xindex];
          var b = numberToInt(x.a() * minScale);
          var tmp$ret$1 = Math.min(a, b);
          this.l5l_1[xindex] = tmp$ret$1;
          // Inline function 'kotlin.math.min' call
          var a_0 = this.m5l_1[yindex];
          var b_0 = numberToInt(y.a() * minScale);
          var tmp$ret$2 = Math.min(a_0, b_0);
          this.m5l_1[yindex] = tmp$ret$2;
        } else {
          // Inline function 'kotlin.math.min' call
          var a_1 = this.l5l_1[xindex];
          var b_1 = numberToInt(segWidth);
          var tmp$ret$3 = Math.min(a_1, b_1);
          this.l5l_1[xindex] = tmp$ret$3;
          // Inline function 'kotlin.math.min' call
          var a_2 = this.m5l_1[yindex];
          var b_2 = numberToInt(segHeight);
          var tmp$ret$4 = Math.min(a_2, b_2);
          this.m5l_1[yindex] = tmp$ret$4;
        }
        n_2 = n_2 + 1 | 0;
      }
      n_1 = n_1 + 1 | 0;
    }
    var denormalizedWidth = sum(this.l5l_1);
    var denormalizedHeight = sum(this.m5l_1);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_4 = this.e5l_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_4, 10));
    var index_1 = 0;
    var tmp0_iterator = this_4.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
      var tmp1 = index_1;
      index_1 = tmp1 + 1 | 0;
      var index_2 = checkIndexOverflow(tmp1);
      var tmp$ret$5 = item.b5m_1 ? this.l5l_1[index_2] : 0;
      destination.h(tmp$ret$5);
    }
    var denormalizedScaledWidth = sum_0(destination);
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_5 = this.f5l_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var index_3 = 0;
    var tmp0_iterator_0 = this_5.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
      var tmp1_0 = index_3;
      index_3 = tmp1_0 + 1 | 0;
      var index_4 = checkIndexOverflow(tmp1_0);
      var tmp$ret$8 = item_0.b5m_1 ? this.m5l_1[index_4] : 0;
      destination_0.h(tmp$ret$8);
    }
    var denormalizedScaledHeight = sum_0(destination_0);
    var xScaledRatio = denormalizedWidth > 0 ? denormalizedScaledWidth / denormalizedWidth : 1.0;
    var yScaledRatio = denormalizedWidth > 0 ? denormalizedScaledHeight / denormalizedHeight : 1.0;
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var segments = n_3 === 0 ? this.f5l_1 : this.e5l_1;
        var computed = n_3 === 0 ? this.m5l_1 : this.l5l_1;
        var denormalizedScaledLen = n_3 === 0 ? denormalizedScaledHeight : denormalizedScaledWidth;
        var side = n_3 === 0 ? bounds.i3r_1 : bounds.h3r_1;
        var scaledRatio = n_3 === 0 ? yScaledRatio : xScaledRatio;
        var scaledSide = side * scaledRatio;
        // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
        var n_4 = 0;
        while (n_4 < segments.g1()) {
          // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
          var index_5 = n_4;
          if (segments.h1(n_4).b5m_1) {
            computed[index_5] = numberToInt(scaledSide * (computed[index_5] / denormalizedScaledLen));
          }
          n_4 = n_4 + 1 | 0;
        }
      }
       while (inductionVariable < 2);
    var xRemaining = bounds.h3r_1 - sum(this.l5l_1) | 0;
    var yRemaining = bounds.i3r_1 - sum(this.m5l_1) | 0;
    var tmp$ret$12;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index_6 = 0;
      var tmp0_iterator_1 = this.e5l_1.b1();
      while (tmp0_iterator_1.c1()) {
        var item_1 = tmp0_iterator_1.d1();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
        if (item_1.b5m_1) {
          tmp$ret$12 = index_6;
          break $l$block;
        }
        index_6 = index_6 + 1 | 0;
      }
      tmp$ret$12 = -1;
    }
    var xScaledFirst = tmp$ret$12;
    var tmp$ret$14;
    $l$block_0: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index_7 = 0;
      var tmp0_iterator_2 = this.f5l_1.b1();
      while (tmp0_iterator_2.c1()) {
        var item_2 = tmp0_iterator_2.d1();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.computeScaleNew.<anonymous>' call
        if (item_2.b5m_1) {
          tmp$ret$14 = index_7;
          break $l$block_0;
        }
        index_7 = index_7 + 1 | 0;
      }
      tmp$ret$14 = -1;
    }
    var yScaledFirst = tmp$ret$14;
    if (xRemaining > 0 && xScaledFirst >= 0) {
      var _array__4zh2yp = this.l5l_1;
      _array__4zh2yp[xScaledFirst] = _array__4zh2yp[xScaledFirst] + xRemaining | 0;
    }
    if (yRemaining > 0 && yScaledFirst >= 0) {
      var _array__4zh2yp_0 = this.m5l_1;
      _array__4zh2yp_0[yScaledFirst] = _array__4zh2yp_0[yScaledFirst] + yRemaining | 0;
    }
    var ry = 0;
    var inductionVariable_0 = 0;
    var last = this.f5l_1.g1() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var yindex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var segHeight_0 = this.m5l_1[yindex_0];
        var rx = 0;
        var inductionVariable_1 = 0;
        var last_0 = this.e5l_1.g1() - 1 | 0;
        if (inductionVariable_1 <= last_0)
          do {
            var xindex_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var segWidth_0 = this.l5l_1[xindex_0];
            var seg = this.k5l_1.h1(yindex_0).h1(xindex_0);
            var segLeft = rx + bounds.i3j() | 0;
            var segTop = ry + bounds.d3q() | 0;
            callback(seg, segLeft, segTop, segWidth_0, segHeight_0);
            rx = rx + segWidth_0 | 0;
          }
           while (inductionVariable_1 <= last_0);
        ry = ry + segHeight_0 | 0;
      }
       while (inductionVariable_0 <= last);
  }
  toString() {
    return 'NinePatchInfo(xranges=' + toString_0(this.x5k_1) + ', yranges=' + toString_0(this.y5k_1) + ', width=' + this.z5k_1 + ', height=' + this.a5l_1 + ', content=' + toString(this.b5l_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.x5k_1);
    result = imul(result, 31) + hashCode(this.y5k_1) | 0;
    result = imul(result, 31) + this.z5k_1 | 0;
    result = imul(result, 31) + this.a5l_1 | 0;
    result = imul(result, 31) + (this.b5l_1 == null ? 0 : this.b5l_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NinePatchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof NinePatchInfo ? other : THROW_CCE();
    if (!equals(this.x5k_1, tmp0_other_with_cast.x5k_1))
      return false;
    if (!equals(this.y5k_1, tmp0_other_with_cast.y5k_1))
      return false;
    if (!(this.z5k_1 === tmp0_other_with_cast.z5k_1))
      return false;
    if (!(this.a5l_1 === tmp0_other_with_cast.a5l_1))
      return false;
    if (!equals(this.b5l_1, tmp0_other_with_cast.b5l_1))
      return false;
    return true;
  }
}
class NullBitmap extends Bitmap {
  static r5n(width, height, premultiplied) {
    Companion_getInstance_21();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.i57(width, height, 32, premultiplied, null);
  }
  r57(x, y, v) {
    return Unit_instance;
  }
  p57(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_4 extends NullBitmap {
  static d5n() {
    Companion_instance_11 = null;
    var $this = this.r5n(1, 1);
    Companion_instance_11 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.s5n_1 = colors;
    this.t5n_1 = names;
    this.u5n_1 = changeStart;
    this.v5n_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.gc('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.s5n_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.s5n_1, n);
        var tmp22_safe_receiver = this.t5n_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.gc(', ');
        }
        if (!(name == null)) {
          this_0.gc(name);
          this_0.gc(': ');
        }
        this_0.gc(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.gc(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.g5o_1 = bmp;
    this.h5o_1 = buffer;
    this.i5o_1 = radius;
    this.j5o_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.g5o_1.toString() + ', buffer=' + this.h5o_1 + ', radius=' + this.i5o_1 + ', cutoff=' + this.j5o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.g5o_1);
    result = imul(result, 31) + this.h5o_1 | 0;
    result = imul(result, 31) + this.i5o_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.j5o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.g5o_1, tmp0_other_with_cast.g5o_1))
      return false;
    if (!(this.h5o_1 === tmp0_other_with_cast.h5o_1))
      return false;
    if (!(this.i5o_1 === tmp0_other_with_cast.i5o_1))
      return false;
    if (!equals(this.j5o_1, tmp0_other_with_cast.j5o_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.k5o_1 = 1.0E10;
  }
  l5o(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.k56(bmp.r56_1 + imul(buffer, 2) | 0, bmp.s56_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.r56_1;
    var height = out.s56_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.r56_1;
    var height_0 = out.s56_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.s56_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.r56_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.j5g(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.s3u(x0, y0, 1.0E10);
                gridInner.s3u(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.s3u(x0, y0, 0.0);
                gridInner.s3u(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.s3u(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.s3u(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.m5o(gridOuter.q3u_1, 0, 0, out.r56_1, out.s56_1, gridOuter.f3u(), f, v, z);
    this.m5o(gridInner.q3u_1, buffer, buffer, bmp.r56_1, bmp.s56_1, gridInner.f3u(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.s56_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.r56_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.z3k(x_0, y_0);
            var gin = gridInner.z3k(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.i5g(x_0, y_0, Companion_getInstance_24().f5o(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  n5o(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.r56_1;
      var b = bmp.s56_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.l5o(bmp, maxSide, buffer, radius, cutoff) : $super.l5o.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  m5o(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o5o(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.o5o(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  o5o(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.u5o_1 = 32;
  }
  p5o() {
    return this.u5o_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.v5o_1 = 24;
  }
  p5o() {
    return this.v5o_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.w5o_1 = _r;
    this.x5o_1 = _g;
    this.y5o_1 = _b;
    this.z5o_1 = _a;
    this.a5p_1 = true;
    this.b5p_1 = Colors_getInstance().y57_1;
  }
  c5p() {
    return this.w5o_1;
  }
  d5p() {
    return this.x5o_1;
  }
  e5p() {
    return this.y5o_1;
  }
  f5p(value) {
    this.z5o_1 = value;
    this.a5p_1 = true;
  }
  g5p() {
    return this.z5o_1;
  }
  h5p() {
    if (this.a5p_1) {
      this.a5p_1 = false;
      this.b5p_1 = Companion_getInstance_24().p5j(this.w5o_1, this.x5o_1, this.y5o_1, this.z5o_1);
    }
    return this.b5p_1;
  }
  i5p(r, g, b, a) {
    this.w5o_1 = r;
    this.x5o_1 = g;
    this.y5o_1 = b;
    this.z5o_1 = a;
    this.a5p_1 = true;
  }
  j5p(other) {
    return this.i5p(other.w5o_1, other.x5o_1, other.y5o_1, other.z5o_1);
  }
  k5p(a, b) {
    return this.i5p(a.c5p() * b.c5p(), a.d5p() * b.d5p(), a.e5p() * b.e5p(), a.g5p() * b.g5p());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.w5o_1 + ', _g=' + this.x5o_1 + ', _b=' + this.y5o_1 + ', _a=' + this.z5o_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.w5o_1);
    result = imul(result, 31) + getNumberHashCode(this.x5o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y5o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.w5o_1, tmp0_other_with_cast.w5o_1))
      return false;
    if (!equals(this.x5o_1, tmp0_other_with_cast.x5o_1))
      return false;
    if (!equals(this.y5o_1, tmp0_other_with_cast.y5o_1))
      return false;
    if (!equals(this.z5o_1, tmp0_other_with_cast.z5o_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.y57_1 = Companion_getInstance_24().f5o(255, 255, 255, 255);
    this.z57_1 = Companion_getInstance_24().f5o(0, 0, 0, 255);
    this.a58_1 = Companion_getInstance_24().f5o(255, 0, 0, 255);
    this.b58_1 = Companion_getInstance_24().f5o(0, 255, 0, 255);
    this.c58_1 = Companion_getInstance_24().f5o(0, 0, 255, 255);
    this.d58_1 = Companion_getInstance_24().f5o(0, 0, 0, 0);
    this.e58_1 = Companion_getInstance_24().f5o(255, 255, 255, 0);
    this.f58_1 = Companion_getInstance_24().l5p(240, 248, 255);
    this.g58_1 = Companion_getInstance_24().l5p(250, 235, 215);
    this.h58_1 = Companion_getInstance_24().l5p(0, 255, 255);
    this.i58_1 = Companion_getInstance_24().l5p(127, 255, 212);
    this.j58_1 = Companion_getInstance_24().l5p(240, 255, 255);
    this.k58_1 = Companion_getInstance_24().l5p(245, 245, 220);
    this.l58_1 = Companion_getInstance_24().l5p(255, 228, 196);
    this.m58_1 = Companion_getInstance_24().l5p(255, 235, 205);
    this.n58_1 = Companion_getInstance_24().l5p(138, 43, 226);
    this.o58_1 = Companion_getInstance_24().l5p(165, 42, 42);
    this.p58_1 = Companion_getInstance_24().l5p(222, 184, 135);
    this.q58_1 = Companion_getInstance_24().l5p(95, 158, 160);
    this.r58_1 = Companion_getInstance_24().l5p(127, 255, 0);
    this.s58_1 = Companion_getInstance_24().l5p(210, 105, 30);
    this.t58_1 = Companion_getInstance_24().l5p(255, 127, 80);
    this.u58_1 = Companion_getInstance_24().l5p(100, 149, 237);
    this.v58_1 = Companion_getInstance_24().l5p(255, 248, 220);
    this.w58_1 = Companion_getInstance_24().l5p(220, 20, 60);
    this.x58_1 = Companion_getInstance_24().l5p(0, 0, 139);
    this.y58_1 = Companion_getInstance_24().l5p(0, 255, 255);
    this.z58_1 = Companion_getInstance_24().l5p(0, 139, 139);
    this.a59_1 = Companion_getInstance_24().l5p(184, 134, 11);
    this.b59_1 = Companion_getInstance_24().l5p(169, 169, 169);
    this.c59_1 = Companion_getInstance_24().l5p(0, 100, 0);
    this.d59_1 = Companion_getInstance_24().l5p(169, 169, 169);
    this.e59_1 = Companion_getInstance_24().l5p(189, 183, 107);
    this.f59_1 = Companion_getInstance_24().l5p(255, 0, 255);
    this.g59_1 = Companion_getInstance_24().l5p(139, 0, 139);
    this.h59_1 = Companion_getInstance_24().l5p(85, 107, 47);
    this.i59_1 = Companion_getInstance_24().l5p(255, 140, 0);
    this.j59_1 = Companion_getInstance_24().l5p(153, 50, 204);
    this.k59_1 = Companion_getInstance_24().l5p(139, 0, 0);
    this.l59_1 = Companion_getInstance_24().l5p(233, 150, 122);
    this.m59_1 = Companion_getInstance_24().l5p(143, 188, 143);
    this.n59_1 = Companion_getInstance_24().l5p(72, 61, 139);
    this.o59_1 = Companion_getInstance_24().l5p(47, 79, 79);
    this.p59_1 = Companion_getInstance_24().l5p(47, 79, 79);
    this.q59_1 = Companion_getInstance_24().l5p(0, 206, 209);
    this.r59_1 = Companion_getInstance_24().l5p(148, 0, 211);
    this.s59_1 = Companion_getInstance_24().l5p(255, 20, 147);
    this.t59_1 = Companion_getInstance_24().l5p(0, 191, 255);
    this.u59_1 = Companion_getInstance_24().l5p(105, 105, 105);
    this.v59_1 = Companion_getInstance_24().l5p(105, 105, 105);
    this.w59_1 = Companion_getInstance_24().l5p(30, 144, 255);
    this.x59_1 = Companion_getInstance_24().l5p(178, 34, 34);
    this.y59_1 = Companion_getInstance_24().l5p(255, 250, 240);
    this.z59_1 = Companion_getInstance_24().l5p(34, 139, 34);
    this.a5a_1 = Companion_getInstance_24().l5p(255, 0, 255);
    this.b5a_1 = Companion_getInstance_24().l5p(220, 220, 220);
    this.c5a_1 = Companion_getInstance_24().l5p(248, 248, 255);
    this.d5a_1 = Companion_getInstance_24().l5p(255, 215, 0);
    this.e5a_1 = Companion_getInstance_24().l5p(218, 165, 32);
    this.f5a_1 = Companion_getInstance_24().l5p(173, 255, 47);
    this.g5a_1 = Companion_getInstance_24().l5p(240, 255, 240);
    this.h5a_1 = Companion_getInstance_24().l5p(255, 105, 180);
    this.i5a_1 = Companion_getInstance_24().l5p(205, 92, 92);
    this.j5a_1 = Companion_getInstance_24().l5p(75, 0, 130);
    this.k5a_1 = Companion_getInstance_24().l5p(255, 255, 240);
    this.l5a_1 = Companion_getInstance_24().l5p(240, 230, 140);
    this.m5a_1 = Companion_getInstance_24().l5p(230, 230, 250);
    this.n5a_1 = Companion_getInstance_24().l5p(255, 240, 245);
    this.o5a_1 = Companion_getInstance_24().l5p(124, 252, 0);
    this.p5a_1 = Companion_getInstance_24().l5p(255, 250, 205);
    this.q5a_1 = Companion_getInstance_24().l5p(173, 216, 230);
    this.r5a_1 = Companion_getInstance_24().l5p(240, 128, 128);
    this.s5a_1 = Companion_getInstance_24().l5p(224, 255, 255);
    this.t5a_1 = Companion_getInstance_24().l5p(250, 250, 210);
    this.u5a_1 = Companion_getInstance_24().l5p(211, 211, 211);
    this.v5a_1 = Companion_getInstance_24().l5p(144, 238, 144);
    this.w5a_1 = Companion_getInstance_24().l5p(211, 211, 211);
    this.x5a_1 = Companion_getInstance_24().l5p(255, 182, 193);
    this.y5a_1 = Companion_getInstance_24().l5p(255, 160, 122);
    this.z5a_1 = Companion_getInstance_24().l5p(32, 178, 170);
    this.a5b_1 = Companion_getInstance_24().l5p(135, 206, 250);
    this.b5b_1 = Companion_getInstance_24().l5p(119, 136, 153);
    this.c5b_1 = Companion_getInstance_24().l5p(119, 136, 153);
    this.d5b_1 = Companion_getInstance_24().l5p(176, 196, 222);
    this.e5b_1 = Companion_getInstance_24().l5p(255, 255, 224);
    this.f5b_1 = Companion_getInstance_24().l5p(0, 255, 0);
    this.g5b_1 = Companion_getInstance_24().l5p(50, 205, 50);
    this.h5b_1 = Companion_getInstance_24().l5p(250, 240, 230);
    this.i5b_1 = Companion_getInstance_24().l5p(128, 0, 0);
    this.j5b_1 = Companion_getInstance_24().l5p(102, 205, 170);
    this.k5b_1 = Companion_getInstance_24().l5p(0, 0, 205);
    this.l5b_1 = Companion_getInstance_24().l5p(186, 85, 211);
    this.m5b_1 = Companion_getInstance_24().l5p(147, 112, 219);
    this.n5b_1 = Companion_getInstance_24().l5p(60, 179, 113);
    this.o5b_1 = Companion_getInstance_24().l5p(123, 104, 238);
    this.p5b_1 = Companion_getInstance_24().l5p(0, 250, 154);
    this.q5b_1 = Companion_getInstance_24().l5p(72, 209, 204);
    this.r5b_1 = Companion_getInstance_24().l5p(199, 21, 133);
    this.s5b_1 = Companion_getInstance_24().l5p(25, 25, 112);
    this.t5b_1 = Companion_getInstance_24().l5p(245, 255, 250);
    this.u5b_1 = Companion_getInstance_24().l5p(255, 228, 225);
    this.v5b_1 = Companion_getInstance_24().l5p(255, 228, 181);
    this.w5b_1 = Companion_getInstance_24().l5p(255, 222, 173);
    this.x5b_1 = Companion_getInstance_24().l5p(0, 0, 128);
    this.y5b_1 = Companion_getInstance_24().l5p(253, 245, 230);
    this.z5b_1 = Companion_getInstance_24().l5p(128, 128, 0);
    this.a5c_1 = Companion_getInstance_24().l5p(107, 142, 35);
    this.b5c_1 = Companion_getInstance_24().l5p(255, 165, 0);
    this.c5c_1 = Companion_getInstance_24().l5p(255, 69, 0);
    this.d5c_1 = Companion_getInstance_24().l5p(218, 112, 214);
    this.e5c_1 = Companion_getInstance_24().l5p(238, 232, 170);
    this.f5c_1 = Companion_getInstance_24().l5p(152, 251, 152);
    this.g5c_1 = Companion_getInstance_24().l5p(175, 238, 238);
    this.h5c_1 = Companion_getInstance_24().l5p(219, 112, 147);
    this.i5c_1 = Companion_getInstance_24().l5p(255, 239, 213);
    this.j5c_1 = Companion_getInstance_24().l5p(255, 218, 185);
    this.k5c_1 = Companion_getInstance_24().l5p(205, 133, 63);
    this.l5c_1 = Companion_getInstance_24().l5p(255, 192, 203);
    this.m5c_1 = Companion_getInstance_24().l5p(221, 160, 221);
    this.n5c_1 = Companion_getInstance_24().l5p(176, 224, 230);
    this.o5c_1 = Companion_getInstance_24().l5p(128, 0, 128);
    this.p5c_1 = Companion_getInstance_24().l5p(188, 143, 143);
    this.q5c_1 = Companion_getInstance_24().l5p(65, 105, 225);
    this.r5c_1 = Companion_getInstance_24().l5p(139, 69, 19);
    this.s5c_1 = Companion_getInstance_24().l5p(250, 128, 114);
    this.t5c_1 = Companion_getInstance_24().l5p(244, 164, 96);
    this.u5c_1 = Companion_getInstance_24().l5p(46, 139, 87);
    this.v5c_1 = Companion_getInstance_24().l5p(255, 245, 238);
    this.w5c_1 = Companion_getInstance_24().l5p(160, 82, 45);
    this.x5c_1 = Companion_getInstance_24().l5p(192, 192, 192);
    this.y5c_1 = Companion_getInstance_24().l5p(135, 206, 235);
    this.z5c_1 = Companion_getInstance_24().l5p(106, 90, 205);
    this.a5d_1 = Companion_getInstance_24().l5p(112, 128, 144);
    this.b5d_1 = Companion_getInstance_24().l5p(112, 128, 144);
    this.c5d_1 = Companion_getInstance_24().l5p(255, 250, 250);
    this.d5d_1 = Companion_getInstance_24().l5p(0, 255, 127);
    this.e5d_1 = Companion_getInstance_24().l5p(70, 130, 180);
    this.f5d_1 = Companion_getInstance_24().l5p(210, 180, 140);
    this.g5d_1 = Companion_getInstance_24().l5p(0, 128, 128);
    this.h5d_1 = Companion_getInstance_24().l5p(216, 191, 216);
    this.i5d_1 = Companion_getInstance_24().l5p(255, 99, 71);
    this.j5d_1 = Companion_getInstance_24().l5p(64, 224, 208);
    this.k5d_1 = Companion_getInstance_24().l5p(238, 130, 238);
    this.l5d_1 = Companion_getInstance_24().l5p(245, 222, 179);
    this.m5d_1 = Companion_getInstance_24().l5p(245, 245, 245);
    this.n5d_1 = Companion_getInstance_24().l5p(154, 205, 50);
    this.o5d_1 = Companion_getInstance_24().l5p(255, 255, 0);
    this.p5d_1 = mapOf([to('black', new RGBA(this.z57_1)), to('white', new RGBA(this.y57_1)), to('red', new RGBA(this.a58_1)), to('green', new RGBA(this.b58_1)), to('blue', new RGBA(this.c58_1)), to('aliceblue', new RGBA(this.f58_1)), to('antiquewhite', new RGBA(this.g58_1)), to('aqua', new RGBA(this.h58_1)), to('aquamarine', new RGBA(this.i58_1)), to('azure', new RGBA(this.j58_1)), to('beige', new RGBA(this.k58_1)), to('bisque', new RGBA(this.l58_1)), to('blanchedalmond', new RGBA(this.m58_1)), to('blueviolet', new RGBA(this.n58_1)), to('brown', new RGBA(this.o58_1)), to('burlywood', new RGBA(this.p58_1)), to('cadetblue', new RGBA(this.q58_1)), to('chartreuse', new RGBA(this.r58_1)), to('chocolate', new RGBA(this.s58_1)), to('coral', new RGBA(this.t58_1)), to('cornflowerblue', new RGBA(this.u58_1)), to('cornsilk', new RGBA(this.v58_1)), to('crimson', new RGBA(this.w58_1)), to('cyan', new RGBA(this.y58_1)), to('darkblue', new RGBA(this.x58_1)), to('darkcyan', new RGBA(this.z58_1)), to('darkgoldenrod', new RGBA(this.a59_1)), to('darkgray', new RGBA(this.b59_1)), to('darkgreen', new RGBA(this.c59_1)), to('darkgrey', new RGBA(this.d59_1)), to('darkkhaki', new RGBA(this.e59_1)), to('darkmagenta', new RGBA(this.g59_1)), to('darkolivegreen', new RGBA(this.h59_1)), to('darkorange', new RGBA(this.i59_1)), to('darkorchid', new RGBA(this.j59_1)), to('darkred', new RGBA(this.k59_1)), to('darksalmon', new RGBA(this.l59_1)), to('darkseagreen', new RGBA(this.m59_1)), to('darkslateblue', new RGBA(this.n59_1)), to('darkslategray', new RGBA(this.o59_1)), to('darkslategrey', new RGBA(this.p59_1)), to('darkturquoise', new RGBA(this.q59_1)), to('darkviolet', new RGBA(this.r59_1)), to('deeppink', new RGBA(this.s59_1)), to('deepskyblue', new RGBA(this.t59_1)), to('dimgray', new RGBA(this.u59_1)), to('dimgrey', new RGBA(this.v59_1)), to('dodgerblue', new RGBA(this.w59_1)), to('firebrick', new RGBA(this.x59_1)), to('floralwhite', new RGBA(this.y59_1)), to('forestgreen', new RGBA(this.z59_1)), to('fuchsia', new RGBA(this.a5a_1)), to('gainsboro', new RGBA(this.b5a_1)), to('ghostwhite', new RGBA(this.c5a_1)), to('gold', new RGBA(this.d5a_1)), to('goldenrod', new RGBA(this.e5a_1)), to('greenyellow', new RGBA(this.f5a_1)), to('honeydew', new RGBA(this.g5a_1)), to('hotpink', new RGBA(this.h5a_1)), to('indianred', new RGBA(this.i5a_1)), to('indigo', new RGBA(this.j5a_1)), to('ivory', new RGBA(this.k5a_1)), to('khaki', new RGBA(this.l5a_1)), to('lavender', new RGBA(this.m5a_1)), to('lavenderblush', new RGBA(this.n5a_1)), to('lawngreen', new RGBA(this.o5a_1)), to('lemonchiffon', new RGBA(this.p5a_1)), to('lightblue', new RGBA(this.q5a_1)), to('lightcoral', new RGBA(this.r5a_1)), to('lightcyan', new RGBA(this.s5a_1)), to('lightgoldenrodyellow', new RGBA(this.t5a_1)), to('lightgray', new RGBA(this.u5a_1)), to('lightgreen', new RGBA(this.v5a_1)), to('lightgrey', new RGBA(this.w5a_1)), to('lightpink', new RGBA(this.x5a_1)), to('lightsalmon', new RGBA(this.y5a_1)), to('lightseagreen', new RGBA(this.z5a_1)), to('lightskyblue', new RGBA(this.a5b_1)), to('lightslategray', new RGBA(this.b5b_1)), to('lightslategrey', new RGBA(this.c5b_1)), to('lightsteelblue', new RGBA(this.d5b_1)), to('lightyellow', new RGBA(this.e5b_1)), to('lime', new RGBA(this.f5b_1)), to('limegreen', new RGBA(this.g5b_1)), to('linen', new RGBA(this.h5b_1)), to('magenta', new RGBA(this.f59_1)), to('maroon', new RGBA(this.i5b_1)), to('mediumaquamarine', new RGBA(this.j5b_1)), to('mediumblue', new RGBA(this.k5b_1)), to('mediumorchid', new RGBA(this.l5b_1)), to('mediumpurple', new RGBA(this.m5b_1)), to('mediumseagreen', new RGBA(this.n5b_1)), to('mediumslateblue', new RGBA(this.o5b_1)), to('mediumspringgreen', new RGBA(this.p5b_1)), to('mediumturquoise', new RGBA(this.q5b_1)), to('mediumvioletred', new RGBA(this.r5b_1)), to('midnightblue', new RGBA(this.s5b_1)), to('mintcream', new RGBA(this.t5b_1)), to('mistyrose', new RGBA(this.u5b_1)), to('moccasin', new RGBA(this.v5b_1)), to('navajowhite', new RGBA(this.w5b_1)), to('navy', new RGBA(this.x5b_1)), to('oldlace', new RGBA(this.y5b_1)), to('olive', new RGBA(this.z5b_1)), to('olivedrab', new RGBA(this.a5c_1)), to('orange', new RGBA(this.b5c_1)), to('orangered', new RGBA(this.c5c_1)), to('orchid', new RGBA(this.d5c_1)), to('palegoldenrod', new RGBA(this.e5c_1)), to('palegreen', new RGBA(this.f5c_1)), to('paleturquoise', new RGBA(this.g5c_1)), to('palevioletred', new RGBA(this.h5c_1)), to('papayawhip', new RGBA(this.i5c_1)), to('peachpuff', new RGBA(this.j5c_1)), to('peru', new RGBA(this.k5c_1)), to('pink', new RGBA(this.l5c_1)), to('plum', new RGBA(this.m5c_1)), to('powderblue', new RGBA(this.n5c_1)), to('purple', new RGBA(this.o5c_1)), to('rosybrown', new RGBA(this.p5c_1)), to('royalblue', new RGBA(this.q5c_1)), to('saddlebrown', new RGBA(this.r5c_1)), to('salmon', new RGBA(this.s5c_1)), to('sandybrown', new RGBA(this.t5c_1)), to('seagreen', new RGBA(this.u5c_1)), to('seashell', new RGBA(this.v5c_1)), to('sienna', new RGBA(this.w5c_1)), to('silver', new RGBA(this.x5c_1)), to('skyblue', new RGBA(this.y5c_1)), to('slateblue', new RGBA(this.z5c_1)), to('slategray', new RGBA(this.a5d_1)), to('slategrey', new RGBA(this.b5d_1)), to('snow', new RGBA(this.c5d_1)), to('springgreen', new RGBA(this.d5d_1)), to('steelblue', new RGBA(this.e5d_1)), to('tan', new RGBA(this.f5d_1)), to('teal', new RGBA(this.g5d_1)), to('thistle', new RGBA(this.h5d_1)), to('tomato', new RGBA(this.i5d_1)), to('turquoise', new RGBA(this.j5d_1)), to('violet', new RGBA(this.k5d_1)), to('wheat', new RGBA(this.l5d_1)), to('whitesmoke', new RGBA(this.m5d_1)), to('yellowgreen', new RGBA(this.n5d_1)), to('yellow', new RGBA(this.o5d_1))]);
  }
  m5p(str) {
    return this.n5p(str, this.d58_1, true);
  }
  n5p(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).z2(hex.length))
          return this.z57_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_24().f5o(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.g1() : false) {
          tmp = parts.h1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.g1() : false) {
          tmp_0 = parts.h1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.g1() : false) {
          tmp_1 = parts.h1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.g1() : false) {
          tmp_2 = parts.h1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_24().f5o(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.p5d_1.e3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.o5p_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.p5p('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().a58_1;
      } else {
        throw $p;
      }
    }
  }
  p5p(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.n5p(str, default_0, errorOnDefault) : $super.n5p.call(this, str, new RGBA(default_0), errorOnDefault).o5p_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_22();
    super();
    this.r5p_1 = rOffset;
    this.s5p_1 = gOffset;
    this.t5p_1 = bOffset;
  }
  q5o(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.r5p_1 | 0) & 255;
  }
  r5o(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.s5p_1 | 0) & 255;
  }
  s5o(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.t5p_1 | 0) & 255;
  }
  t5o(v) {
    return 255;
  }
}
class Companion_5 extends RGB {
  constructor() {
    Companion_instance_12 = null;
    super(0, 8, 16);
    Companion_instance_12 = this;
  }
}
class Companion_6 {
  c5i(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.u5p_1 = ints;
  }
  q1(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.u5p_1, fromIndex, toIndex);
  }
  v5p(element) {
    return RgbaArray__contains_impl_ofn00n(this.u5p_1, element);
  }
  z2(element) {
    return RgbaArray__contains_impl_ofn00n_0(this, element);
  }
  w5p(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.u5p_1, elements);
  }
  a3(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  j1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.u5p_1);
  }
  b1() {
    return RgbaArray__iterator_impl_5wfwsm(this.u5p_1);
  }
  b3() {
    return RgbaArray__listIterator_impl_m4kjt0(this.u5p_1);
  }
  k1(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.u5p_1, index);
  }
  g1() {
    return _RgbaArray___get_size__impl__imxef8(this.u5p_1);
  }
  x5p(index) {
    return RgbaArray__get_impl_nzyo1o(this.u5p_1, index);
  }
  h1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.u5p_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.u5p_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.u5p_1, other);
  }
}
class Companion_7 extends ColorFormat32 {
  constructor() {
    Companion_instance_14 = null;
    super();
    Companion_instance_14 = this;
    this.r5d_1 = 0;
    this.s5d_1 = 8;
    this.t5d_1 = 16;
    this.u5d_1 = 24;
  }
  p5j(r, g, b, a) {
    return this.z5p(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  z5p(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  f5o(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  l5p(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  a5q(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  q5o(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  r5o(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  s5o(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  t5o(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  b5q(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.c5q(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  c5q(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  d5q(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.b5q(c1, c2, tmp$ret$0);
  }
  e5q(c1, c2, factor) {
    return Companion_getInstance_24().a5q(_RGBA___get_rgb__impl__tijaqt(this.d5q(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  v5d(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.e5q(c00, c10, factorX);
    var c2 = this.e5q(c01, c11, factorX);
    return this.e5q(c1, c2, factorY);
  }
  e5o(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_24().a5q(_RGBA___get_rgb__impl__tijaqt(this.b5q(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  y5p(c1, c2) {
    return Companion_getInstance_24().f5o(imul(_RGBA___get_r__impl__duz7mo(c1), _RGBA___get_r__impl__duz7mo(c2)) / 255 | 0, imul(_RGBA___get_g__impl__o8pukr(c1), _RGBA___get_g__impl__o8pukr(c2)) / 255 | 0, imul(_RGBA___get_b__impl__m6tl80(c1), _RGBA___get_b__impl__m6tl80(c2)) / 255 | 0, imul(_RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2)) / 255 | 0);
  }
  f5q(src, dst, ratio) {
    return Companion_getInstance_24().f5o(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_24();
    this.o5p_1 = value;
  }
  z27() {
    return RGBA__clone_impl_w007z0(this.o5p_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.o5p_1);
  }
  g5q(other) {
    return RGBA__compareTo_impl_lrfjc1(this.o5p_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.o5p_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.o5p_1, other);
  }
}
class Companion_8 {
  constructor() {
    this.h5q_1 = 16711935;
    this.i5q_1 = -16711936;
  }
  j5q(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_9 {
  k5q(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.l5q_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.l5q_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.l5q_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.l5q_1, other);
  }
}
class Companion_10 {
  m5q(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_11 {}
class Kerning {
  constructor(first, second, amount) {
    this.v5q_1 = first;
    this.w5q_1 = second;
    this.x5q_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.n5q_1 = fontSize;
    this.o5q_1 = id;
    this.p5q_1 = texture;
    this.q5q_1 = xoffset;
    this.r5q_1 = yoffset;
    this.s5q_1 = xadvance;
    var tmp = this;
    tmp.t5q_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.u5q_1 = new GlyphMetrics(this.n5q_1, true, -1, Companion_getInstance_4().k3q(this.q5q_1, this.r5q_1, this.p5q_1.r4r_1, this.p5q_1.s4r_1), this.s5q_1);
  }
  y5q() {
    return this.p5q_1.r4r_1;
  }
  z5q() {
    return this.p5q_1.s4r_1;
  }
  a5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5q_1;
    bmp$factory();
    return this_0.w1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.n5q_1 + ', id=' + this.o5q_1 + ', texture=' + this.p5q_1.toString() + ', xoffset=' + this.q5q_1 + ', yoffset=' + this.r5q_1 + ', xadvance=' + this.s5q_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.n5q_1);
    result = imul(result, 31) + this.o5q_1 | 0;
    result = imul(result, 31) + this.p5q_1.hashCode() | 0;
    result = imul(result, 31) + this.q5q_1 | 0;
    result = imul(result, 31) + this.r5q_1 | 0;
    result = imul(result, 31) + this.s5q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.n5q_1, tmp0_other_with_cast.n5q_1))
      return false;
    if (!(this.o5q_1 === tmp0_other_with_cast.o5q_1))
      return false;
    if (!this.p5q_1.equals(tmp0_other_with_cast.p5q_1))
      return false;
    if (!(this.q5q_1 === tmp0_other_with_cast.q5q_1))
      return false;
    if (!(this.r5q_1 === tmp0_other_with_cast.r5q_1))
      return false;
    if (!(this.s5q_1 === tmp0_other_with_cast.s5q_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_1() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.i5r(size, metrics) : $super.i5r.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.u5r(size, codePoint, metrics, reader) : $super.u5r.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.g5s(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.g5s.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function getFontMetrics(size, metrics) {
  return metrics.s5r(this.g5r(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.i1s(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.u5q_1;
  return metrics.a5s(tmp0_elvis_lhs == null ? this.h5r() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.b5r();
}
function get_1(charCode) {
  var tmp0_elvis_lhs = this.i1s(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.i1s(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.f5r() : tmp1_elvis_lhs;
}
function get_2(char) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(char);
  return this.h1(tmp$ret$0);
}
function getGlyph(char) {
  return this.e5s(char);
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.d5s(size);
  var tmp0_elvis_lhs = this.d5r().h1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.u5r(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.w5r_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.f3u() === 0.0 && metrics.g3u() === 0.0)
    return false;
  var texX = pos.r3i_1 + metrics.i3j();
  var texY = pos.s3i_1 + metrics.d3q();
  var swidth = metrics.f3u();
  var sheight = metrics.g3u();
  var tmp_1;
  if (equals(ctx.d5t(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.a5r();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.k56(g.a5r().r56_1, g.a5r().s56_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.v56_1;
    if (true) {
      this_1.e57();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.n5e(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.s5e_1.h5s_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.c5t(1.0 / scale);
          ctx_0.e5t(ctx.d5t());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.f3u() * scale;
          var height = ctx_0.g3u() * scale;
          ctx_0.f5t(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.s5e_1.h5s_1 = t;
        }
      }finally {
        ctx_0.k2i();
      }
    }finally {
      result = true ? this_1.g57(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.w5g(BitmapChannel_ALPHA_getInstance(), g.a5r(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.g5t(bmp, Vector2D.y3k(texX, texY - metrics.c3q()), Size2D.r3q(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.d5s(size);
  var tmp40_safe_receiver = this.c5s(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.x5q_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.j5t_1 = new Mixin();
    this.k5t_1 = fontSize;
    this.l5t_1 = lineHeight;
    this.m5t_1 = base;
    this.n5t_1 = glyphs;
    this.o5t_1 = kernings;
    this.p5t_1 = name;
    this.q5t_1 = distanceField;
    this.r5t_1 = this.l5t_1 - this.m5t_1;
    var tmp = this;
    tmp.s5t_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.t5t_1 = new GlyphMetrics(this.k5t_1, false, 0, Companion_getInstance_4().c3m(), 0.0);
    var tmp_0 = this;
    tmp_0.u5t_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.v5t_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  c28(_set____db54di) {
    this.j5t_1.c28(_set____db54di);
  }
  d28() {
    return this.j5t_1.d28();
  }
  b5r() {
    return this.k5t_1;
  }
  r4s() {
    return this.m5t_1;
  }
  d5r() {
    return this.n5t_1;
  }
  e5r() {
    return this.o5t_1;
  }
  q3() {
    return this.p5t_1;
  }
  c5r() {
    return this.q5t_1;
  }
  f29() {
    return this;
  }
  g5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s5t_1;
    naturalFontMetrics$factory();
    return this_0.w1();
  }
  h5r() {
    return this.t5t_1;
  }
  c5s(first, second) {
    return this.o5t_1.h1(Companion_instance_17.m5q(first, second));
  }
  i1s(codePoint) {
    return this.n5t_1.h1(codePoint);
  }
  f5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5t_1;
    anyGlyph$factory();
    return this_0.w1();
  }
  w5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5t_1;
    invalidGlyph$factory();
    return this_0.w1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.m5w_1 = bmp;
    this.n5w_1 = fmetrics;
    this.o5w_1 = metrics;
    this.p5w_1 = glyphs;
    this.q5w_1 = glyphsPerLine;
    this.r5w_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.m5w_1) + ', fmetrics=' + this.n5w_1.toString() + ', metrics=' + this.o5w_1.toString() + ', glyphs=' + toString_0(this.p5w_1) + ', glyphsPerLine=' + toString_0(this.q5w_1) + ', shape=' + toString(this.r5w_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.m5w_1);
    result = imul(result, 31) + this.n5w_1.hashCode() | 0;
    result = imul(result, 31) + this.o5w_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p5w_1) | 0;
    result = imul(result, 31) + hashCode(this.q5w_1) | 0;
    result = imul(result, 31) + (this.r5w_1 == null ? 0 : hashCode(this.r5w_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.m5w_1, tmp0_other_with_cast.m5w_1))
      return false;
    if (!this.n5w_1.equals(tmp0_other_with_cast.n5w_1))
      return false;
    if (!this.o5w_1.equals(tmp0_other_with_cast.o5w_1))
      return false;
    if (!equals(this.p5w_1, tmp0_other_with_cast.p5w_1))
      return false;
    if (!equals(this.q5w_1, tmp0_other_with_cast.q5w_1))
      return false;
    if (!equals(this.r5w_1, tmp0_other_with_cast.r5w_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.d5x_1 = codePoint;
    this.e5x_1 = pos;
    this.f5x_1 = metrics;
    this.g5x_1 = fontMetrics;
    this.h5x_1 = transform;
    this.i5x_1 = index;
    this.j5x_1 = nline;
    var tmp = this;
    tmp.k5x_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.l5x_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.m5x_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.n5x_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  p5x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k5x_1;
    boundsPath$factory();
    return this_0.w1();
  }
  q5x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l5x_1;
    boundsPathCurves$factory();
    return this_0.w1();
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.d5x_1 + ', pos=' + this.e5x_1.toString() + ', metrics=' + this.f5x_1.toString() + ', fontMetrics=' + this.g5x_1.toString() + ', transform=' + this.h5x_1.toString() + ', index=' + this.i5x_1 + ', nline=' + this.j5x_1 + ')';
  }
  hashCode() {
    var result = this.d5x_1;
    result = imul(result, 31) + this.e5x_1.hashCode() | 0;
    result = imul(result, 31) + this.f5x_1.hashCode() | 0;
    result = imul(result, 31) + this.g5x_1.hashCode() | 0;
    result = imul(result, 31) + this.h5x_1.hashCode() | 0;
    result = imul(result, 31) + this.i5x_1 | 0;
    result = imul(result, 31) + this.j5x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.d5x_1 === tmp0_other_with_cast.d5x_1))
      return false;
    if (!this.e5x_1.equals(tmp0_other_with_cast.e5x_1))
      return false;
    if (!this.f5x_1.equals(tmp0_other_with_cast.f5x_1))
      return false;
    if (!this.g5x_1.equals(tmp0_other_with_cast.g5x_1))
      return false;
    if (!this.h5x_1.equals(tmp0_other_with_cast.h5x_1))
      return false;
    if (!(this.i5x_1 === tmp0_other_with_cast.i5x_1))
      return false;
    if (!(this.j5x_1 === tmp0_other_with_cast.j5x_1))
      return false;
    return true;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.k3l(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.f3s(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().c3m() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.w5z_1 = path;
    this.x5z_1 = colorShape;
    this.y5z_1 = bitmap;
    this.z5z_1 = bitmapOffset;
    this.a60_1 = bitmapScale;
    this.b60_1 = transform;
    this.c60_1 = scale;
  }
  d60() {
    return this.y5z_1 == null && this.x5z_1 == null;
  }
  e60(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.s5e_1.h5s_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.f60(this.b60_1);
      if (!(this.y5z_1 == null)) {
        c.g5t(ensureNotNull(this.y5z_1), this.z5z_1, toFloat(ensureNotNull(this.y5z_1).g1()).t3s(this.a60_1));
      } else if (!(this.x5z_1 == null)) {
        c.g60(ensureNotNull(this.x5z_1));
        c.h60();
      } else {
        draw_1(c, this.w5z_1);
      }
    }finally {
      c.s5e_1.h5s_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.w5z_1.toString() + ', colorShape=' + toString(this.x5z_1) + ', bitmap=' + toString(this.y5z_1) + ', bitmapOffset=' + this.z5z_1.toString() + ', bitmapScale=' + this.a60_1.toString() + ', transform=' + this.b60_1.toString() + ', scale=' + this.c60_1 + ')';
  }
  hashCode() {
    var result = this.w5z_1.hashCode();
    result = imul(result, 31) + (this.x5z_1 == null ? 0 : hashCode(this.x5z_1)) | 0;
    result = imul(result, 31) + (this.y5z_1 == null ? 0 : hashCode(this.y5z_1)) | 0;
    result = imul(result, 31) + this.z5z_1.hashCode() | 0;
    result = imul(result, 31) + this.a60_1.hashCode() | 0;
    result = imul(result, 31) + this.b60_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.c60_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.w5z_1.equals(tmp0_other_with_cast.w5z_1))
      return false;
    if (!equals(this.x5z_1, tmp0_other_with_cast.x5z_1))
      return false;
    if (!equals(this.y5z_1, tmp0_other_with_cast.y5z_1))
      return false;
    if (!this.z5z_1.equals(tmp0_other_with_cast.z5z_1))
      return false;
    if (!this.a60_1.equals(tmp0_other_with_cast.a60_1))
      return false;
    if (!this.b60_1.equals(tmp0_other_with_cast.b60_1))
      return false;
    if (!equals(this.c60_1, tmp0_other_with_cast.c60_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.i60_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_29();
    distanceField = distanceField === VOID ? null : distanceField;
    this.j60_1 = new Mixin();
    this.k60_1 = font;
    this.l60_1 = fontSize;
    this.m60_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.n56(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.m60_1 == null))
      this_0.p55_1;
    else
      mipmaps(this_0.p55_1);
    tmp.n60_1 = this_0;
    this.o60_1 = this.k60_1.t5r(this.l60_1);
    this.p60_1 = this.o60_1.o5x();
    this.q60_1 = this.o60_1.m5r_1;
    this.r60_1 = IntMap.a41();
    this.s60_1 = IntMap.a41();
    var tmp_0 = this;
    tmp_0.t60_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.u60_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.v60_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.w60_1 = new GlyphMetrics(this.l60_1, false, 0, Companion_getInstance_4().c3m(), 0.0);
  }
  c28(_set____db54di) {
    this.j60_1.c28(_set____db54di);
  }
  d28() {
    return this.j60_1.d28();
  }
  b5r() {
    return this.l60_1;
  }
  c5r() {
    return this.m60_1;
  }
  r4s() {
    return this.q60_1;
  }
  d5r() {
    return this.r60_1;
  }
  e5r() {
    return this.s60_1;
  }
  f5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t60_1;
    anyGlyph$factory_0();
    return this_0.w1();
  }
  w5t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u60_1;
    invalidGlyph$factory_0();
    return this_0.w1();
  }
  q3() {
    return this.k60_1.q3();
  }
  g5r() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v60_1;
    naturalFontMetrics$factory_0();
    return this_0.w1();
  }
  h5r() {
    return this.w60_1;
  }
  c5s(first, second) {
    var kerning = this.k60_1.i5t(this.l60_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.s60_1;
      var key = Companion_instance_17.m5q(first, second);
      var res = this_0.h1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.u40(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.h1(key));
    }
    return tmp;
  }
  i1s(codePoint) {
    if (this.r60_1.h1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.x60(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.x60(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.x60(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.y60(tmp$ret$6);
    }
    return this.r60_1.h1(codePoint);
  }
  x60(codePoint, range) {
    var containsLower = range.f2_1;
    if (codePoint <= range.g2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.l3w(coerceAtLeast(range.p1() - range.o1() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.o1();
      var last = range.p1();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.r3w(v);
        }
         while (!(v === last));
      this.y60(this_0.c3x());
    }
  }
  y60(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.n60_1.p55_1;
    var rect = this_0.v56_1;
    if (true) {
      this_0.e57();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.r60_1;
        var res = this_1.h1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.m60_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.l60_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.k60_1;
          var tmp84_size = this.l60_1;
          var tmp85_paint = Colors_getInstance().y57_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.m5w_1.d57();
          var rbmp;
          switch (this.m60_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.r5w_1).z60(), bmp.r56_1, bmp.s56_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.r5w_1).z60(), bmp.r56_1, bmp.s56_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.n60_1.p56(rbmp, Unit_instance);
          var slice = entry.h55_1.x4s(border, border, entry.h55_1.r4r_1 - border | 0, entry.h55_1.s4r_1 - border | 0);
          var g = first_0(result_0.p5w_1);
          var m = g.f5x_1;
          var xadvance = m.z5r_1;
          var tmp$ret$1 = new Glyph(this.l60_1, codePoint, slice, -toIntRound(g.e5x_1.r3i_1) | 0, -toIntRound(g.e5x_1.s3i_1) | 0, toIntRound(xadvance));
          this_1.u40(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.h1(codePoint));
      }
    }finally {
      result = true ? this_0.g57(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.j5r_1 = size;
    this.k5r_1 = top;
    this.l5r_1 = ascent;
    this.m5r_1 = baseline;
    this.n5r_1 = descent;
    this.o5r_1 = bottom;
    this.p5r_1 = lineGap;
    this.q5r_1 = maxWidth;
    this.r5r_1 = unitsPerEm;
  }
  a61() {
    // Inline function 'kotlin.math.max' call
    var a = this.l5r_1;
    var b = this.k5r_1;
    return Math.max(a, b);
  }
  b61() {
    // Inline function 'kotlin.math.min' call
    var a = this.n5r_1;
    var b = this.o5r_1;
    return Math.min(a, b);
  }
  c61() {
    return this.a61() - this.b61();
  }
  o5x() {
    return this.c61() + this.p5r_1;
  }
  s5r(other, size) {
    return this.d61(other, size / other.j5r_1);
  }
  d61(other, scale) {
    this.j5r_1 = other.j5r_1 * scale;
    this.k5r_1 = other.k5r_1 * scale;
    this.l5r_1 = other.l5r_1 * scale;
    this.m5r_1 = other.m5r_1 * scale;
    this.n5r_1 = other.n5r_1 * scale;
    this.o5r_1 = other.o5r_1 * scale;
    this.p5r_1 = other.p5r_1 * scale;
    this.r5r_1 = other.r5r_1 * scale;
    this.q5r_1 = other.q5r_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.gc('FontMetrics(');
    this_0.gc('size=' + niceStr(this.j5r_1, 1) + ', ');
    this_0.gc('top=' + niceStr(this.k5r_1, 1) + ', ');
    this_0.gc('ascent=' + niceStr(this.l5r_1, 1) + ', ');
    this_0.gc('baseline=' + niceStr(this.m5r_1, 1) + ', ');
    this_0.gc('descent=' + niceStr(this.n5r_1, 1) + ', ');
    this_0.gc('bottom=' + niceStr(this.o5r_1, 1) + ', ');
    this_0.gc('lineGap=' + niceStr(this.p5r_1, 1) + ', ');
    this_0.gc('unitsPerEm=' + niceStr(this.r5r_1, 1) + ', ');
    this_0.gc('maxWidth=' + niceStr(this.q5r_1, 1) + ', ');
    this_0.gc('lineHeight=' + niceStr(this.o5x(), 1));
    this_0.gc(')');
    return this_0.toString();
  }
  hashCode() {
    var result = getNumberHashCode(this.j5r_1);
    result = imul(result, 31) + getNumberHashCode(this.k5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q5r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r5r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.j5r_1, tmp0_other_with_cast.j5r_1))
      return false;
    if (!equals(this.k5r_1, tmp0_other_with_cast.k5r_1))
      return false;
    if (!equals(this.l5r_1, tmp0_other_with_cast.l5r_1))
      return false;
    if (!equals(this.m5r_1, tmp0_other_with_cast.m5r_1))
      return false;
    if (!equals(this.n5r_1, tmp0_other_with_cast.n5r_1))
      return false;
    if (!equals(this.o5r_1, tmp0_other_with_cast.o5r_1))
      return false;
    if (!equals(this.p5r_1, tmp0_other_with_cast.p5r_1))
      return false;
    if (!equals(this.q5r_1, tmp0_other_with_cast.q5r_1))
      return false;
    if (!equals(this.r5r_1, tmp0_other_with_cast.r5r_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().c3m() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.v5r_1 = size;
    this.w5r_1 = existing;
    this.x5r_1 = codePoint;
    this.y5r_1 = bounds;
    this.z5r_1 = xadvance;
  }
  c3q() {
    return this.y5r_1.c3q();
  }
  i3j() {
    return this.y5r_1.i3j();
  }
  d3q() {
    return this.y5r_1.d3q();
  }
  f3u() {
    return this.y5r_1.d3j_1;
  }
  g3u() {
    return this.y5r_1.e3j_1;
  }
  a5s(other, size, codePoint) {
    return this.e61(other, size / other.v5r_1, codePoint);
  }
  e61(other, scale, codePoint) {
    this.v5r_1 = other.v5r_1;
    this.w5r_1 = other.w5r_1;
    this.x5r_1 = codePoint;
    this.y5r_1 = other.y5r_1.u3q(scale);
    this.z5r_1 = other.z5r_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.gc('GlyphMetrics(');
    this_0.gc('codePoint=' + this.x5r_1 + " ('" + toString_1(numberToChar(this.x5r_1)) + "'), ");
    this_0.gc('existing=' + this.w5r_1 + ', ');
    this_0.gc('xadvance=' + roundToInt(this.z5r_1) + ', ');
    this_0.gc('bounds=' + this.y5r_1.l2().toString());
    this_0.gc(')');
    return this_0.toString();
  }
  hashCode() {
    var result = getNumberHashCode(this.v5r_1);
    result = imul(result, 31) + getBooleanHashCode(this.w5r_1) | 0;
    result = imul(result, 31) + this.x5r_1 | 0;
    result = imul(result, 31) + this.y5r_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.v5r_1, tmp0_other_with_cast.v5r_1))
      return false;
    if (!(this.w5r_1 === tmp0_other_with_cast.w5r_1))
      return false;
    if (!(this.x5r_1 === tmp0_other_with_cast.x5r_1))
      return false;
    if (!this.y5r_1.equals(tmp0_other_with_cast.y5r_1))
      return false;
    if (!equals(this.z5r_1, tmp0_other_with_cast.z5r_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().c3m() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.r5y_1 = bounds;
    this.s5y_1 = lineBounds;
    this.t5y_1 = fontMetrics;
    this.u5y_1 = nlines;
  }
  f61() {
    var tmp0_elvis_lhs = firstOrNull_0(this.s5y_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().l3j_1 : tmp0_elvis_lhs;
  }
  i3j() {
    return this.r5y_1.i3j();
  }
  d3q() {
    return this.r5y_1.d3q();
  }
  f3u() {
    return this.r5y_1.d3j_1;
  }
  g3u() {
    return this.r5y_1.e3j_1;
  }
  g61() {
    return -this.i3j();
  }
  h61() {
    return this.f61().e3j_1 + this.f61().d3q();
  }
  t5z() {
    return this.t5y_1.l5r_1;
  }
  o5x() {
    return this.t5y_1.o5x();
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.i3j()) + ', ' + get_niceStr_0(this.d3q()) + ', ' + get_niceStr_0(this.f3u()) + ', ' + get_niceStr_0(this.g3u()) + '][' + get_niceStr_0(this.g61()) + ', ' + get_niceStr_0(this.h61()) + ']';
  }
  hashCode() {
    var result = this.r5y_1.hashCode();
    result = imul(result, 31) + hashCode(this.s5y_1) | 0;
    result = imul(result, 31) + this.t5y_1.hashCode() | 0;
    result = imul(result, 31) + this.u5y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.r5y_1.equals(tmp0_other_with_cast.r5y_1))
      return false;
    if (!equals(this.s5y_1, tmp0_other_with_cast.s5y_1))
      return false;
    if (!this.t5y_1.equals(tmp0_other_with_cast.t5y_1))
      return false;
    if (!(this.u5y_1 === tmp0_other_with_cast.u5y_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.k61_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.l61_1 = toIntMap(destination);
  }
  h1(id) {
    return this.l61_1.h1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.m61_1 = path;
    this.n61_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.m61_1.toString() + ', advanceWidth=' + this.n61_1 + ')';
  }
  hashCode() {
    var result = this.m61_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.n61_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.m61_1.equals(tmp0_other_with_cast.m61_1))
      return false;
    if (!equals(this.n61_1, tmp0_other_with_cast.n61_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.o61_1 = charstringsIndex;
    this.p61_1 = globalSubrIndex;
    this.q61_1 = localSubrsIndex;
    this.r61_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.r61_1.e3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.s61_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.r61_1.e3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.t61_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  u61(index, flipY) {
    var evalCtx = new EvalContext(this.p61_1, this.q61_1, this.s61_1, this.t61_1, index);
    var vp = new VectorPath();
    var bytes = this.o61_1.h1(index);
    CharStringType2_instance.x61(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.o4z(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.h62_1);
  }
  j62(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.u61(index, flipY) : $super.u61.call(this, index, flipY);
  }
}
class DataIndex {
  static k62(offsets, bytes) {
    var $this = createThis(this);
    $this.v61_1 = offsets;
    $this.w61_1 = bytes;
    return $this;
  }
  static l62() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.k62(tmp, tmp$ret$1);
  }
  g1() {
    return this.v61_1.length - 1 | 0;
  }
  m62(index) {
    return this.v61_1[index + 1 | 0] - this.v61_1[index] | 0;
  }
  h1(index) {
    return copyOfRange(this.w61_1, this.v61_1[index], this.v61_1[index + 1 | 0]);
  }
  n62() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.g1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.h1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  b1() {
    return this.n62().b1();
  }
  toString() {
    var tmp = this.g1();
    var tmp_0 = toString_0(toList_0(this.v61_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.g1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.m62(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.k61_1 = id;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.q62_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.r62_1 = toIntMap(destination);
  }
  h1(id) {
    var tmp0_elvis_lhs = this.r62_1.h1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.h5(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.l62() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.l62() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.y61_1 = globalSubrIndex;
    this.z61_1 = localSubrsIndex;
    this.a62_1 = defaultWidthX;
    this.b62_1 = nominalWidthX;
    this.c62_1 = index;
    this.d62_1 = heap;
    this.e62_1 = computeSubrBias(CharStringType2_instance, this.y61_1.g1());
    this.f62_1 = computeSubrBias(CharStringType2_instance, this.z61_1.g1());
    this.g62_1 = 0;
    this.h62_1 = this.a62_1;
    this.i62_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.q62_1 = id;
  }
}
class CFF {
  s62(_this__u8e3s4) {
    this.t62(_this__u8e3s4);
    var nameIndex = this.u62(_this__u8e3s4);
    var topDictIndex = this.u62(_this__u8e3s4);
    var topDictByte = topDictIndex.h1(0)[1];
    var topDict = this.v62(openFastStream(topDictIndex.h1(0)));
    var stringIndex = this.u62(_this__u8e3s4);
    var globalSubrIndex = this.u62(_this__u8e3s4);
    var privateSizeOffset = topDict.e3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.l62();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.h1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.h1(1);
      privateDict = this.v62(_this__u8e3s4.f30(privateOffset, privateSize));
      var localSubrs = privateDict.e3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.u62(_this__u8e3s4.g30(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.e3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.u62(_this__u8e3s4.g30(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  t62(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.l30();
    var versionMinor = _this__u8e3s4.l30();
    var headerSize = _this__u8e3s4.l30();
    var offsetSize = _this__u8e3s4.l30();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().w62_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  x62(_this__u8e3s4) {
    return _this__u8e3s4.l30();
  }
  y62(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.x62(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.l30();
        break;
      case 2:
        tmp = _this__u8e3s4.n30();
        break;
      case 3:
        tmp = _this__u8e3s4.o30();
        break;
      case 4:
        tmp = _this__u8e3s4.p30();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  u62(_this__u8e3s4) {
    var count = _this__u8e3s4.n30();
    if (count === 0)
      return DataIndex.l62();
    var offSize = this.x62(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.l3w((coerceAtLeast(this_0.p1() - this_0.o1() | 0, 0) / this_0.h2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.o1();
    var nestedLast = this_0.p1();
    var stepArg = this_0.h2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.y62(_this__u8e3s4, offSize) - 1 | 0;
        this_1.r3w(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.j30(offsets.y3w());
    return DataIndex.k62(offsets.c3x(), bytes);
  }
  v62(_this__u8e3s4) {
    var map = LinkedHashMap.wc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.z();
    while (_this__u8e3s4.w25()) {
      var item = this.z62(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.k3(item, value);
        values.h3();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  z62(_this__u8e3s4) {
    var b0 = _this__u8e3s4.l30();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_30();
      tmp = tmp_0.h1(b0 === 12 ? b0 << 8 | _this__u8e3s4.l30() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.l30() << 8 | _this__u8e3s4.l30());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.l30() << 24 | _this__u8e3s4.l30() << 16 | _this__u8e3s4.l30() << 8 | _this__u8e3s4.l30();
    } else if (b0 === 30) {
      tmp = this.a63(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.l30() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.l30() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  b63(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.l30() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.h5(toString_0(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.l30();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.gc('E-');
              break;
            default:
              str.hc((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  a63(_this__u8e3s4, readHeader) {
    return toDouble(this.b63(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  c63(_this__u8e3s4, value) {
    _this__u8e3s4.q3x(_this__u8e3s4.g1() - 1 | 0, value);
  }
  d63(_this__u8e3s4) {
    return _this__u8e3s4.h1(_this__u8e3s4.g1() - 1 | 0);
  }
  e63(_this__u8e3s4) {
    return _this__u8e3s4.j3(_this__u8e3s4.g1() - 1 | 0);
  }
  f63(_this__u8e3s4, value) {
    _this__u8e3s4.s29(value);
  }
  g63(_this__u8e3s4, value) {
    _this__u8e3s4.s29(value);
  }
  h63(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.v4y();
    _this__u8e3s4.p6();
    _this__u8e3s4.k4p(lastPoint);
  }
  i63(_this__u8e3s4, x, y) {
    _this__u8e3s4.e4z(Vector2D.y3k(x, y));
  }
  j63(_this__u8e3s4, x, y) {
    _this__u8e3s4.f4z(Vector2D.y3k(x, y));
  }
  k63(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.l4p(Vector2D.y3k(fcx1, fcy1), Vector2D.y3k(fcx2, fcy2), Vector2D.y3k(fax, fay));
  }
  l63(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.v4y().r3i_1 + cx1;
    var fcy1 = _this__u8e3s4.v4y().s3i_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.k63(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  m63(_this__u8e3s4, v, horizontal) {
    return this.i63(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  n63(_this__u8e3s4, v, horizontal) {
    return this.j63(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  o63(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.l30();
  }
  p63(ctx, s, evalCtx, stack, stackLevel) {
    while (s.w25()) {
      var v0 = this.o63(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_31();
        var op = tmp.h1(v0 === 12 ? v0 << 8 | this.o63(s) : v0);
        switch (op.p3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.j1()) {
              tmp_0 = !evalCtx.i62_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.h62_1 = stack.h1(0) + evalCtx.b62_1;
              evalCtx.i62_1 = true;
            }

            if (!(ctx.u4y() === 0)) {
              this.h63(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.e63(stack));
            var bytes = global ? evalCtx.y61_1.h1(evalCtx.e62_1 + funcOffset | 0) : evalCtx.z61_1.h1(evalCtx.f62_1 + funcOffset | 0);
            this.p63(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.e63(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.e63(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.i3x(this_0, this_0);
            break;
          case 39:
            stack.a3x(stack.g1() - 2 | 0, stack.g1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.je();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.je();
          case 25:
            var index = this.e63(stack);
            var value = this.e63(stack);
            evalCtx.d62_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.d63(stack);
            var tmp$ret$3 = evalCtx.d62_1[numberToInt(it)];
            this.c63(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.e63(stack);
            var l = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.f63(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.e63(stack);
            var l_0 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.f63(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.d63(stack) === 0.0 ? 1 : 0;
            this.c63(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.e63(stack);
            var l_1 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.f63(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.e63(stack);
            var v1 = this.e63(stack);
            var s2 = this.e63(stack);
            var s1 = this.e63(stack);
            this.f63(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.s29(Default_getInstance().wp());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.d63(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.c63(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.d63(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.c63(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.d63(stack);
            this.c63(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.e63(stack);
            var l_2 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.f63(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.e63(stack);
            var l_3 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.f63(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.e63(stack);
            var l_4 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.f63(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.e63(stack);
            var l_5 = this.e63(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.f63(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.g1() > 2) {
              evalCtx.h62_1 = stack.h1(0) + evalCtx.b62_1;
              evalCtx.i62_1 = true;
            }

            if (!(ctx.u4y() === 0)) {
              this.h63(ctx);
            }

            this.i63(ctx, stack.h1(stack.g1() - 2 | 0), stack.h1(stack.g1() - 1 | 0));
            stack.h3();
            break;
          case 3:
          case 28:
            if (stack.g1() > 1) {
              evalCtx.h62_1 = stack.h1(0) + evalCtx.b62_1;
              evalCtx.i62_1 = true;
            }

            this.m63(ctx, this.e63(stack), op.equals(Op_hmoveto_getInstance()));
            stack.h3();
            break;
          case 5:
            var progression = step(until(0, stack.g1()), 2);
            var inductionVariable = progression.f2_1;
            var last = progression.g2_1;
            var step_0 = progression.h2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.j63(ctx, stack.h1(n), stack.h1(n + 1 | 0));
              }
               while (!(n === last));
            stack.h3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.g1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.n63(ctx, stack.h1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.h3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.g1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.h1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.j63(ctx, tmp_1, stack.h1(_unary__edvuaz_0));
              }
            }

            while ((stack.g1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.h1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.h1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.h1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.h1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.h1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.l63(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.h1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.g1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.h1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.j63(ctx, tmp_7, stack.h1(_unary__edvuaz_8));
              }
            }

            stack.h3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.g1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.h1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.g1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.h5(toString_0(message));
            }

            while (n_2 < stack.g1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.h1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.h1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.h1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.h1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.l63(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.h3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.j1()) {
                break $l$loop;
              }
              var vv_0 = this.e63(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.e63(stack);
              var y2_0 = this.e63(stack);
              var v1_1 = this.e63(stack);
              var v2_0 = stack.g1() === 1 ? this.e63(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.l63(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.h3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.je();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.g1() % 2 | 0) === 0) && !evalCtx.i62_1) {
              var value_0 = stack.h1(0);
              evalCtx.h62_1 = value_0 + evalCtx.b62_1;
            }

            evalCtx.g62_1 = evalCtx.g62_1 + (stack.g1() >>> 1 | 0) | 0;
            evalCtx.i62_1 = true;
            stack.h3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.g62_1 + 7 | 0) >>> 3 | 0;
              s.b26(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.je();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.je();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.o63(s) << 8 | this.o63(s);
        var fractionPart = this.o63(s) << 8 | this.o63(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.f63(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.o63(s) << 8 | this.o63(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.o63(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.o63(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.g63(stack, value_2);
      }
    }
  }
  x61(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.f3x(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.p63(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.p63.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.w62_1 = Companion_getInstance_14().g26('TtfCIDFont');
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_22 = this;
    this.q63_1 = Companion_getInstance_14().g26('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.g66(size, codePoint, path, reader) : $super.g66.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.p25_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.u5r(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.p25_1 = old;
      }
    }
  }
  var g = this.h66(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.h60();
    }
    if (!g.d60()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.s5e_1.h5s_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.i6g(pos.r3i_1, pos.s3i_1);
      g.e60(ctx);
    }finally {
      ctx.s5e_1.h5s_1 = t;
    }
    switch (fill) {
      case true:
        ctx.v5z();
        break;
      case false:
        ctx.u5z();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.d60();
  }
  return false;
}
class BaseTtfFont {
  static c6g(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.r63_1 = new Mixin();
    $this.s63_1 = s;
    $this.t63_1 = extName;
    $this.u63_1 = onlyReadMetadata;
    $this.v63_1 = enableLigatures;
    $this.w63_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.x63_1 = tmp_1;
    $this.y63_1 = 0;
    $this.z63_1 = 0;
    $this.a64_1 = 0;
    $this.b64_1 = 0;
    $this.c64_1 = 0;
    $this.d64_1 = 0;
    $this.e64_1 = 0;
    $this.f64_1 = 0;
    $this.g64_1 = 0;
    $this.h64_1 = 0;
    $this.i64_1 = 0;
    $this.j64_1 = 0;
    $this.k64_1 = 0;
    $this.l64_1 = 0;
    $this.m64_1 = Companion_instance_26.d6g(0, 0);
    $this.n64_1 = 0;
    $this.o64_1 = 0;
    $this.p64_1 = 0;
    $this.q64_1 = 0;
    $this.r64_1 = 0;
    $this.s64_1 = 0;
    $this.t64_1 = 0;
    $this.u64_1 = 0;
    $this.v64_1 = 0;
    $this.w64_1 = 0;
    $this.x64_1 = 0;
    $this.y64_1 = 0;
    $this.z64_1 = new Int32Array(0);
    $this.a65_1 = Companion_instance_26.d6g(0, 0);
    $this.b65_1 = 128;
    $this.c65_1 = 0;
    $this.d65_1 = 0;
    $this.e65_1 = 0;
    $this.f65_1 = 0;
    $this.g65_1 = 0;
    $this.h65_1 = 0;
    $this.i65_1 = 0;
    $this.j65_1 = 0;
    $this.k65_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.l65_1 = emptyList();
    $this.m65_1 = LinkedHashMap.wc();
    $this.n65_1 = LinkedHashMap.wc();
    $this.o65_1 = IntMap.a41(512);
    $this.p65_1 = LinkedHashMap.wc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.q65_1 = [];
    $this.r65_1 = IntMap.a41();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.s65_1 = emptyList();
    $this.t65_1 = new COLRv1();
    $this.u65_1 = false;
    $this.v65_1 = IntIntMap.t41();
    $this.w65_1 = IntMap.a41();
    $this.y65_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().c3m(), 0.0);
    $this.z65_1 = false;
    $this.a66_1 = null;
    return $this;
  }
  c28(_set____db54di) {
    this.r63_1.c28(_set____db54di);
  }
  d28() {
    return this.r63_1.d28();
  }
  static b66(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.c6g(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  i5r(size, metrics) {
    return metrics.s5r(this.l66(), size);
  }
  u5r(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.w67(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.i6d_1;
    return metrics.a5s(tmp0_elvis_lhs == null ? this.y65_1 : tmp0_elvis_lhs, size, codePoint);
  }
  i5t(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  g66(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.p25_1;
    var codePointPeek = reader == null ? null : reader.x25(0);
    var tmp0_elvis_lhs = this.v67(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.d5s(size);
    path.w5z_1 = g.d3e().l6d_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.v6d();
    tmp_0.x5z_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.n6d();
    var bitmapEntry = g.x6d();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.x6a();
    path.y5z_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.b65_1 / bitmapEntry.g6a_1.m69_1;
      var scaleY = this.b65_1 / bitmapEntry.g6a_1.n69_1;
      path.z5z_1 = Vector2D.y3k(0.0, ((-bitmapEntry.h6a_1 | 0) - bitmapEntry.r6a() | 0) * scaleY);
      path.a60_1 = Scale.g3q(scaleX, scaleY);
    }
    path.b60_1 = Companion_getInstance_5().z3l_1.x3m(scale, scale);
    path.c60_1 = scale;
    return path;
  }
  d5s(size) {
    return size / this.b65_1;
  }
  i66(key) {
    return this.m65_1.e3(key);
  }
  j66(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.m65_1.k3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.n65_1.k3(glyphID, codePoint);
  }
  k66(codePoint, glyphID) {
  }
  l66() {
    var tmp = this.x65_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  m66() {
    return this.w63_1.m66();
  }
  q3() {
    var tmp0_elvis_lhs = this.t63_1;
    return tmp0_elvis_lhs == null ? this.m66() : tmp0_elvis_lhs;
  }
  c66() {
    this.d66();
    this.s66();
    this.t66();
    this.u66();
    this.q66();
    if (!this.u63_1) {
      if (!(this.f66('CFF ') == null) && this.f66('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.p66('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.a66_1 = CFF_instance.s62(tmp111_safe_receiver);
        }
      }
      this.r66();
      this.s67();
      this.v66();
      this.w66();
      this.r67();
      this.q67();
      this.y66();
      this.z66();
      this.a67();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.d5s(1.0);
    this_0.j5r_1 = 1.0;
    this_0.k5r_1 = this.f65_1 * scale;
    this_0.l5r_1 = this.n64_1 * scale;
    this_0.m5r_1 = 0.0 * scale;
    this_0.n5r_1 = this.o64_1 * scale;
    this_0.o5r_1 = this.d65_1 * scale;
    this_0.p5r_1 = this.p64_1 * scale;
    this_0.q5r_1 = this.q64_1 * scale;
    this_0.r5r_1 = this.b65_1 * scale;
    tmp.x65_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.q3() + ')';
  }
  n66(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.n30());
  }
  o66(_this__u8e3s4) {
    return Companion_instance_26.d6g(_this__u8e3s4.m30(), _this__u8e3s4.m30());
  }
  p66(name) {
    var tmp109_safe_receiver = this.f66(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.a69();
  }
  q66() {
    var tmp111_safe_receiver = this.p66('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_25.d69(tmp111_safe_receiver, this.w63_1);
    }
    return Unit_instance;
  }
  r66() {
    var tmp111_safe_receiver = this.p66('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.j65_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.j30(imul(bytesPerEntry, this.y63_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.j65_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.t30(this.y63_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.v30(this.y63_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.z64_1 = tmp_1;
    }
    return Unit_instance;
  }
  s66() {
    var tmp111_safe_receiver = this.p66('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.n30() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.n30() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.a65_1 = this.o66(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.p30();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.p30();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.n30();
      this.b65_1 = tmp111_safe_receiver.n30();
      var created = tmp111_safe_receiver.q30().x3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.q30().x3(new Long(1000, 0));
      this.c65_1 = tmp111_safe_receiver.m30();
      this.d65_1 = tmp111_safe_receiver.m30();
      this.e65_1 = tmp111_safe_receiver.m30();
      this.f65_1 = tmp111_safe_receiver.m30();
      this.g65_1 = tmp111_safe_receiver.n30();
      this.h65_1 = tmp111_safe_receiver.n30();
      this.i65_1 = tmp111_safe_receiver.m30();
      this.j65_1 = tmp111_safe_receiver.m30();
      this.k65_1 = tmp111_safe_receiver.m30();
    }
    return Unit_instance;
  }
  t66() {
    var tmp111_safe_receiver = this.p66('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.o66(tmp111_safe_receiver);
      this.y63_1 = tmp111_safe_receiver.n30();
      this.z63_1 = tmp111_safe_receiver.n30();
      this.a64_1 = tmp111_safe_receiver.n30();
      this.b64_1 = tmp111_safe_receiver.n30();
      this.c64_1 = tmp111_safe_receiver.n30();
      this.d64_1 = tmp111_safe_receiver.n30();
      this.e64_1 = tmp111_safe_receiver.n30();
      this.f64_1 = tmp111_safe_receiver.n30();
      this.g64_1 = tmp111_safe_receiver.n30();
      this.h64_1 = tmp111_safe_receiver.n30();
      this.i64_1 = tmp111_safe_receiver.n30();
      this.j64_1 = tmp111_safe_receiver.n30();
      this.k64_1 = tmp111_safe_receiver.n30();
      this.l64_1 = tmp111_safe_receiver.n30();
    }
    return Unit_instance;
  }
  u66() {
    var tmp111_safe_receiver = this.p66('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.m64_1 = this.o66(tmp111_safe_receiver);
      this.n64_1 = tmp111_safe_receiver.m30();
      this.o64_1 = tmp111_safe_receiver.m30();
      this.p64_1 = tmp111_safe_receiver.m30();
      this.q64_1 = tmp111_safe_receiver.n30();
      this.r64_1 = tmp111_safe_receiver.m30();
      this.s64_1 = tmp111_safe_receiver.m30();
      this.t64_1 = tmp111_safe_receiver.m30();
      this.u64_1 = tmp111_safe_receiver.m30();
      this.v64_1 = tmp111_safe_receiver.m30();
      this.w64_1 = tmp111_safe_receiver.m30();
      tmp111_safe_receiver.m30();
      tmp111_safe_receiver.m30();
      tmp111_safe_receiver.m30();
      tmp111_safe_receiver.m30();
      this.x64_1 = tmp111_safe_receiver.m30();
      this.y64_1 = tmp111_safe_receiver.n30();
    }
    return Unit_instance;
  }
  v66() {
    var tmp111_safe_receiver = this.p66('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.y64_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.f2_1;
      var last_0 = this_0.g2_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.n30(), tmp111_safe_receiver.m30());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).b69_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.y63_1 - this.y64_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.f2_1;
      var last_1 = this_1.g2_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.m30());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.l65_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  w66() {
    var tmp111_safe_receiver = this.p66('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.n30();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.n30();
          var numPalettes = tmp111_safe_receiver.n30();
          var numColorRecords = tmp111_safe_receiver.n30();
          var colorRecordsArrayOffset = tmp111_safe_receiver.p30();
          var colorRecordIndices = tmp111_safe_receiver.s30(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.p30() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.p30() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.p30() : -1;
          tmp111_safe_receiver.b30(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.u30(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_24().f5o(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.s65_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  x66(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.l30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30(), _this__u8e3s4.k30());
  }
  y66() {
    var tmp111_safe_receiver = this.p66('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.n30();
      var minorVersion = tmp111_safe_receiver.n30();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.p30();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.p30(), tmp111_safe_receiver.p30(), tmp111_safe_receiver.p30(), tmp111_safe_receiver.p30(), this.x66(tmp111_safe_receiver), this.x66(tmp111_safe_receiver), tmp111_safe_receiver.n30(), tmp111_safe_receiver.n30(), tmp111_safe_receiver.l30(), tmp111_safe_receiver.l30(), tmp111_safe_receiver.l30(), tmp111_safe_receiver.k30());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.b1();
        while (_iterator__ex2g4s.c1()) {
          var cbi = _iterator__ex2g4s.d1();
          var glyphCount = cbi.l69_1 - cbi.k69_1 | 0;
          tmp111_safe_receiver.b30(cbi.e69_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.g69_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.n30(), tmp111_safe_receiver.n30(), tmp111_safe_receiver.p30());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.b30(cbi.e69_1 + subtable.p6f_1 | 0);
            var indexFormat = tmp111_safe_receiver.n30();
            var imageFormat = tmp111_safe_receiver.n30();
            var imageDataOffset = tmp111_safe_receiver.p30();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.q6f() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.p30() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.n6f_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.p65_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.k3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  z66() {
    var tmp111_safe_receiver = this.p66('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.n30();
      var minorVersion = tmp111_safe_receiver.n30();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.p65_1.n3().b1();
        while (_iterator__ex2g4s.c1()) {
          var i = _iterator__ex2g4s.d1();
          var format = i.d6a_1;
          if (format === 17 || format === 18) {
            i.h6a_1 = tmp111_safe_receiver.l30();
            i.i6a_1 = tmp111_safe_receiver.l30();
            i.j6a_1 = tmp111_safe_receiver.k30();
            i.k6a_1 = tmp111_safe_receiver.k30();
            i.l6a_1 = tmp111_safe_receiver.l30();
            i.m6a_1 = format === 18 ? tmp111_safe_receiver.k30() : i.j6a_1;
            i.n6a_1 = format === 18 ? tmp111_safe_receiver.k30() : i.k6a_1;
            i.o6a_1 = format === 18 ? tmp111_safe_receiver.k30() : i.l6a_1;
          }
          var dataLen = tmp111_safe_receiver.p30();
          i.p6a_1 = tmp111_safe_receiver.e30(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  a67() {
    var tmp111_safe_receiver = this.p66('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.n30();
      var flags = tmp111_safe_receiver.n30();
      var numStrikes = tmp111_safe_receiver.p30();
      var strikeOffsets = tmp111_safe_receiver.v30(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.b30(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.n30(), tmp111_safe_receiver.n30(), item, toIntArrayList(tmp111_safe_receiver.v30(this.y63_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.b1();
        if (!iterator.c1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.d1();
        if (!iterator.c1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.r6f_1;
        do {
          var e = iterator.d1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.r6f_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.c1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.y63_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.u6f_1.h1(n);
          var len = strike.u6f_1.h1(n + 1 | 0) - offset | 0;
          var start = strike.t6f_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.b30(start);
          var originOffsetX = tmp111_safe_receiver.m30();
          var originOffsetY = tmp111_safe_receiver.m30();
          var graphicType = tmp111_safe_receiver.y30(4);
          var bytes = tmp111_safe_receiver.e30(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.p65_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.r6f_1, strike.r6f_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.p6a_1 = bytes;
          this_0.k3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  b67(_this__u8e3s4) {
    return _this__u8e3s4.p30();
  }
  c67(_this__u8e3s4) {
    return _this__u8e3s4.n30();
  }
  d67(_this__u8e3s4) {
    return _this__u8e3s4.m30();
  }
  e67(_this__u8e3s4) {
    return _this__u8e3s4.n30();
  }
  f67(_this__u8e3s4) {
    return _this__u8e3s4.o30();
  }
  g67(_this__u8e3s4) {
    return _this__u8e3s4.p30();
  }
  h67(_this__u8e3s4, isVar) {
    var xx = this.c68(_this__u8e3s4);
    var yx = this.c68(_this__u8e3s4);
    var xy = this.c68(_this__u8e3s4);
    var yy = this.c68(_this__u8e3s4);
    var dx = this.c68(_this__u8e3s4);
    var dy = this.c68(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  i67(_this__u8e3s4, out) {
    out.b6b_1 = this.b68(_this__u8e3s4);
    out.c6b_1 = _this__u8e3s4.n30();
    out.d6b_1 = this.b68(_this__u8e3s4);
    return out;
  }
  j67(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.i67(_this__u8e3s4, out) : $super.i67.call(this, _this__u8e3s4, out);
  }
  k67(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.l30();
    var xMin = this.d67(_this__u8e3s4);
    var yMin = this.d67(_this__u8e3s4);
    var xMax = this.d67(_this__u8e3s4);
    var yMax = this.d67(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.b67(_this__u8e3s4);
    }
    return Companion_getInstance_4().p3q(xMin, yMin, xMax, yMax);
  }
  l67(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.k67(_this__u8e3s4, doVar) : $super.k67.call(this, _this__u8e3s4, doVar);
  }
  m67(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.l30()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.n30();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.j67(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  n67(glyphID, s, c, pal, level) {
    var nodeFormat = s.l30();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_34().m68_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.l30();
        var firstLayerIndex = s.p30();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.t65_1.g6c_1[firstLayerIndex + n | 0];
            this.n67(glyphID, this.t65_1.j6c_1.g30(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.n30();
        var alpha = this.b68(s);
        if (isVar) {
          var varIndexBase = this.b67(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.je();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.s65_1.h1(pal).s5n_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.e6g(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.f67(s);
        var x0 = this.d67(s);
        var y0 = this.d67(s);
        var x1 = this.d67(s);
        var y1 = this.d67(s);
        var x2 = this.d67(s);
        var y2 = this.d67(s);
        var colorLine = this.m67(s.g30(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.b67(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.y6a_1;
        var transform = Companion_getInstance_5().z3l_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.a6b(paint_0, this.s65_1.h1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.e6g(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.f67(s);
        var x0_0 = this.d67(s);
        var y0_1 = this.d67(s);
        var radius0 = this.c67(s);
        var x1_0 = this.d67(s);
        var y1_1 = this.d67(s);
        var radius1 = this.c67(s);
        var colorLine_0 = this.m67(s.g30(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.b67(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.y6a_1;
        var transform_0 = Companion_getInstance_5().z3l_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.a6b(paint_1, this.s65_1.h1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.e6g(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.f67(s);
        var centerX = this.d67(s);
        var centerY = this.d67(s);
        var startAngle = this.b68(s);
        var endAngle = this.b68(s);
        if (isVar) {
          var varIndexBase_2 = this.b67(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      case 10:
        var paint_2 = this.f67(s);
        var glyphID_0 = s.n30();
        var colr = this.r65_1.h1(glyphID_0);
        var glyph = this.a68(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f6g();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.d3e().l6d_1), '\n'));
            }
            c.g6g(glyph.d3e().l6d_1);
            this.n67(glyphID_0, s.g30(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.h6g();
        }

        break;
      case 11:
        var glyphID_1 = s.n30();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      case 12:
      case 13:
        var paint_3 = this.f67(s);
        var transform_1 = this.f67(s);
        var affine = this.h67(s.g30(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f6g();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.f60(affine);
          this.n67(glyphID, s.g30(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.h6g();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.f67(s);
        var dx = FWord__toDouble_impl_53j5qp(this.n66(s));
        var dy = FWord__toDouble_impl_53j5qp(this.n66(s));
        if (isVar) {
          var varIndexBase_3 = this.b67(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f6g();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.i6g(dx, -dy);
          this.n67(glyphID, s.g30(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.h6g();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.f67(s);
        var scaleX = this.b68(s);
        var scaleY = this.b68(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.d67(s);
          var centerY_0 = this.d67(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.je();
        }

        if (isVar) {
          var varIndexBase_4 = this.b67(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f6g();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.j6g(numberToDouble(scaleX), numberToDouble(scaleY));
          this.n67(glyphID, s.g30(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.h6g();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.f67(s);
        var scale = this.b68(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.d67(s);
          var centerY_1 = this.d67(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.b67(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.f67(s);
        var angle = this.b68(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.d67(s);
          var centerY_2 = this.d67(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.b67(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.f67(s);
        var xSkewAngle = this.b68(s);
        var ySkewAngle = this.b68(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.d67(s);
          var centerY_3 = this.d67(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.b67(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      case 32:
        var sourcePaint = this.f67(s);
        var compositeMode = s.l30();
        var backdropPaint = this.f67(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.je();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.je('An operation is not implemented: ' + reason);
    }
  }
  o67(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.n30();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.n30();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.t30(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.n30();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.f2_1;
        var last_0 = this_3.g2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.n30(), _this__u8e3s4.n30(), _this__u8e3s4.n30());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.b1();
        if (!iterator.c1())
          throw NoSuchElementException.x6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.d1();
        var maxValue = it.x6f_1 + it.y6f_1 | 0;
        while (iterator.c1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.d1();
          var v = it_0.x6f_1 + it_0.y6f_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.b1();
        while (_iterator__ex2g4s.c1()) {
          var range = _iterator__ex2g4s.d1();
          var inductionVariable_1 = range.v6f_1;
          var last_1 = range.w6f_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.v6f_1 | 0;
              glyphArray[range.x6f_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.je('An operation is not implemented: ' + reason);
    }
  }
  p67(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.o67(_this__u8e3s4, hintedCount) : $super.o67.call(this, _this__u8e3s4, hintedCount);
  }
  q67() {
    var tmp111_safe_receiver = this.p66('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.n30();
      var minorVersion = tmp111_safe_receiver.n30();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.h5(toString_0(message));
      }
      var scriptListOffset = this.e67(tmp111_safe_receiver);
      var featureListOffset = this.e67(tmp111_safe_receiver);
      var lookupListOffset = this.e67(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.g67(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.g30(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.n30();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.y30(4);
          var scriptOffset = this.e67(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.g30(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.n30();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.y30(4);
          var featureOffset = this.e67(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.g30(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.n30();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.l3w((coerceAtLeast(this_3.p1() - this_3.o1() | 0, 0) / this_3.h2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.o1();
      var nestedLast = this_3.p1();
      var stepArg = this_3.h2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.e67(this_2);
          this_4.r3w(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.b1();
      while (_iterator__ex2g4s.c1()) {
        var lookupOffset = _iterator__ex2g4s.d1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.g30(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.n30();
        var lookupFlag = this_5.n30();
        var subTableCount = this_5.n30();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.s30(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.n30();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.g30(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.n30();
              var coverageOffset = this.e67(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.m30();
                  var coverageTable = this.p67(this_8.g30(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.v65_1.s41(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.n30();
                  var coverageTable_0 = this.p67(this_8.g30(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.t30(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.v65_1.s41(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.h5(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.n30();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.h5(toString_0(message_1));
              }

              var coverageOffset_0 = this.e67(this_8);
              var ligatureSetCount = this_8.n30();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.t30(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.o67(this_8.g30(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.wc();
                  var codePoint = this.u67(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.g30(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.n30();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.t30(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.g30(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.n30();
                    var componentCount = this_19.n30();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.t30(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.u67(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_11();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.e26(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.k3(ligature, value);
                  }
                  this.w65_1.u40(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_32().q63_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.q46(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.r46(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  r67() {
    var tmp111_safe_receiver = this.p66('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.n30();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.n30();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.p30();
          var layerRecordsOffset = tmp111_safe_receiver.p30();
          var numLayerRecords = tmp111_safe_receiver.n30();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.g30(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.n30(), this_0.n30());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.q65_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.g30(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.n30(), this_1.n30(), this_1.n30());
              this.r65_1.u40(info.r6d_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.g67(tmp111_safe_receiver);
            var layerListOffset = this.g67(tmp111_safe_receiver);
            var clipListOffset = this.g67(tmp111_safe_receiver);
            var varIdxMapOffset = this.g67(tmp111_safe_receiver);
            var varStoreOffset = this.g67(tmp111_safe_receiver);
            this.t65_1.l6c_1.h3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.g30(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.g30(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.p30();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.g67(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.g30(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.g30(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.g30(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.t65_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.g30(clipListOffset);
              var format = s.l30();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.p30();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.n30();
                var endGlyphID = s.n30();
                var clipBoxOffset = this.f67(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.t65_1.l6c_1.s41(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.g30(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.p30();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.n30();
              var paint = this.g67(this_3);
              this.r65_1.u40(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  s67() {
    var tmp111_safe_receiver = this.p66('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.n30();
      var numTables = tmp111_safe_receiver.n30();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.f2_1;
      var last = this_0.g2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.n30(), tmp111_safe_receiver.n30(), tmp111_safe_receiver.p30());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.b1();
      while (_iterator__ex2g4s.c1()) {
        var table = _iterator__ex2g4s.d1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.g30(table.b6g_1);
        var format = $this$run.n30();
        try {
          switch (format) {
            case 0:
              var length = $this$run.n30();
              var language = $this$run.n30();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.j30(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.k66(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.n30();
              var language_0 = $this$run.n30();
              var segCount = $this$run.n30() / 2 | 0;
              var searchRangeS = $this$run.n30();
              var entrySelector = $this$run.n30();
              var rangeShift = $this$run.n30();
              var endCount = $this$run.t30(segCount);
              $this$run.n30();
              var startCount = $this$run.t30(segCount);
              var idDelta = $this$run.s30(segCount);
              var rangeOffsetPos = $this$run.c30();
              var idRangeOffset = $this$run.t30(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.g30(glyphIndexOffset).n30();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.j66(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.n30();
              var language_1 = $this$run.n30();
              var firstCode = $this$run.n30();
              var entryCount = $this$run.n30();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.j66(codePoint, $this$run.n30());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.n30();
              var length_2 = $this$run.p30();
              var language_2 = $this$run.p30();
              var numGroups = $this$run.p30();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.p30();
                  var endCharCode = $this$run.p30();
                  var startGlyphId = $this$run.p30();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.j66(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  t67(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.n65_1.e3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  u67(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.t67(charIndex, default_0) : $super.t67.call(this, charIndex, default_0);
  }
  v67(reader, codePoint, cache) {
    var g = this.y67(codePoint);
    var skipCount = 1;
    if (this.v63_1 && !(g == null)) {
      var subs = this.w65_1.h1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.q25();
        var b = subs.y68_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.c26(0, count);
            var replacement = subs.z68_1.e3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.a68(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.b26(skipCount);
    }
    return g;
  }
  w67(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.v67(reader, codePoint, cache) : $super.v67.call(this, reader, codePoint, cache);
  }
  x67(codePoint, cache) {
    var tmp134_safe_receiver = this.i66(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.z67(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  y67(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.x67(codePoint, cache) : $super.x67.call(this, codePoint, cache);
  }
  z67(index, cache, codePoint) {
    var cff = this.a66_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.o65_1;
      var res = this_0.h1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.j62(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.n61_1), new GlyphGraphicsPath(index, gvector.m61_1));
        this_0.u40(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.h1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.z64_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.z64_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.o65_1.h1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.f66('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.a69();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.e68($this$runTable.g30(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.l65_1.h1(index).b69_1, true);
    }
    var glyph = tmp;
    if (cache && !this.u65_1) {
      this.o65_1.u40(index, glyph);
    }
    return glyph;
  }
  a68(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.z67(index, cache, codePoint) : $super.z67.call(this, index, cache, codePoint);
  }
  b68(_this__u8e3s4) {
    var v = _this__u8e3s4.m30();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  c68(_this__u8e3s4) {
    var v = _this__u8e3s4.p30();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  d68(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.k30();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.l30();
    } else if (word && signed) {
      tmp = _this__u8e3s4.m30();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.n30();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  e68(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.m30();
    var xMin = _this__u8e3s4.m30();
    var yMin = _this__u8e3s4.m30();
    var xMax = _this__u8e3s4.m30();
    var yMax = _this__u8e3s4.m30();
    var advanceWidth = this.l65_1.h1(index).b69_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.z();
      do {
        var flags = _this__u8e3s4.n30();
        var glyphIndex = _this__u8e3s4.n30();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.d68(_this__u8e3s4, signed, words);
        var y = this.d68(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.b68(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.b68(_this__u8e3s4);
          scaleY = this.b68(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.b68(_this__u8e3s4);
          scale01 = this.b68(_this__u8e3s4);
          scale10 = this.b68(_this__u8e3s4);
          scaleY = this.b68(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.a68(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.n30();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.n30();
      var instructions = _this__u8e3s4.j30(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.l3w();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.l30();
        flags_0.r3w(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.l30();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.r3w(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.x27(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.l30();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.m30() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.c3x(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static l5w(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_32();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.b66(d, extName, onlyReadMetadata, enableLigatures);
    $this.k5w_1 = LinkedHashMap.wc();
    $this.c66();
    return $this;
  }
  d66() {
    this.k5w_1.m3(Companion_instance_25.e66(this.s63_1.h30()));
  }
  f66(name) {
    return this.k5w_1.e3(name);
  }
}
class Companion_16 {
  constructor() {
    this.l68_1 = 26;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_24 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m68_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.n68_1 = fillArrayVal(Array(26), null);
    this.o68_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.p68_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.q68_1 = tmp_5;
    this.r68_1 = null;
  }
  m66() {
    var tmp0_elvis_lhs = this.s68(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.s68(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  t68(nameId) {
    if (this.n68_1[nameId] == null) {
      var nameLength = this.p68_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.r68_1).w30(this.o68_1[nameId], nameLength, this.q68_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.hc(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.n68_1[nameId] = tmp;
    }
    return this.n68_1[nameId];
  }
  s68(nameId) {
    return this.t68(nameId.w68_1);
  }
  x68() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.xc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.s68(element);
      result.k3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.x68()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.y68_1 = maxSequence;
    this.z68_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.f68_1 = id;
    this.g68_1 = checksum;
    this.h68_1 = offset;
    this.i68_1 = length;
    this.j68_1 = null;
    var tmp = this;
    tmp.k68_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  a69() {
    return _get_ss__ndcawb(this).z27();
  }
  toString() {
    return 'Table(id=' + this.f68_1 + ', checksum=' + this.g68_1 + ', offset=' + this.h68_1 + ', length=' + this.i68_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.f68_1);
    result = imul(result, 31) + this.g68_1 | 0;
    result = imul(result, 31) + this.h68_1 | 0;
    result = imul(result, 31) + this.i68_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.f68_1 === tmp0_other_with_cast.f68_1))
      return false;
    if (!(this.g68_1 === tmp0_other_with_cast.g68_1))
      return false;
    if (!(this.h68_1 === tmp0_other_with_cast.h68_1))
      return false;
    if (!(this.i68_1 === tmp0_other_with_cast.i68_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.b69_1 = advanceWidth;
    this.c69_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.b69_1 + ', lsb=' + this.c69_1 + ')';
  }
  hashCode() {
    var result = this.b69_1;
    result = imul(result, 31) + this.c69_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.b69_1 === tmp0_other_with_cast.b69_1))
      return false;
    if (!(this.c69_1 === tmp0_other_with_cast.c69_1))
      return false;
    return true;
  }
}
class Companion_18 {
  d69(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.n30();
    var count = s.n30();
    var stringOffset = s.n30();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.n30();
        var encodingId = s.n30();
        var languageId = s.n30();
        var nameId = s.n30();
        var length = s.n30();
        var offset = s.n30();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.p68_1[nameId] === -1) {
          info.o68_1[nameId] = stringOffset + offset | 0;
          info.p68_1[nameId] = length;
          info.q68_1[nameId] = charset;
          info.r68_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  e66(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.p30() === 1953784678) {
      var majorVersion = s.n30();
      var minorVersion = s.n30();
      var numFonts = s.p30();
      var tableDirectoryOffsets = s.v30(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.p30();
        var dsigLength = s.p30();
        var dsigOffset = s.p30();
      }
      s.b30(tableDirectoryOffsets[0]);
    } else {
      s.i30(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.n30();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.n30();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.n30();
    var searchRange = s.n30();
    var entrySelector = s.n30();
    var rangeShift = s.n30();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.f2_1;
    var last = this_2.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.y30(4), s.p30(), s.p30(), s.p30());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.wc();
    var _iterator__ex2g4s = tables.b1();
    while (_iterator__ex2g4s.c1()) {
      var table = _iterator__ex2g4s.d1();
      var tmp = table;
      tmp.j68_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.f68_1;
      tablesByName.k3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.w68_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.e69_1 = indexSubTableArrayOffset;
    this.f69_1 = indexTablesSize;
    this.g69_1 = numberofIndexSubTables;
    this.h69_1 = colorRef;
    this.i69_1 = hori;
    this.j69_1 = vert;
    this.k69_1 = startGlyphIndex;
    this.l69_1 = endGlyphIndex;
    this.m69_1 = ppemX;
    this.n69_1 = ppemY;
    this.o69_1 = bitDepth;
    this.p69_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.e69_1 + ', indexTablesSize=' + this.f69_1 + ', numberofIndexSubTables=' + this.g69_1 + ', colorRef=' + this.h69_1 + ', hori=' + this.i69_1.toString() + ', vert=' + this.j69_1.toString() + ', startGlyphIndex=' + this.k69_1 + ', endGlyphIndex=' + this.l69_1 + ', ppemX=' + this.m69_1 + ', ppemY=' + this.n69_1 + ', bitDepth=' + this.o69_1 + ', flags=' + this.p69_1 + ')';
  }
  hashCode() {
    var result = this.e69_1;
    result = imul(result, 31) + this.f69_1 | 0;
    result = imul(result, 31) + this.g69_1 | 0;
    result = imul(result, 31) + this.h69_1 | 0;
    result = imul(result, 31) + this.i69_1.hashCode() | 0;
    result = imul(result, 31) + this.j69_1.hashCode() | 0;
    result = imul(result, 31) + this.k69_1 | 0;
    result = imul(result, 31) + this.l69_1 | 0;
    result = imul(result, 31) + this.m69_1 | 0;
    result = imul(result, 31) + this.n69_1 | 0;
    result = imul(result, 31) + this.o69_1 | 0;
    result = imul(result, 31) + this.p69_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.e69_1 === tmp0_other_with_cast.e69_1))
      return false;
    if (!(this.f69_1 === tmp0_other_with_cast.f69_1))
      return false;
    if (!(this.g69_1 === tmp0_other_with_cast.g69_1))
      return false;
    if (!(this.h69_1 === tmp0_other_with_cast.h69_1))
      return false;
    if (!this.i69_1.equals(tmp0_other_with_cast.i69_1))
      return false;
    if (!this.j69_1.equals(tmp0_other_with_cast.j69_1))
      return false;
    if (!(this.k69_1 === tmp0_other_with_cast.k69_1))
      return false;
    if (!(this.l69_1 === tmp0_other_with_cast.l69_1))
      return false;
    if (!(this.m69_1 === tmp0_other_with_cast.m69_1))
      return false;
    if (!(this.n69_1 === tmp0_other_with_cast.n69_1))
      return false;
    if (!(this.o69_1 === tmp0_other_with_cast.o69_1))
      return false;
    if (!(this.p69_1 === tmp0_other_with_cast.p69_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.q69_1 = ascender;
    this.r69_1 = descender;
    this.s69_1 = widthMax;
    this.t69_1 = caretSlopeNumerator;
    this.u69_1 = caretSlopeDenominator;
    this.v69_1 = caretOffset;
    this.w69_1 = minOriginSB;
    this.x69_1 = minAdvanceSB;
    this.y69_1 = maxBeforeBL;
    this.z69_1 = minAfterBL;
    this.a6a_1 = pad1;
    this.b6a_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.q69_1 + ', descender=' + this.r69_1 + ', widthMax=' + this.s69_1 + ', caretSlopeNumerator=' + this.t69_1 + ', caretSlopeDenominator=' + this.u69_1 + ', caretOffset=' + this.v69_1 + ', minOriginSB=' + this.w69_1 + ', minAdvanceSB=' + this.x69_1 + ', maxBeforeBL=' + this.y69_1 + ', minAfterBL=' + this.z69_1 + ', pad1=' + this.a6a_1 + ', pad2=' + this.b6a_1 + ')';
  }
  hashCode() {
    var result = this.q69_1;
    result = imul(result, 31) + this.r69_1 | 0;
    result = imul(result, 31) + this.s69_1 | 0;
    result = imul(result, 31) + this.t69_1 | 0;
    result = imul(result, 31) + this.u69_1 | 0;
    result = imul(result, 31) + this.v69_1 | 0;
    result = imul(result, 31) + this.w69_1 | 0;
    result = imul(result, 31) + this.x69_1 | 0;
    result = imul(result, 31) + this.y69_1 | 0;
    result = imul(result, 31) + this.z69_1 | 0;
    result = imul(result, 31) + this.a6a_1 | 0;
    result = imul(result, 31) + this.b6a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.q69_1 === tmp0_other_with_cast.q69_1))
      return false;
    if (!(this.r69_1 === tmp0_other_with_cast.r69_1))
      return false;
    if (!(this.s69_1 === tmp0_other_with_cast.s69_1))
      return false;
    if (!(this.t69_1 === tmp0_other_with_cast.t69_1))
      return false;
    if (!(this.u69_1 === tmp0_other_with_cast.u69_1))
      return false;
    if (!(this.v69_1 === tmp0_other_with_cast.v69_1))
      return false;
    if (!(this.w69_1 === tmp0_other_with_cast.w69_1))
      return false;
    if (!(this.x69_1 === tmp0_other_with_cast.x69_1))
      return false;
    if (!(this.y69_1 === tmp0_other_with_cast.y69_1))
      return false;
    if (!(this.z69_1 === tmp0_other_with_cast.z69_1))
      return false;
    if (!(this.a6a_1 === tmp0_other_with_cast.a6a_1))
      return false;
    if (!(this.b6a_1 === tmp0_other_with_cast.b6a_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.c6a_1 = glyphID;
    this.d6a_1 = imageFormat;
    this.e6a_1 = offset;
    this.f6a_1 = size;
    this.g6a_1 = info;
    this.h6a_1 = height;
    this.i6a_1 = width;
    this.j6a_1 = horiBearingX;
    this.k6a_1 = horiBearingY;
    this.l6a_1 = horiAdvance;
    this.m6a_1 = vertBearingX;
    this.n6a_1 = vertBearingY;
    this.o6a_1 = vertAdvance;
    this.p6a_1 = null;
    this.q6a_1 = null;
  }
  r6a() {
    return this.g6a_1.i69_1.r69_1;
  }
  s6a(cache) {
    var tmp0_elvis_lhs = this.q6a_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().w6a(toSyncStream(ensureNotNull(this.p6a_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.q6a_1 = bmp;
    return bmp;
  }
  x6a(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.s6a(cache) : $super.s6a.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.c6a_1 + ', imageFormat=' + this.d6a_1 + ', offset=' + this.e6a_1 + ', size=' + this.f6a_1 + ', info=' + this.g6a_1.toString() + ', height=' + this.h6a_1 + ', width=' + this.i6a_1 + ', horiBearingX=' + this.j6a_1 + ', horiBearingY=' + this.k6a_1 + ', horiAdvance=' + this.l6a_1 + ', vertBearingX=' + this.m6a_1 + ', vertBearingY=' + this.n6a_1 + ', vertAdvance=' + this.o6a_1 + ')';
  }
  hashCode() {
    var result = this.c6a_1;
    result = imul(result, 31) + this.d6a_1 | 0;
    result = imul(result, 31) + this.e6a_1 | 0;
    result = imul(result, 31) + this.f6a_1 | 0;
    result = imul(result, 31) + this.g6a_1.hashCode() | 0;
    result = imul(result, 31) + this.h6a_1 | 0;
    result = imul(result, 31) + this.i6a_1 | 0;
    result = imul(result, 31) + this.j6a_1 | 0;
    result = imul(result, 31) + this.k6a_1 | 0;
    result = imul(result, 31) + this.l6a_1 | 0;
    result = imul(result, 31) + this.m6a_1 | 0;
    result = imul(result, 31) + this.n6a_1 | 0;
    result = imul(result, 31) + this.o6a_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.c6a_1 === tmp0_other_with_cast.c6a_1))
      return false;
    if (!(this.d6a_1 === tmp0_other_with_cast.d6a_1))
      return false;
    if (!(this.e6a_1 === tmp0_other_with_cast.e6a_1))
      return false;
    if (!(this.f6a_1 === tmp0_other_with_cast.f6a_1))
      return false;
    if (!this.g6a_1.equals(tmp0_other_with_cast.g6a_1))
      return false;
    if (!(this.h6a_1 === tmp0_other_with_cast.h6a_1))
      return false;
    if (!(this.i6a_1 === tmp0_other_with_cast.i6a_1))
      return false;
    if (!(this.j6a_1 === tmp0_other_with_cast.j6a_1))
      return false;
    if (!(this.k6a_1 === tmp0_other_with_cast.k6a_1))
      return false;
    if (!(this.l6a_1 === tmp0_other_with_cast.l6a_1))
      return false;
    if (!(this.m6a_1 === tmp0_other_with_cast.m6a_1))
      return false;
    if (!(this.n6a_1 === tmp0_other_with_cast.n6a_1))
      return false;
    if (!(this.o6a_1 === tmp0_other_with_cast.o6a_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.y6a_1 = cycle;
    this.z6a_1 = stops;
  }
  a6b(paint, palette) {
    var _iterator__ex2g4s = this.z6a_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var stop = _iterator__ex2g4s.d1();
      paint.c6c(stop.b6b_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.s5n_1, stop.c6b_1), stop.d6b_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.y6a_1.toString() + ', stops=' + toString_0(this.z6a_1) + ')';
  }
  hashCode() {
    var result = this.y6a_1.hashCode();
    result = imul(result, 31) + hashCode(this.z6a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.y6a_1.equals(tmp0_other_with_cast.y6a_1))
      return false;
    if (!equals(this.z6a_1, tmp0_other_with_cast.z6a_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.b6b_1 = stopOffset;
    this.c6b_1 = paletteIndex;
    this.d6b_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.f6c_1 = this.p3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.g6c_1 = layerList;
    this.h6c_1 = s;
    this.i6c_1 = sBaseOffset;
    this.j6c_1 = sLayerOffset;
    this.k6c_1 = sClipOffset;
    this.l6c_1 = IntIntMap.t41();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.m6c_1 = x;
    this.n6c_1 = y;
    this.o6c_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.m6c_1 + ', y=' + this.n6c_1 + ', onCurve=' + this.o6c_1 + ')';
  }
  hashCode() {
    var result = this.m6c_1;
    result = imul(result, 31) + this.n6c_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o6c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.m6c_1 === tmp0_other_with_cast.m6c_1))
      return false;
    if (!(this.n6c_1 === tmp0_other_with_cast.n6c_1))
      return false;
    if (!(this.o6c_1 === tmp0_other_with_cast.o6c_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.p6c_1 = glyph;
    this.q6c_1 = x;
    this.r6c_1 = y;
    this.s6c_1 = scaleX;
    this.t6c_1 = scale01;
    this.u6c_1 = scale10;
    this.v6c_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.p6c_1) + ', x=' + this.q6c_1 + ', y=' + this.r6c_1 + ', scaleX=' + this.s6c_1 + ', scale01=' + this.t6c_1 + ', scale10=' + this.u6c_1 + ', scaleY=' + this.v6c_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.p6c_1);
    result = imul(result, 31) + this.q6c_1 | 0;
    result = imul(result, 31) + this.r6c_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.s6c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t6c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u6c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v6c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.p6c_1, tmp0_other_with_cast.p6c_1))
      return false;
    if (!(this.q6c_1 === tmp0_other_with_cast.q6c_1))
      return false;
    if (!(this.r6c_1 === tmp0_other_with_cast.r6c_1))
      return false;
    if (!equals(this.s6c_1, tmp0_other_with_cast.s6c_1))
      return false;
    if (!equals(this.t6c_1, tmp0_other_with_cast.t6c_1))
      return false;
    if (!equals(this.u6c_1, tmp0_other_with_cast.u6c_1))
      return false;
    if (!equals(this.v6c_1, tmp0_other_with_cast.v6c_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.y6c_1 = $outer;
    this.w6c_1 = glyphID;
    this.x6c_1 = paletteIndex;
  }
  z6c(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.y6c_1.s65_1, pal).s5n_1);
    var index = this.x6c_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.g1() : false) {
      tmp = this_0.h1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().a5a_1);
    }
    return tmp.o5p_1;
  }
  a6d() {
    return this.z6c(0);
  }
  b6d(pal) {
    var tmp135_safe_receiver = this.y6c_1.a68(this.w6c_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.d3e();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.l6d_1, null, new RGBA(this.z6c(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.w6c_1 + ', ' + this.x6c_1 + ', ' + RGBA__toString_impl_4lw6dp(this.a6d()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.m6d(pal) : $super.m6d.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.q6d_1 = $outer;
    this.o6d_1 = glyphID;
    this.p6d_1 = paint;
  }
  m6d(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.q6d_1.t65_1.i6c_1.g30(this.p6d_1);
    try {
      this.q6d_1.n67(this.o6d_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.c5x();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.o6d_1 + '][' + this.p6d_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.u6d_1 = $outer;
    this.r6d_1 = glyphID;
    this.s6d_1 = firstLayerIndex;
    this.t6d_1 = numLayers;
  }
  h1(index) {
    return this.u6d_1.q65_1[this.s6d_1 + index | 0];
  }
  n62() {
    var tmp = 0;
    var tmp_0 = this.t6d_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.h1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  m6d(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.n62();
    var destination = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.b6d(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.r6d_1 + '][' + this.t6d_1 + '](' + toString_0(this.n62()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.k6d_1 = glpyhIndex;
    this.l6d_1 = path;
  }
  k4p(p) {
    this.l6d_1.k4p(p);
  }
  x4p(p) {
    this.l6d_1.x4p(p);
  }
  y4p(c, a) {
    this.l6d_1.y4p(c, a);
  }
  l4p(c1, c2, a) {
    this.l6d_1.l4p(c1, c2, a);
  }
  p6() {
    this.l6d_1.p6();
  }
  w4y(p0, p1) {
    this.l6d_1.w4y(p0, p1);
  }
  x4y(rect) {
    this.l6d_1.x4y(rect);
  }
  y4y(pos, size) {
    this.l6d_1.y4y(pos, size);
  }
  z4y(x, y, width, height) {
    this.l6d_1.z4y(x, y, width, height);
  }
  a4z(x, y, width, height) {
    this.l6d_1.a4z(x, y, width, height);
  }
  b4z(center, r, start, end, counterclockwise) {
    this.l6d_1.b4z(center, r, start, end, counterclockwise);
  }
  d4z(center, radius) {
    this.l6d_1.d4z(center, radius);
  }
  e4z(delta) {
    this.l6d_1.e4z(delta);
  }
  f4z(delta) {
    this.l6d_1.f4z(delta);
  }
  m3r(m) {
    return this.l6d_1.m3r(m);
  }
  u4y() {
    return this.l6d_1.u4y();
  }
  v4y() {
    return this.l6d_1.t4p_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.k6d_1 + ', "' + toSvgPathString(this.l6d_1) + '")';
  }
  hashCode() {
    var result = this.k6d_1;
    result = imul(result, 31) + this.l6d_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.k6d_1 === tmp0_other_with_cast.k6d_1))
      return false;
    if (!this.l6d_1.equals(tmp0_other_with_cast.l6d_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.j6d_1 = $outer;
    this.c6d_1 = index;
    this.d6d_1 = xMin;
    this.e6d_1 = yMin;
    this.f6d_1 = xMax;
    this.g6d_1 = yMax;
    this.h6d_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.d6d_1;
    var yMin_0 = this.e6d_1;
    var xMax_0 = this.f6d_1;
    var yMax_0 = this.g6d_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.j6d_1.t65_1.k6c_1;
      var glyphIDToClipOffset = this.j6d_1.t65_1.l6c_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.hq(this.c6d_1)) {
        var clipOffset = glyphIDToClipOffset.h1(this.c6d_1);
        tmp_0 = this.j6d_1.l67(sClipOffset.g30(clipOffset));
      } else {
        var tmp137_safe_receiver = this.v6d();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.n6d();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.w6d();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.i3j());
        xMax_0 = numberToInt(bounds.j3j());
        yMin_0 = numberToInt(bounds.d3q());
        yMax_0 = numberToInt(bounds.c3q());
      }
    }
    var size = this.j6d_1.b65_1;
    var scale = this.j6d_1.d5s(size);
    tmp.i6d_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().o3q(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.h6d_1 * scale);
  }
  v6d() {
    return this.j6d_1.r65_1.h1(this.c6d_1);
  }
  x6d() {
    return this.j6d_1.p65_1.e3(this.c6d_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.j6e_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.g6e_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.g6e_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.p6c_1.d3e().l6d_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.p6c_1.c6d_1, new VectorPath(IntArrayList.l3w(gpath.n4p_1.g1()), DoubleArrayList.f3x(gpath.o4p_1.g1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_5().c3m().w3m(item.s6c_1, item.v6c_1).c3n(item.q6c_1, -item.r6c_1 | 0);
      this_1.l6d_1.l4z(item.p6c_1.d3e().l6d_1, m);
      destination.h(this_1);
    }
    tmp.h6e_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.h6e_1;
    var n = 0;
    while (n < this_2.g1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.h1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.l6d_1.n4p_1.g1() | 0;
      dataSize = dataSize + gpath_0.l6d_1.o4p_1.g1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.l3w(commandsSize), DoubleArrayList.f3x(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.h6e_1;
    var n_0 = 0;
    while (n_0 < this_4.g1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.h1(_unary__edvuaz_0);
      this_3.l6d_1.m4z(it.l6d_1);
    }
    tmp_0.i6e_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.h6d_1 + '](' + toString_0(this.g6e_1) + ')';
  }
  d3e() {
    return this.i6e_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.u6e_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.s6e_1 = path;
    this.t6e_1 = listOf_0(this.s6e_1);
  }
  d3e() {
    return this.s6e_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.k6f_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.d6f_1 = contoursIndices;
    this.e6f_1 = flags;
    this.f6f_1 = xPos;
    this.g6f_1 = yPos;
    this.h6f_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.k6f_1;
    var inductionVariable = 0;
    var last = this.d6f_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.d6f_1[n] + 1 | 0;
        var cend = this.d6f_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.l3w(commandSize), DoubleArrayList.f3x(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.k6f_1;
    var inductionVariable_0 = 0;
    var last_0 = this.d6f_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.d6f_1[n_0] + 1 | 0;
        var cend_0 = this.d6f_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.l6f(cend_0, this_1.x63_1[0]);
        var next = this.l6f(cstart_0, this_1.x63_1[1]);
        if (curr.o6c_1) {
          this_0.k4p(Vector2D.k3l(curr.m6c_1, -curr.n6c_1 | 0));
        } else if (next.o6c_1) {
          this_0.k4p(Vector2D.k3l(next.m6c_1, -next.n6c_1 | 0));
        } else {
          this_0.k4p(Vector2D.k3l(imul(curr.m6c_1 + next.m6c_1 | 0, numberToInt(0.5)), -numberToInt((curr.n6c_1 + next.n6c_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.l6f(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.x63_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.o6c_1) {
              this_0.x4p(Vector2D.k3l(curr.m6c_1, -curr.n6c_1 | 0));
            } else {
              var prev2X = prev.m6c_1;
              var prev2Y = prev.n6c_1;
              var next2X = next.m6c_1;
              var next2Y = next.n6c_1;
              if (!prev.o6c_1) {
                prev2X = numberToInt((curr.m6c_1 + prev.m6c_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.n6c_1 + prev.n6c_1 | 0) * 0.5);
                this_0.x4p(Vector2D.k3l(prev2X, -prev2Y | 0));
              }
              if (!next.o6c_1) {
                next2X = numberToInt((curr.m6c_1 + next.m6c_1 | 0) * 0.5);
                next2Y = numberToInt((curr.n6c_1 + next.n6c_1 | 0) * 0.5);
              }
              this_0.x4p(Vector2D.k3l(prev2X, -prev2Y | 0));
              this_0.y4p(Vector2D.k3l(curr.m6c_1, -curr.n6c_1 | 0), Vector2D.k3l(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.p6();
      }
       while (inductionVariable_0 < last_0);
    tmp.i6f_1 = this_0;
    this.j6f_1 = listOf_0(this.i6f_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.h6f_1 ? 'Dummy' : '') + '[' + this.c6d_1 + '](advance=' + this.h6d_1 + ') : ' + this.i6f_1.toString();
  }
  m6f(n) {
    return !((this.e6f_1[n] & 1) === 0);
  }
  l6f(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.m6c_1 = this.f6f_1[n];
    out.n6c_1 = this.g6f_1[n];
    out.o6c_1 = this.m6f(n);
    return out;
  }
  d3e() {
    return this.i6f_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.n6f_1 = firstGlyphIndex;
    this.o6f_1 = lastGlyphIndex;
    this.p6f_1 = additionalOffsetToIndexSubtable;
  }
  q6f() {
    return this.o6f_1 - this.n6f_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.n6f_1 + ', lastGlyphIndex=' + this.o6f_1 + ', additionalOffsetToIndexSubtable=' + this.p6f_1 + ')';
  }
  hashCode() {
    var result = this.n6f_1;
    result = imul(result, 31) + this.o6f_1 | 0;
    result = imul(result, 31) + this.p6f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.n6f_1 === tmp0_other_with_cast.n6f_1))
      return false;
    if (!(this.o6f_1 === tmp0_other_with_cast.o6f_1))
      return false;
    if (!(this.p6f_1 === tmp0_other_with_cast.p6f_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.r6f_1 = ppem;
    this.s6f_1 = ppi;
    this.t6f_1 = strikeOffset;
    this.u6f_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.r6f_1 + ', ppi=' + this.s6f_1 + ', strikeOffset=' + this.t6f_1 + ', offsets=' + this.u6f_1.toString() + ')';
  }
  hashCode() {
    var result = this.r6f_1;
    result = imul(result, 31) + this.s6f_1 | 0;
    result = imul(result, 31) + this.t6f_1 | 0;
    result = imul(result, 31) + this.u6f_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.r6f_1 === tmp0_other_with_cast.r6f_1))
      return false;
    if (!(this.s6f_1 === tmp0_other_with_cast.s6f_1))
      return false;
    if (!(this.t6f_1 === tmp0_other_with_cast.t6f_1))
      return false;
    if (!this.u6f_1.equals(tmp0_other_with_cast.u6f_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.v6f_1 = start;
    this.w6f_1 = endInclusive;
    this.x6f_1 = index;
    this.y6f_1 = (this.w6f_1 - this.v6f_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.v6f_1 + ', endInclusive=' + this.w6f_1 + ', index=' + this.x6f_1 + ')';
  }
  hashCode() {
    var result = this.v6f_1;
    result = imul(result, 31) + this.w6f_1 | 0;
    result = imul(result, 31) + this.x6f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.v6f_1 === tmp0_other_with_cast.v6f_1))
      return false;
    if (!(this.w6f_1 === tmp0_other_with_cast.w6f_1))
      return false;
    if (!(this.x6f_1 === tmp0_other_with_cast.x6f_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.z6f_1 = platformId;
    this.a6g_1 = encodingId;
    this.b6g_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.z6f_1 + ', encodingId=' + this.a6g_1 + ', offset=' + this.b6g_1 + ')';
  }
  hashCode() {
    var result = this.z6f_1;
    result = imul(result, 31) + this.a6g_1 | 0;
    result = imul(result, 31) + this.b6g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.z6f_1 === tmp0_other_with_cast.z6f_1))
      return false;
    if (!(this.a6g_1 === tmp0_other_with_cast.a6g_1))
      return false;
    if (!(this.b6g_1 === tmp0_other_with_cast.b6g_1))
      return false;
    return true;
  }
}
class Companion_19 {
  d6g(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_20 {
  c3m() {
    return new Mixin_0();
  }
}
class Mixin_0 {
  constructor() {
    this.k6g_1 = null;
    this.l6g_1 = Colors_getInstance().d58_1;
  }
  m6g(_set____db54di) {
    this.k6g_1 = _set____db54di;
  }
  n6g(_set____db54di) {
    this.l6g_1 = _set____db54di;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.o6g_1 = function_0;
  }
  vj(a, b) {
    return this.o6g_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.o6g_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class AseCell {}
function resolve() {
  return this;
}
class AseBitmapCell {
  constructor(bmp, x, y, opacity) {
    this.e6h_1 = Companion_instance_27.c3m();
    this.f6h_1 = bmp;
    this.g6h_1 = x;
    this.h6h_1 = y;
    this.i6h_1 = opacity;
  }
  m6g(_set____db54di) {
    this.e6h_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.e6h_1.n6g(_set____db54di);
  }
  a5r() {
    return this.f6h_1;
  }
  b6h() {
    return this.g6h_1;
  }
  c6h() {
    return this.h6h_1;
  }
}
class AseLinkedCell {
  constructor(linkedCell, x, y, opacity) {
    this.j6h_1 = Companion_instance_27.c3m();
    this.k6h_1 = linkedCell;
    this.l6h_1 = x;
    this.m6h_1 = y;
    this.n6h_1 = opacity;
  }
  m6g(_set____db54di) {
    this.j6h_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.j6h_1.n6g(_set____db54di);
  }
  b6h() {
    return this.l6h_1;
  }
  c6h() {
    return this.m6h_1;
  }
  a5r() {
    return this.k6h_1.a5r();
  }
  d6h() {
    return this.k6h_1.d6h();
  }
}
class AseTilemapCell {
  constructor(data, tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity) {
    this.o6h_1 = Companion_instance_27.c3m();
    this.p6h_1 = data;
    this.q6h_1 = tileBitmask;
    this.r6h_1 = bitmaskXFlip;
    this.s6h_1 = bitmaskYFlip;
    this.t6h_1 = bitmask90CWFlip;
    this.u6h_1 = x;
    this.v6h_1 = y;
    this.w6h_1 = opacity;
    this.x6h_1 = Bitmap32.k56(1, 1, VOID, true);
  }
  m6g(_set____db54di) {
    this.o6h_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.o6h_1.n6g(_set____db54di);
  }
  b6h() {
    return this.u6h_1;
  }
  c6h() {
    return this.v6h_1;
  }
  a5r() {
    return this.x6h_1;
  }
}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.m6l_1 = index;
    this.n6l_1 = name;
    this.o6l_1 = type;
  }
}
class AseLayer extends ImageLayer {
  constructor(originalAseIndex, index, name, flags, type, childLevel, blendModeInt, opacity, tilesetIndex) {
    super(index, name, type);
    this.b6i_1 = Companion_instance_27.c3m();
    this.c6i_1 = originalAseIndex;
    this.d6i_1 = flags;
    this.e6i_1 = childLevel;
    this.f6i_1 = blendModeInt;
    this.g6i_1 = opacity;
    this.h6i_1 = tilesetIndex;
    this.i6i_1 = hasBitSet(this.d6i_1, 0);
    this.j6i_1 = hasBitSet(this.d6i_1, 1);
    this.k6i_1 = hasBitSet(this.d6i_1, 2);
    this.l6i_1 = hasBitSet(this.d6i_1, 3);
    this.m6i_1 = hasBitSet(this.d6i_1, 4);
    this.n6i_1 = hasBitSet(this.d6i_1, 5);
    this.o6i_1 = hasBitSet(this.d6i_1, 6);
    var tmp = this;
    switch (this.f6i_1) {
      case 0:
        tmp.p6i_1 = BlendMode_NORMAL_getInstance();
        break;
      case 1:
        tmp.p6i_1 = BlendMode_MULTIPLY_getInstance();
        break;
      case 2:
        tmp.p6i_1 = BlendMode_SCREEN_getInstance();
        break;
      case 3:
        tmp.p6i_1 = BlendMode_OVERLAY_getInstance();
        break;
      case 4:
        tmp.p6i_1 = BlendMode_DARKEN_getInstance();
        break;
      case 5:
        tmp.p6i_1 = BlendMode_LIGHTEN_getInstance();
        break;
      case 6:
        tmp.p6i_1 = BlendMode_COLOR_DODGE_getInstance();
        break;
      case 7:
        tmp.p6i_1 = BlendMode_COLOR_BURN_getInstance();
        break;
      case 8:
        tmp.p6i_1 = BlendMode_HARD_LIGHT_getInstance();
        break;
      case 9:
        tmp.p6i_1 = BlendMode_SOFT_LIGHT_getInstance();
        break;
      case 10:
        tmp.p6i_1 = BlendMode_DIFFERENCE_getInstance();
        break;
      case 11:
        tmp.p6i_1 = BlendMode_EXCLUSION_getInstance();
        break;
      case 12:
        tmp.p6i_1 = BlendMode_HUE_getInstance();
        break;
      case 13:
        tmp.p6i_1 = BlendMode_SATURATION_getInstance();
        break;
      case 14:
        tmp.p6i_1 = BlendMode_COLOR_getInstance();
        break;
      case 15:
        tmp.p6i_1 = BlendMode_LUMINOSITY_getInstance();
        break;
      case 16:
        tmp.p6i_1 = BlendMode_ADDITION_getInstance();
        break;
      case 17:
        tmp.p6i_1 = BlendMode_SUBTRACT_getInstance();
        break;
      case 18:
        tmp.p6i_1 = BlendMode_DIVIDE_getInstance();
        break;
      default:
        tmp.p6i_1 = BlendMode_NORMAL_getInstance();
        break;
    }
  }
  m6g(_set____db54di) {
    this.b6i_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.b6i_1.n6g(_set____db54di);
  }
}
class AseFrame {
  constructor(index) {
    this.q6i_1 = Companion_instance_27.c3m();
    this.r6i_1 = index;
    this.s6i_1 = 0;
    this.t6i_1 = FastIntMap();
  }
  m6g(_set____db54di) {
    this.q6i_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.q6i_1.n6g(_set____db54di);
  }
}
class AsePalette extends Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    super(colors, names, changeStart, changeEnd);
    this.y6i_1 = Companion_instance_27.c3m();
  }
  m6g(_set____db54di) {
    this.y6i_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.y6i_1.n6g(_set____db54di);
  }
}
class AseTileset {
  constructor(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles, border) {
    border = border === VOID ? 0 : border;
    this.z6i_1 = tilesetId;
    this.a6j_1 = ntiles;
    this.b6j_1 = tileWidth;
    this.c6j_1 = tileHeight;
    this.d6j_1 = baseIndex;
    this.e6j_1 = tilesetName;
    this.f6j_1 = tiles;
    this.g6j_1 = border;
    var tmp = this;
    var tmp_0 = Companion_getInstance_55();
    // Inline function 'kotlin.also' call
    var this_0 = IntMap.a41();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.AseTileset.tileSet.<anonymous>' call
    var inductionVariable = 0;
    var last = this.f6j_1.g1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var id = n;
        this_0.u40(id, new TileSetTileInfo(id, this.f6j_1.h1(n)));
      }
       while (inductionVariable <= last);
    tmp.h6j_1 = tmp_0.j6j(this_0, VOID, VOID, this.g6j_1);
  }
  toString() {
    return 'AseTileset(tilesetId=' + this.z6i_1 + ', ntiles=' + this.a6j_1 + ', tileWidth=' + this.b6j_1 + ', tileHeight=' + this.c6j_1 + ', baseIndex=' + this.d6j_1 + ', tilesetName=' + this.e6j_1 + ', tiles=' + toString_0(this.f6j_1) + ', border=' + this.g6j_1 + ')';
  }
  hashCode() {
    var result = this.z6i_1;
    result = imul(result, 31) + this.a6j_1 | 0;
    result = imul(result, 31) + this.b6j_1 | 0;
    result = imul(result, 31) + this.c6j_1 | 0;
    result = imul(result, 31) + this.d6j_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.e6j_1) | 0;
    result = imul(result, 31) + hashCode(this.f6j_1) | 0;
    result = imul(result, 31) + this.g6j_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AseTileset))
      return false;
    var tmp0_other_with_cast = other instanceof AseTileset ? other : THROW_CCE();
    if (!(this.z6i_1 === tmp0_other_with_cast.z6i_1))
      return false;
    if (!(this.a6j_1 === tmp0_other_with_cast.a6j_1))
      return false;
    if (!(this.b6j_1 === tmp0_other_with_cast.b6j_1))
      return false;
    if (!(this.c6j_1 === tmp0_other_with_cast.c6j_1))
      return false;
    if (!(this.d6j_1 === tmp0_other_with_cast.d6j_1))
      return false;
    if (!(this.e6j_1 === tmp0_other_with_cast.e6j_1))
      return false;
    if (!equals(this.f6j_1, tmp0_other_with_cast.f6j_1))
      return false;
    if (!(this.g6j_1 === tmp0_other_with_cast.g6j_1))
      return false;
    return true;
  }
}
class AseSliceKey {
  constructor(frameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY) {
    this.p6g_1 = frameIndex;
    this.q6g_1 = sliceXOrigin;
    this.r6g_1 = sliceYOrigin;
    this.s6g_1 = sliceWidth;
    this.t6g_1 = sliceHeight;
    this.u6g_1 = centerXPos;
    this.v6g_1 = centerYPos;
    this.w6g_1 = centerWidth;
    this.x6g_1 = centerHeight;
    this.y6g_1 = pivotX;
    this.z6g_1 = pivotY;
    this.a6h_1 = RectangleInt.j3r(this.q6g_1, this.r6g_1, this.s6g_1, this.t6g_1);
  }
}
class AseSlice {
  constructor(name, hasNinePatch, hasPivotInfo) {
    this.k6j_1 = Companion_instance_27.c3m();
    this.l6j_1 = name;
    this.m6j_1 = hasNinePatch;
    this.n6j_1 = hasPivotInfo;
    this.o6j_1 = FastArrayList.u28();
  }
  m6g(_set____db54di) {
    this.k6j_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.k6j_1.n6g(_set____db54di);
  }
  p6j() {
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = this.o6j_1;
    if (this_0.g1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = ASE$AseSlice$sortKeys$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
      sortWith(this_0, tmp$ret$0);
    }
  }
  q6j(index) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
    var this_0 = this.o6j_1;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this_0.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.image.format.AseSlice.getSliceForFrame.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[(this_0.g1() - n | 0) - 1 | 0];
      if (index >= it.p6g_1)
        return it;
      n = n + 1 | 0;
    }
    var tmp0_elvis_lhs = firstOrNull_0(this.o6j_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'No frames key frames for slice!';
      throw IllegalStateException.h5(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class AseTag {
  constructor(fromFrame, toFrame, directionByte, tagColor, tagName) {
    this.r6j_1 = Companion_instance_27.c3m();
    this.s6j_1 = fromFrame;
    this.t6j_1 = toFrame;
    this.u6j_1 = directionByte;
    this.v6j_1 = tagColor;
    this.w6j_1 = tagName;
    var tmp = this;
    switch (this.u6j_1) {
      case 0:
        tmp.x6j_1 = Direction_FORWARD_getInstance();
        break;
      case 1:
        tmp.x6j_1 = Direction_REVERSE_getInstance();
        break;
      case 2:
        tmp.x6j_1 = Direction_PING_PONG_getInstance();
        break;
      default:
        tmp.x6j_1 = Direction_FORWARD_getInstance();
        break;
    }
  }
  m6g(_set____db54di) {
    this.r6j_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.r6j_1.n6g(_set____db54di);
  }
}
class AseImage {
  constructor() {
    this.y6j_1 = Companion_instance_27.c3m();
    this.z6j_1 = null;
    this.a6k_1 = FastArrayList.u28();
    this.b6k_1 = FastArrayList.u28();
    this.c6k_1 = FastArrayList.u28();
    this.d6k_1 = FastArrayList.u28();
    this.e6k_1 = IntMap.a41();
    this.f6k_1 = IntMap.a41();
  }
  m6g(_set____db54di) {
    this.y6j_1.m6g(_set____db54di);
  }
  n6g(_set____db54di) {
    this.y6j_1.n6g(_set____db54di);
  }
}
class ImageFormat {
  static l6k(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.t6a_1 = mimeType;
    var tmp = $this;
    tmp.u6a_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.v6a_1 = toSet(destination);
    return $this;
  }
  h6m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u6a_1;
    decodingProps$factory();
    return this_0.w1();
  }
  i6m(s, props) {
    return this.r6k(s, props).e6o();
  }
  m6k(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.j6m(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.o6k_1 = bmp.r56_1;
      this_0.p6k_1 = bmp.s56_1;
      this_0.q6k_1 = bmp.t56_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  j6m(s, props) {
    return this.i6m(s, props).w6n();
  }
  k6m(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.m6k(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  l6m(s, props) {
    return this.j6m(s, props);
  }
  w6a(s, props, $super) {
    props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
    return $super === VOID ? this.l6m(s, props) : $super.l6m.call(this, s, props);
  }
  m6m(data, props) {
    return this.j6m(openSync(data), props);
  }
  o6m(data, props, $completion) {
    return this.m6m(data, props);
  }
  n6m(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.v6a_1) + ')';
  }
}
class ASE extends ImageFormat {
  static k6k() {
    ASE_instance = null;
    var $this = this.l6k(['ase']);
    ASE_instance = $this;
    return $this;
  }
  m6k(s, props) {
    var ss = s.z27();
    readBytesExact(ss, 4);
    if (!(readU16LE(ss) === 42464))
      return null;
    var frames = readU16LE(ss);
    var width = readU16LE(ss);
    var height = readU16LE(ss);
    var bitsPerPixel = readU16LE(ss);
    // Inline function 'kotlin.also' call
    var this_0 = new ImageInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.ASE.decodeHeader.<anonymous>' call
    this_0.q6k_1 = bitsPerPixel;
    this_0.o6k_1 = width;
    this_0.p6k_1 = height;
    return this_0;
  }
  r6k(s, props) {
    var fileSize = readS32LE(s);
    if (s.a().b2(toLong(fileSize)) < 0) {
      // Inline function 'kotlin.error' call
      var message = 'File too short';
      throw IllegalStateException.h5(toString_0(message));
    }
    if (!(readU16LE(s) === 42464)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Not an Aseprite file';
      throw IllegalStateException.h5(toString_0(message_0));
    }
    var numFrames = readU16LE(s);
    var imageWidth = readU16LE(s);
    var imageHeight = readU16LE(s);
    var bitsPerPixel = readU16LE(s);
    var bytesPerPixel = bitsPerPixel / 8 | 0;
    var flags = readU32LE(s);
    var speed = readU16LE(s);
    s.b26(4);
    s.b26(4);
    var transparentIndex = readU8(s);
    s.b26(3);
    var numColors = readU16LE(s);
    var pixelWidth = readU8(s);
    var pixelHeight = readU8(s);
    var gridX = readS16LE(s);
    var gridY = readS16LE(s);
    var gridWidth = readU16LE(s);
    var gridHeight = readU16LE(s);
    s.b26(84);
    var image = new AseImage();
    var inductionVariable = 0;
    if (inductionVariable < numFrames)
      do {
        var frameIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var bytesInFrame = readS32LE(s);
        var fs = readStream(s, bytesInFrame - 4 | 0);
        if (!(readU16LE(fs) === 61946)) {
          // Inline function 'kotlin.error' call
          var message_1 = 'Invalid ASE sprite file or error parsing';
          throw IllegalStateException.h5(toString_0(message_1));
        }
        readU16LE(fs);
        var frameDuration = readU16LE(fs);
        fs.b26(2);
        var numChunks = readS32LE(fs);
        var currentFrame = new AseFrame(frameIndex);
        image.b6k_1.h(currentFrame);
        currentFrame.s6i_1 = frameDuration;
        var lastEntity = null;
        var lastCell = null;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < numChunks)
          do {
            var nc = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var chunkSize = readS32LE(fs);
            var chunkType = readU16LE(fs);
            var cs = readStream(fs, chunkSize - 6 | 0);
            switch (chunkType) {
              case 4:
                image.z6j_1;
                break;
              case 17:
                image.z6j_1;
                break;
              case 8196:
                var flags_0 = readU16LE(cs);
                var type = Companion_getInstance_44().s6k_1[readU16LE(cs)];
                var childLevel = readU16LE(cs);
                var defaultLayerWidth = readU16LE(cs);
                var defaultLayerHeight = readU16LE(cs);
                var blendModeInt = readU16LE(cs);
                var opacity = readU8(cs);
                cs.b26(3);
                var name = this.t6k(cs);
                var tilesetIndex = type.w6k() ? readS32LE(cs) : 0;
                var layer = new AseLayer(image.a6k_1.g1(), image.a6k_1.g1(), name, flags_0, type, childLevel, blendModeInt, opacity, tilesetIndex);
                image.a6k_1.h(layer);
                lastEntity = layer;
                break;
              case 8197:
                var layerIndex = readU16LE(cs);
                var x = readS16LE(cs);
                var y = readS16LE(cs);
                var opacity_0 = readU8(cs);
                var celType = readU16LE(cs);
                cs.b26(7);
                var tmp;
                switch (celType) {
                  case 0:
                  case 2:
                    var width = readU16LE(cs);
                    var height = readU16LE(cs);
                    var data = readAvailable(cs);
                    var udata = celType === 2 ? uncompress(data, Companion_getInstance_13(), imul(imul(width, height), bytesPerPixel)) : data;
                    var tmp_0;
                    switch (bitsPerPixel) {
                      case 32:
                        // Inline function 'kotlin.also' call

                        var this_0 = Bitmap32.h5g(width, height, _RgbaArray___init__impl__oib4y4(getS32Array(udata, 0, imul(width, height), true)));
                        // Inline function 'kotlin.contracts.contract' call

                        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call

                        if (props.j6l()) {
                          this_0.y5h();
                        }

                        tmp_0 = this_0;
                        break;
                      case 8:
                        tmp_0 = Bitmap8.u5h(width, height, udata, ensureNotNull(image.z6j_1).s5n_1);
                        break;
                      default:
                        var message_2 = 'Unsupported ASE mode';
                        throw IllegalStateException.h5(toString_0(message_2));
                    }

                    var bmp = tmp_0;
                    tmp = new AseBitmapCell(bmp, x, y, opacity_0);
                    break;
                  case 1:
                    var linkFrame = readU16LE(cs);
                    // Inline function 'korlibs.datastructure.get' call

                    // Inline function 'kotlin.js.asDynamic' call

                    var tmp$ret$2 = image.b6k_1.h1(linkFrame).t6i_1.get(layerIndex);
                    var aseCell = ensureNotNull(tmp$ret$2);
                    tmp = new AseLinkedCell(aseCell, x, y, opacity_0);
                    break;
                  case 3:
                    var tilesWidth = readU16LE(cs);
                    var tilesHeight = readU16LE(cs);
                    var bitsPerTile = readU16LE(cs);
                    var tileBitmask = readS32LE(cs);
                    var bitmaskXFlip = readS32LE(cs);
                    var bitmaskYFlip = readS32LE(cs);
                    var bitmask90CWFlip = readS32LE(cs);
                    var bytesPerTile = bitsPerTile / 8 | 0;
                    cs.b26(10);
                    var compressedData = uncompress(readAvailable(cs), Companion_getInstance_13(), imul(imul(tilesWidth, tilesHeight), bytesPerTile));
                    var tmp_1;
                    if (bitsPerTile === 32) {
                      tmp_1 = getS32ArrayLE(compressedData, 0, imul(tilesWidth, tilesHeight));
                    } else {
                      var reason = 'Only supported 32-bits per tile';
                      throw NotImplementedError.je('An operation is not implemented: ' + reason);
                    }

                    var data_0 = tmp_1;
                    tmp = new AseTilemapCell(new IntArray2(tilesWidth, tilesHeight, data_0), tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity_0);
                    break;
                  default:
                    var message_3 = 'Aseprite: Unknown celType=' + celType;
                    throw IllegalStateException.h5(toString_0(message_3));
                }

                var cel = tmp;
                lastEntity = cel;
                lastCell = cel;
                if (!(cel == null)) {
                  // Inline function 'korlibs.datastructure.set' call
                  // Inline function 'kotlin.js.asDynamic' call
                  currentFrame.t6i_1.set(layerIndex, cel);
                }

                break;
              case 8198:
                var flags_1 = readS32LE(cs);
                var x_0 = _Fixed32___get_double__impl__wjoyf6(this.k6l(cs));
                var y_0 = _Fixed32___get_double__impl__wjoyf6(this.k6l(cs));
                var width_0 = _Fixed32___get_double__impl__wjoyf6(this.k6l(cs));
                var height_0 = _Fixed32___get_double__impl__wjoyf6(this.k6l(cs));
                cs.b26(16);
                break;
              case 8199:
                var type_0 = readU16LE(cs);
                var flags_2 = readU16LE(cs);
                var gamma = this.k6l(cs);
                cs.b26(8);
                break;
              case 8200:
                var nentries = readS32LE(cs);
                cs.b26(8);
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < nentries)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var entryId = readS32LE(cs);
                    cs.b26(8);
                    var externalFileName = this.t6k(cs);
                    image.e6k_1.u40(entryId, externalFileName);
                  }
                   while (inductionVariable_1 < nentries);
                break;
              case 8214:
                break;
              case 8215:
                break;
              case 8216:
                var numTags = readU16LE(cs);
                cs.b26(8);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < numTags)
                  do {
                    var tag = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var fromFrame = readU16LE(cs);
                    var toFrame = readU16LE(cs);
                    var direction = readU8(cs);
                    cs.b26(8);
                    var tagColor = RGBA__withA_impl_vogscm(this.l6l(cs), 255);
                    var tagName = this.t6k(cs);
                    var tag_0 = new AseTag(fromFrame, toFrame, direction, tagColor, tagName);
                    image.c6k_1.h(tag_0);
                  }
                   while (inductionVariable_2 < numTags);
                break;
              case 8217:
                var numEntries = readS32LE(cs);
                var changeStart = readS32LE(cs);
                var changeEnd = readS32LE(cs);
                var colors = Companion_instance_13.c5i(numEntries);
                // Inline function 'kotlin.arrayOfNulls' call

                var colorNames = fillArrayVal(Array(numEntries), null);
                cs.b26(8);
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < numEntries)
                  do {
                    var ncol = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var flags_3 = readU16LE(cs);
                    var rgba = this.l6l(cs);
                    var name_0 = hasBitSet(flags_3, 0) ? this.t6k(cs) : null;
                    RgbaArray__set_impl_epw2wg(colors, ncol, rgba);
                    colorNames[ncol] = name_0;
                  }
                   while (inductionVariable_3 < numEntries);
                image.z6j_1 = new AsePalette(colors, colorNames, changeStart, changeEnd);
                lastEntity = image.z6j_1;
                break;
              case 8224:
                var flags_4 = readS32LE(cs);
                if (hasBitSet(flags_4, 0)) {
                  var tmp149_safe_receiver = lastEntity;
                  if (tmp149_safe_receiver == null)
                    null;
                  else {
                    tmp149_safe_receiver.m6g(this.t6k(cs));
                  }
                }

                if (hasBitSet(flags_4, 1)) {
                  var tmp150_safe_receiver = lastEntity;
                  if (tmp150_safe_receiver == null)
                    null;
                  else {
                    tmp150_safe_receiver.n6g(this.l6l(cs));
                  }
                }

                break;
              case 8226:
                var numSliceKeys = readS32LE(cs);
                var sliceFlags = readS32LE(cs);
                cs.b26(4);
                var sliceName = this.t6k(cs);
                var hasNinePatch = hasBitSet(sliceFlags, 0);
                var hasPivotInfo = hasBitSet(sliceFlags, 1);
                var slice_1 = new AseSlice(sliceName, hasNinePatch, hasPivotInfo);
                image.d6k_1.h(slice_1);
                lastEntity = slice_1;
                var inductionVariable_4 = 0;
                if (inductionVariable_4 < numSliceKeys)
                  do {
                    var nsk = inductionVariable_4;
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    var sliceFrameIndex = readS32LE(cs);
                    var sliceXOrigin = readS32LE(cs);
                    var sliceYOrigin = readS32LE(cs);
                    var sliceWidth = readS32LE(cs);
                    var sliceHeight = readS32LE(cs);
                    var centerXPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerYPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerWidth = hasNinePatch ? readS32LE(cs) : sliceWidth;
                    var centerHeight = hasNinePatch ? readS32LE(cs) : sliceHeight;
                    var pivotX = hasPivotInfo ? readS32LE(cs) : 0;
                    var pivotY = hasPivotInfo ? readS32LE(cs) : 0;
                    slice_1.o6j_1.h(new AseSliceKey(sliceFrameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY));
                  }
                   while (inductionVariable_4 < numSliceKeys);
                break;
              case 8227:
                var tilesetId = readS32LE(cs);
                var tilesetFlags = readS32LE(cs);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeLinkToExternalFile = !(((tilesetFlags >>> 0 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeTilesInsideThisFile = !(((tilesetFlags >>> 1 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var tile0IsEmpty = !(((tilesetFlags >>> 2 | 0) & 1) === 0);
                var ntiles = readS32LE(cs);
                var tileWidth = readU16LE(cs);
                var tileHeight = readU16LE(cs);
                var baseIndex = readS16LE(cs);
                cs.b26(14);
                var tilesetName = this.t6k(cs);
                // Inline function 'kotlin.collections.listOf' call

                var tiles = emptyList();
                if (includeLinkToExternalFile) {
                  var externalFileId = readS32LE(cs);
                  var externalTilesetId = readS32LE(cs);
                }

                if (includeTilesInsideThisFile) {
                  var compressedDataLength = readS32LE(cs);
                  var compressedData_0 = readBytesExact(cs, compressedDataLength);
                  var data_1 = uncompress(compressedData_0, Companion_getInstance_13());
                  var ints = getS32ArrayLE(data_1, 0, imul(imul(tileWidth, tileHeight), ntiles));
                  // Inline function 'kotlin.also' call
                  var this_1 = Bitmap32.h5g(tileWidth, imul(tileHeight, ntiles), _RgbaArray___init__impl__oib4y4(ints));
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
                  if (props.j6l()) {
                    this_1.y5h();
                  }
                  var bitmap = this_1;
                  tiles = splitInRows(slice_0(bitmap), tileWidth, tileHeight);
                }

                image.f6k_1.u40(tilesetId, new AseTileset(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles, get_tilesetBorder(props)));
                break;
              default:
                println('WARNING: Aseprite: Not implemented chunkType=' + get_hex(chunkType));
                break;
            }
          }
           while (inductionVariable_0 < numChunks);
      }
       while (inductionVariable < numFrames);
    var imageLayers = image.a6k_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.z();
    var tmp0_iterator = imageLayers.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var shouldProcess = get_onlyReadVisibleLayers(props) ? element.i6i_1 : true;
      var tmp_2;
      if (shouldProcess) {
        var tmp_3 = ASE_getInstance();
        var tmp_4 = element.n6l_1;
        tmp_2 = takeLayersByName(props, tmp_3, (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        destination.h(element);
      }
    }
    var imageLayersToProcess = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_2 = image.b6k_1;
    var destination_0 = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this_2.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = toLinkedMap(element_0.t6i_1);
      var destination_1 = LinkedHashMap.wc();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = this_3.u1().b1();
      while (tmp0_iterator_1.c1()) {
        var element_1 = tmp0_iterator_1.d1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var shouldProcess_0 = get_onlyReadVisibleLayers(props) ? imageLayers.h1(element_1.v1()).i6i_1 : true;
        var tmp_5;
        if (shouldProcess_0) {
          var tmp_6 = ASE_getInstance();
          var tmp_7 = imageLayers.h1(element_1.v1()).n6l_1;
          tmp_5 = takeLayersByName(props, tmp_6, (!(tmp_7 == null) ? typeof tmp_7 === 'string' : false) ? tmp_7 : THROW_CCE());
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          destination_1.k3(element_1.v1(), element_1.w1());
        }
      }
      var cells = destination_1;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList.w(cells.g1());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = cells.u1().b1();
      while (tmp0_iterator_2.c1()) {
        var item = tmp0_iterator_2.d1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.v1();
        // Inline function 'kotlin.collections.component2' call
        var value = item.w1();
        var tmp$ret$23 = readImageContainer$createImageFrameLayer(imageLayers, image, key, value);
        destination_2.h(tmp$ret$23);
      }
      var layerData = destination_2;
      var tmp_8;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!layerData.j1()) {
        // Inline function 'korlibs.time.milliseconds' call
        var this_4 = element_0.s6i_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$28 = toDuration(this_4, DurationUnit_MILLISECONDS_getInstance());
        tmp_8 = ImageFrame.v6l(element_0.r6i_1, tmp$ret$28, layerData);
      } else {
        tmp_8 = ImageFrame.u6l(element_0.r6i_1);
      }
      var tmp0_safe_receiver = tmp_8;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.h(tmp0_safe_receiver);
      }
    }
    var frames = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_5 = image.c6k_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_3 = this_5.b1();
    while (tmp0_iterator_3.c1()) {
      var item_0 = tmp0_iterator_3.d1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var framesRange = slice(frames, numberRangeToNumber(clamp(item_0.s6j_1, 0, frames.g1()), clamp(item_0.t6j_1, 0, frames.g1() - 1 | 0)));
      var tmp$ret$33 = new ImageAnimation(framesRange, item_0.x6j_1, item_0.w6j_1);
      destination_3.h(tmp$ret$33);
    }
    var animations = destination_3;
    var defaultData = new ImageData(frames, VOID, imageWidth, imageHeight, imageLayersToProcess, animations);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_6 = image.d6k_1;
    var destination_4 = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_4 = this_6.b1();
    while (tmp0_iterator_4.c1()) {
      var element_2 = tmp0_iterator_4.d1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      element_2.p6j();
      var tmp$ret$36;
      $l$block: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator = element_2.o6j_1.b1();
        if (!iterator.c1()) {
          tmp$ret$36 = null;
          break $l$block;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue = iterator.d1().s6g_1;
        while (iterator.c1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v = iterator.d1().s6g_1;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        tmp$ret$36 = maxValue;
      }
      var tmp0_elvis_lhs = tmp$ret$36;
      var maxWidth = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var tmp$ret$39;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator_0 = element_2.o6j_1.b1();
        if (!iterator_0.c1()) {
          tmp$ret$39 = null;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue_0 = iterator_0.d1().t6g_1;
        while (iterator_0.c1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v_0 = iterator_0.d1().t6g_1;
          if (compareTo(maxValue_0, v_0) < 0) {
            maxValue_0 = v_0;
          }
        }
        tmp$ret$39 = maxValue_0;
      }
      var tmp1_elvis_lhs = tmp$ret$39;
      var maxHeight = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_7 = image.b6k_1;
      var destination_5 = ArrayList.z();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_5 = this_7.b1();
      while (tmp0_iterator_5.c1()) {
        var element_3 = tmp0_iterator_5.d1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var sliceKey = element_2.q6j(element_3.r6i_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_8 = toLinkedMap(element_3.t6i_1);
        var destination_6 = LinkedHashMap.wc();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_6 = this_8.u1().b1();
        while (tmp0_iterator_6.c1()) {
          var element_4 = tmp0_iterator_6.d1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var shouldProcess_1 = get_onlyReadVisibleLayers(props) ? imageLayers.h1(element_4.v1()).i6i_1 : true;
          var tmp_9;
          if (shouldProcess_1) {
            var tmp_10 = ASE_getInstance();
            var tmp_11 = imageLayers.h1(element_4.v1()).n6l_1;
            tmp_9 = takeLayersByName(props, tmp_10, (!(tmp_11 == null) ? typeof tmp_11 === 'string' : false) ? tmp_11 : THROW_CCE());
          } else {
            tmp_9 = false;
          }
          if (tmp_9) {
            destination_6.k3(element_4.v1(), element_4.w1());
          }
        }
        var cells_0 = destination_6;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_7 = ArrayList.w(cells_0.g1());
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_7 = cells_0.u1().b1();
        while (tmp0_iterator_7.c1()) {
          var item_1 = tmp0_iterator_7.d1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.component1' call
          var key_0 = item_1.v1();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = item_1.w1();
          var tmp$ret$49 = readImageContainer$createImageFrameLayer(imageLayers, image, key_0, value_0);
          destination_7.h(tmp$ret$49);
        }
        // Inline function 'kotlin.collections.mapTo' call
        var destination_8 = ArrayList.w(collectionSizeOrDefault(destination_7, 10));
        var tmp0_iterator_8 = destination_7.b1();
        while (tmp0_iterator_8.c1()) {
          var item_2 = tmp0_iterator_8.d1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var sliceKeyFrame = sliceKey.a6h_1;
          var sliceFrame = RectangleInt.j3r(sliceKeyFrame.f3r_1 - item_2.x6l_1 | 0, sliceKeyFrame.g3r_1 - item_2.y6l_1 | 0, sliceKeyFrame.h3r_1, sliceKeyFrame.i3r_1);
          var sslice = item_2.f6m_1.b4t(sliceFrame, item_2.f6m_1.m4r_1);
          var ninePatchSlice = element_2.m6j_1 ? asNinePatchSimple(sslice, sliceKey.u6g_1, sliceKey.v6g_1, sliceKey.u6g_1 + sliceKey.w6g_1 | 0, sliceKey.v6g_1 + sliceKey.x6g_1 | 0) : null;
          var tmp$ret$52 = new ImageFrameLayer(item_2.w6l_1, sslice, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.f3r_1 : item_2.x6l_1) - sliceKey.y6g_1 | 0, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.g3r_1 : item_2.y6l_1) - sliceKey.z6g_1 | 0, item_2.z6l_1, item_2.a6m_1, VOID, ninePatchSlice);
          destination_8.h(tmp$ret$52);
        }
        var layerData_0 = destination_8;
        var tmp_12;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!layerData_0.j1()) {
          // Inline function 'korlibs.time.milliseconds' call
          var this_9 = element_3.s6i_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$57 = toDuration(this_9, DurationUnit_MILLISECONDS_getInstance());
          tmp_12 = ImageFrame.v6l(element_3.r6i_1, tmp$ret$57, layerData_0);
        } else {
          tmp_12 = null;
        }
        var tmp0_safe_receiver_0 = tmp_12;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_5.h(tmp0_safe_receiver_0);
        }
      }
      var frames_0 = destination_5;
      var tmp_13;
      var tmp_14;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!frames_0.j1()) {
        tmp_14 = slicingEnabled(props, ASE_getInstance());
      } else {
        tmp_14 = false;
      }
      if (tmp_14) {
        // Inline function 'kotlin.collections.map' call
        var this_10 = image.c6k_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_9 = ArrayList.w(collectionSizeOrDefault(this_10, 10));
        var tmp0_iterator_9 = this_10.b1();
        while (tmp0_iterator_9.c1()) {
          var item_3 = tmp0_iterator_9.d1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var framesRange_0 = slice(frames_0, numberRangeToNumber(clamp(item_3.s6j_1, 0, frames_0.g1()), clamp(item_3.t6j_1, 0, frames_0.g1() - 1 | 0)));
          var tmp$ret$63 = new ImageAnimation(framesRange_0, item_3.x6j_1, item_3.w6j_1);
          destination_9.h(tmp$ret$63);
        }
        var animations_0 = destination_9;
        tmp_13 = new ImageData(frames_0, VOID, maxWidth, maxHeight, imageLayersToProcess, animations_0, element_2.l6j_1);
      } else {
        tmp_13 = null;
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_4.h(tmp0_safe_receiver_1);
      }
    }
    var datas = destination_4;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_10 = imageLayersToProcess.b1();
    while (tmp0_iterator_10.c1()) {
      var item_4 = tmp0_iterator_10.d1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      item_4.m6l_1 = checkIndexOverflow(tmp1);
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_15;
    if (datas.j1()) {
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      tmp_15 = listOf_0(defaultData);
    } else {
      tmp_15 = datas;
    }
    var tmp$ret$71 = tmp_15;
    return new ImageDataContainer(tmp$ret$71);
  }
  l6l(_this__u8e3s4) {
    return _RGBA___init__impl__lqpay5(readS32LE(_this__u8e3s4));
  }
  k6l(_this__u8e3s4) {
    return Companion_instance_28.g6m(readS32LE(_this__u8e3s4));
  }
  t6k(_this__u8e3s4) {
    return readString(_this__u8e3s4, readU16LE(_this__u8e3s4));
  }
}
class Companion_21 {
  g6m(raw) {
    return _Fixed32___init__impl__8jizkq(raw);
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.r6m_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.t6m_1 = destination;
  }
  h1(index) {
    var tmp0_elvis_lhs = this.t6m_1.e3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.r6m_1 = id;
    this.s6m_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.u6m_1 = Companion_getInstance_14().g26('EXIF');
  }
  v6m(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  w6m(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.v6m(ss, info, debug, $completion) : $super.v6m.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.x6m_1 = function_0;
  }
  vj(a, b) {
    return this.x6m_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.x6m_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.z();
      var tmp0_iterator = frames.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.s6l_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.b1();
      while (tmp0_iterator_0.c1()) {
        var item = tmp0_iterator_0.d1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.w6l_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.y6m_1 = frames;
    this.z6m_1 = direction;
    this.a6n_1 = name;
    this.b6n_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.y6m_1);
    tmp_1.c6n_1 = tmp0_elvis_lhs == null ? ImageFrame.u6l(0) : tmp0_elvis_lhs;
  }
}
class Companion_23 {
  d6n(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_33.e6n(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
  f6n(loopCount, layers, animations, name) {
    return new ImageData(fastArrayListOf([]), loopCount, VOID, VOID, layers, animations, name);
  }
  g6n(loopCount, layers, animations, name, $super) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    return $super === VOID ? this.f6n(loopCount, layers, animations, name) : $super.f6n.call(this, loopCount, layers, animations, name);
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.h6n_1 = function_0;
  }
  vj(a, b) {
    return this.h6n_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.h6n_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.f3u();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.g3u();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.k6n_1 = new Mixin();
    this.l6n_1 = frames;
    this.m6n_1 = loopCount;
    this.n6n_1 = width;
    this.o6n_1 = height;
    this.p6n_1 = layers;
    this.q6n_1 = animations;
    this.r6n_1 = name;
    this.s6n_1 = new ImageAnimation(this.l6n_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.q6n_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.a6n_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp_1.t6n_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.l6n_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.xc(capacity_0);
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.q3();
      destination_0.k3(tmp$ret$3, element_0);
    }
    tmp_2.u6n_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.l6n_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_4);
    tmp_3.v6n_1 = sortedWith(this_2, tmp$ret$6);
  }
  c28(_set____db54di) {
    this.k6n_1.c28(_set____db54di);
  }
  d28() {
    return this.k6n_1.d28();
  }
  w6n() {
    var tmp173_safe_receiver = firstOrNull_0(this.v6n_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.i6n();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.l6n_1) + ')';
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.b6o_1 = function_0;
  }
  vj(a, b) {
    return this.b6o_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.b6o_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class Companion_24 {
  c6o(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_30.d6n([item]);
      destination.h(tmp$ret$0);
    }
    return new ImageDataContainer(destination);
  }
  d6n(bitmaps) {
    return Companion_instance_31.c6o(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.y6n_1 = imageDatas;
    var tmp = this;
    tmp.z6n_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.a6o_1 = lazy(ImageDataContainer$default$delegate$lambda(this));
  }
  d6o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z6n_1;
    imageDatasByName$factory();
    return this_0.w1();
  }
  e6o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a6o_1;
    default$factory();
    return this_0.w1();
  }
  f6o(name) {
    return this.d6o().e3(name);
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_32 = this;
    this.x5t_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.y5t_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.z5t_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_42();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.x6k_1 = filename;
    this.y6k_1 = width;
    this.z6k_1 = height;
    this.a6l_1 = premultiplied;
    this.b6l_1 = asumePremultiplied;
    this.c6l_1 = requestedMaxSize;
    this.d6l_1 = debug;
    this.e6l_1 = preferKotlinDecoder;
    this.f6l_1 = tryNativeDecode;
    this.g6l_1 = format;
    this.h6l_1 = out;
    this.i6l_1 = extra;
  }
  c28(_set____db54di) {
    this.i6l_1 = _set____db54di;
  }
  d28() {
    return this.i6l_1;
  }
  h6m() {
    return this;
  }
  j6l() {
    var tmp0_elvis_lhs = this.a6l_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  g6o() {
    var tmp0_elvis_lhs = this.g6l_1;
    return tmp0_elvis_lhs == null ? get_RegisteredImageFormats() : tmp0_elvis_lhs;
  }
  h6o(filename) {
    return this.i6o(filename);
  }
  j6o(file) {
    return this.h6o(get_baseName(file));
  }
  k6o(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  i6o(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.x6k_1 : filename;
    width = width === VOID ? this.y6k_1 : width;
    height = height === VOID ? this.z6k_1 : height;
    premultiplied = premultiplied === VOID ? this.a6l_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.b6l_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.c6l_1 : requestedMaxSize;
    debug = debug === VOID ? this.d6l_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.e6l_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.f6l_1 : tryNativeDecode;
    format = format === VOID ? this.g6l_1 : format;
    out = out === VOID ? this.h6l_1 : out;
    extra = extra === VOID ? this.i6l_1 : extra;
    return $super === VOID ? this.k6o(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.k6o.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.x6k_1 + ', width=' + this.y6k_1 + ', height=' + this.z6k_1 + ', premultiplied=' + this.a6l_1 + ', asumePremultiplied=' + this.b6l_1 + ', requestedMaxSize=' + this.c6l_1 + ', debug=' + this.d6l_1 + ', preferKotlinDecoder=' + this.e6l_1 + ', tryNativeDecode=' + this.f6l_1 + ', format=' + toString(this.g6l_1) + ', out=' + toString(this.h6l_1) + ', extra=' + toString(this.i6l_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x6k_1);
    result = imul(result, 31) + (this.y6k_1 == null ? 0 : this.y6k_1) | 0;
    result = imul(result, 31) + (this.z6k_1 == null ? 0 : this.z6k_1) | 0;
    result = imul(result, 31) + (this.a6l_1 == null ? 0 : getBooleanHashCode(this.a6l_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b6l_1) | 0;
    result = imul(result, 31) + (this.c6l_1 == null ? 0 : this.c6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6l_1) | 0;
    result = imul(result, 31) + (this.g6l_1 == null ? 0 : hashCode(this.g6l_1)) | 0;
    result = imul(result, 31) + (this.h6l_1 == null ? 0 : hashCode(this.h6l_1)) | 0;
    result = imul(result, 31) + (this.i6l_1 == null ? 0 : hashCode(this.i6l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.x6k_1 === tmp0_other_with_cast.x6k_1))
      return false;
    if (!(this.y6k_1 == tmp0_other_with_cast.y6k_1))
      return false;
    if (!(this.z6k_1 == tmp0_other_with_cast.z6k_1))
      return false;
    if (!(this.a6l_1 == tmp0_other_with_cast.a6l_1))
      return false;
    if (!(this.b6l_1 === tmp0_other_with_cast.b6l_1))
      return false;
    if (!(this.c6l_1 == tmp0_other_with_cast.c6l_1))
      return false;
    if (!(this.d6l_1 === tmp0_other_with_cast.d6l_1))
      return false;
    if (!(this.e6l_1 === tmp0_other_with_cast.e6l_1))
      return false;
    if (!(this.f6l_1 === tmp0_other_with_cast.f6l_1))
      return false;
    if (!equals(this.g6l_1, tmp0_other_with_cast.g6l_1))
      return false;
    if (!equals(this.h6l_1, tmp0_other_with_cast.h6l_1))
      return false;
    if (!equals(this.i6l_1, tmp0_other_with_cast.i6l_1))
      return false;
    return true;
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static p6o(formats) {
    var $this = this.l6k(['']);
    $this.o6o_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static q6o(formats) {
    return this.p6o(toList_1(formats));
  }
  r6o(_set____db54di) {
    var this_0 = this.o6o_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  s6o() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.o6o_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  t6o() {
    return this.s6o();
  }
  toString() {
    return 'ImageFormats(' + this.t6o().g1() + ')' + toString_0(this.t6o());
  }
  m6k(s, props) {
    if (this.t6o().j1())
      return null;
    var _iterator__ex2g4s = this.t6o().b1();
    $l$loop_0: while (_iterator__ex2g4s.c1()) {
      var format = _iterator__ex2g4s.d1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.m6k(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  r6k(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.t6o().b1();
      while (_iterator__ex2g4s.c1()) {
        var format = _iterator__ex2g4s.d1();
        if (format.k6m(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.r6k(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.sa('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
}
class ImageFormatsMutable extends ImageFormats {
  static z6o() {
    var $this = this.q6o([]);
    $this.y6o_1 = new NonRecursiveLock();
    return $this;
  }
  static a6p(formats) {
    var $this = this.z6o();
    $this.b6p(formats.slice());
    return $this;
  }
  b6p(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.y6o_1.x35_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.r6o(minus(plus_0(this.s6o(), formats), this));
    return this;
  }
}
class Companion_26 {
  c6p(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.v6l(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice_0(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  e6n(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.c6p(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.c6p.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static u6l(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.p6l_1 = new Mixin();
    $this.q6l_1 = index;
    $this.r6l_1 = fastTime;
    $this.s6l_1 = layerData;
    $this.t6l_1 = firstOrNull_0($this.s6l_1);
    return $this;
  }
  c28(_set____db54di) {
    this.p6l_1.c28(_set____db54di);
  }
  d28() {
    return this.p6l_1.d28();
  }
  d6p() {
    return toDuration_0(this.r6l_1);
  }
  static v6l(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.u6l(index, get_fast(time), layerData);
  }
  e6p() {
    var tmp177_safe_receiver = this.t6l_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.f6m_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  f6p() {
    var tmp178_safe_receiver = this.t6l_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.x6l_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  g6p() {
    var tmp179_safe_receiver = this.t6l_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.y6l_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  j6n() {
    var tmp180_safe_receiver = this.t6l_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.z6l_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  h6p() {
    return this.d6p();
  }
  f3u() {
    return this.e6p().r4r_1;
  }
  g3u() {
    return this.e6p().s4r_1;
  }
  i6n() {
    var tmp182_safe_receiver = this.t6l_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.i6n();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  q3() {
    return this.e6p().m4r_1;
  }
  toString() {
    return 'ImageFrame(' + this.e6p().toString() + ', time=' + Duration__toString_impl_8d916b(this.d6p()) + ', targetX=' + this.f6p() + ', targetY=' + this.g6p() + ', main=' + this.j6n() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.w6l_1 = layer;
    this.x6l_1 = targetX;
    this.y6l_1 = targetY;
    this.z6l_1 = main;
    this.a6m_1 = includeInAtlas;
    this.b6m_1 = tilemap;
    this.c6m_1 = ninePatchSlice;
    this.d6m_1 = null;
    this.e6m_1 = null;
    this.f6m_1 = slice;
  }
  x6n(value) {
    this.f6m_1 = value;
    this.d6m_1 = null;
    this.e6m_1 = null;
  }
  f3u() {
    return this.f6m_1.r4r_1;
  }
  g3u() {
    return this.f6m_1.s4r_1;
  }
  x3r() {
    return this.f6m_1.x3r();
  }
  i6n() {
    if (get_bmp(this.f6m_1).r56_1 === this.f3u() && get_bmp(this.f6m_1).s56_1 === this.g3u())
      return get_bmp(this.f6m_1);
    if (this.d6m_1 == null)
      this.d6m_1 = extract_0(this.f6m_1);
    return ensureNotNull(this.d6m_1);
  }
}
class ImageInfo {
  constructor() {
    this.n6k_1 = new Mixin();
    this.o6k_1 = 0;
    this.p6k_1 = 0;
    this.q6k_1 = 8;
  }
  c28(_set____db54di) {
    this.n6k_1.c28(_set____db54di);
  }
  d28() {
    return this.n6k_1.d28();
  }
  toString() {
    var tmp = this.o6k_1;
    var tmp_0 = this.p6k_1;
    var tmp_1 = this.q6k_1;
    var tmp183_safe_receiver = this.d28();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s6k_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {
  w6k() {
    return this.equals(Type_TILEMAP_getInstance());
  }
}
class NativeImageFormatProvider {
  k6p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  e6q(_this__u8e3s4, props) {
    return this.g6q(_this__u8e3s4, props);
  }
  g6q(image, props) {
    return this.f6q(toBitmap_0(image.s54()), props);
  }
  d6q(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  o6m(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  h6q(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  n6m(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  u5k(width, height, premultiplied) {
    return BitmapNativeImage.m6q(Bitmap32.k56(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  t5k(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.u5k(bmp.r56_1, bmp.s56_1, bmp.x56_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.v56_1;
    if (true) {
      this_0.e57();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.n5e(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.n6q(bmp, Companion_getInstance_7().t3i_1);
      }finally {
        ctx.k2i();
      }
    }finally {
      result = true ? this_0.g57(rect) : 0;
    }
    return this_0;
  }
  i6q(bmp) {
    return BitmapNativeImage.c6q(bmp);
  }
  f6q(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.b6l_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.a6l_1 == null || props.a6l_1 === _this__u8e3s4.x56_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.o5e();
    if (props.b6l_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.x56_1 && props.a6l_1 === false) {
      out.z5h();
    } else if (_this__u8e3s4.x56_1 && props.a6l_1 === true) {
      out.y5h();
    }
    return this.i6q(out);
  }
  i6p(_this__u8e3s4, props) {
    return new NativeImageResult(this.f6q(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  k6p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  l6p(bmp) {
    return BitmapNativeImage.c6q(bmp);
  }
  j6p(bmp, props) {
    var bmp32 = bmp.o5e();
    return new NativeImageResult(this.l6p(props.b6l_1 ? asumePremultiplied(bmp32) : props.j6l() ? bmp32.v5h() : bmp32.w5h()));
  }
  u5k(width, height, premultiplied) {
    return this.l6p(Bitmap32.k56(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  t5k(bmp) {
    return this.l6p(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.r56_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.s56_1 : originalHeight;
    this.j6q_1 = image;
    this.k6q_1 = originalWidth;
    this.l6q_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.j6q_1.toString() + ', originalWidth=' + this.k6q_1 + ', originalHeight=' + this.l6q_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.j6q_1);
    result = imul(result, 31) + this.k6q_1 | 0;
    result = imul(result, 31) + this.l6q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.j6q_1, tmp0_other_with_cast.j6q_1))
      return false;
    if (!(this.k6q_1 === tmp0_other_with_cast.k6q_1))
      return false;
    if (!(this.l6q_1 === tmp0_other_with_cast.l6q_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static m6q(bitmap) {
    var $this = this.s5k(bitmap.r56_1, bitmap.s56_1, bitmap, bitmap.x56_1);
    $this.a6q_1 = bitmap;
    $this.b6q_1 = $this.a6q_1.h56_1;
    return $this;
  }
  q3() {
    return 'BitmapNativeImage';
  }
  static c6q(bitmap) {
    return this.m6q(bitmap.o5e());
  }
  n5e(antialiasing) {
    return this.a6q_1.n5e(antialiasing);
  }
  d57() {
    return this.a6q_1;
  }
  o57(x, y, width, height, out, offset) {
    return this.a6q_1.o57(x, y, width, height, out, offset);
  }
  q57(x, y, width, height, out, offset) {
    return this.a6q_1.q57(x, y, width, height, out, offset);
  }
  r57(x, y, v) {
    return this.a6q_1.r57(x, y, v);
  }
  p57(x, y) {
    return this.a6q_1.p57(x, y);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_6();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.q6q_1;
      destination.k3(tmp$ret$0, element);
    }
    tmp.s6q_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.t6q_1 = startingRow;
    this.u6q_1 = startingCol;
    this.v6q_1 = rowIncrement;
    this.w6q_1 = colIncrement;
    this.x6q_1 = blockHeight;
    this.y6q_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.w6q_1;
    var tmp$ret$0 = log2(x);
    tmp.z6q_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.t6q_1 + ', startingCol=' + this.u6q_1 + ', rowIncrement=' + this.v6q_1 + ', colIncrement=' + this.w6q_1 + ', blockHeight=' + this.x6q_1 + ', blockWidth=' + this.y6q_1 + ')';
  }
  hashCode() {
    var result = this.t6q_1;
    result = imul(result, 31) + this.u6q_1 | 0;
    result = imul(result, 31) + this.v6q_1 | 0;
    result = imul(result, 31) + this.w6q_1 | 0;
    result = imul(result, 31) + this.x6q_1 | 0;
    result = imul(result, 31) + this.y6q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.t6q_1 === tmp0_other_with_cast.t6q_1))
      return false;
    if (!(this.u6q_1 === tmp0_other_with_cast.u6q_1))
      return false;
    if (!(this.v6q_1 === tmp0_other_with_cast.v6q_1))
      return false;
    if (!(this.w6q_1 === tmp0_other_with_cast.w6q_1))
      return false;
    if (!(this.x6q_1 === tmp0_other_with_cast.x6q_1))
      return false;
    if (!(this.y6q_1 === tmp0_other_with_cast.y6q_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.q6q_1 = id;
    this.r6q_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.a6r_1 = width;
    this.b6r_1 = height;
    this.c6r_1 = bitsPerChannel;
    this.d6r_1 = colorspace;
    this.e6r_1 = compressionmethod;
    this.f6r_1 = filtermethod;
    this.g6r_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.d6r_1.p3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.h6r_1 = tmp_0;
    this.i6r_1 = imul(imul(this.a6r_1, this.h6r_1), this.c6r_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.j6r_1 = header;
    this.k6r_1 = _UByteArrayInt___init__impl__xif7bu_0(this.j6r_1.i6r_1);
    this.l6r_1 = _UByteArrayInt___init__impl__xif7bu_0(this.j6r_1.i6r_1);
    this.m6r_1 = Companion_instance_13.c5i(this.j6r_1.a6r_1);
  }
  w6r() {
    var temp = this.l6r_1;
    this.l6r_1 = this.k6r_1;
    this.k6r_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.x6r_1 = $data;
    this.y6r_1 = $info;
  }
  ke($completion) {
    return EXIF_getInstance().w6m(openAsync(readAll_0(this.x6r_1)), this.y6r_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static z6r() {
    PNG_instance = null;
    var $this = this.l6k(['png']);
    PNG_instance = $this;
    $this.q6r_1 = -1991225785;
    $this.r6r_1 = 218765834;
    $this.s6r_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.t6r_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  m6k(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  r6k(s, props) {
    var tmp = Companion_instance_31;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.d6n([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  a6s(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  u6r(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.a6s(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.je('An operation is not implemented: ' + reason);
    }
  }
  v6r(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.u6r(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.u6r.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  e6s(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.d6s(n, yFloat));
      }
       while (!(n === x1));
  }
  f6s(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.h56_1);
    var inductionVariable = rect.d3q();
    var last = rect.c3q();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.r56_1);
        this.e6s(cols, offset, rect.i3j(), rect.j3j() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  g6s(bmp, rect, $super) {
    rect = rect === VOID ? bmp.j56_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.f6s(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.f6s.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.b6s_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().a58_1);
  }
  c6s(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.b6s_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  d6s(x, y) {
    return this.b6s_1;
  }
  e6s(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.b6s_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_29 {
  constructor() {
    this.h6s_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.i6s_1 = Companion_instance_16.k5q(256);
  }
  k6s(fill, state) {
    fill.l6s(this.i6s_1);
    this.j6s_1 = fill.m6s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().z3l_1.n3n(fill.o6b_1).n3n(state.h5s_1));
    return this;
  }
  n6s(x, y) {
    return _get_fill__d6ivc8(this).o6s(Vector2D.m3q(x, y));
  }
  d6s(x, y) {
    return color(this, this.n6s(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.p6s_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.q6s_1 = 0.0;
    this.r6s_1 = 0.0;
    this.s6s_1 = 0.0;
    this.t6s_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.u6s_1 = get_bmp(tmp$ret$0);
    this.v6s_1 = Companion_getInstance_5().z3l_1;
    this.w6s_1 = true;
    this.x6s_1 = Companion_getInstance_5().z3l_1;
  }
  y6s(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.p6s_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.b6t_1, fill.c6t_1);
    _set_texture__qu271y(this, fill.f6t_1);
    this.v6s_1 = fill.a6t_1;
    this.w6s_1 = fill.d6t_1;
    this.x6s_1 = Companion_getInstance_5().z3l_1.g3n(state.h5s_1).g3n(fill.a6t_1).h3n();
    return this;
  }
  g6t(x, y) {
    return this.u6s_1.x57(x, y);
  }
  h6t(x, y) {
    return this.u6s_1.j5g(numberToInt(x), numberToInt(y));
  }
  d6s(x, y) {
    var mat = this.x6s_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.m3q(x, y);
      if (mat.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(mat.r3m(p.r3i_1, p.s3i_1), mat.u3m(p.r3i_1, p.s3i_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.m3q(this.s6s_1, this.t6s_1);
    var p_0 = Vector2D.y3k(this_0.r3i_1 * that.r3i_1, this_0.s3i_1 * that.s3i_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.p6s_1, p_0);
    var that_0 = Vector2D.m3q(this.q6s_1, this.r6s_1);
    var t = Vector2D.y3k(this_1.r3i_1 * that_0.r3i_1, this_1.s3i_1 * that_0.s3i_1);
    return this.w6s_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.g6t(t.r3i_1, t.s3i_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.h6t(t.r3i_1, t.s3i_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  d6s(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  e6s(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_30 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.f3x() : stops;
    colors = colors === VOID ? IntArrayList.l3w() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().z3l_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().i3i_1 : startAngle;
    this.e6b_1 = kind;
    this.f6b_1 = x0;
    this.g6b_1 = y0;
    this.h6b_1 = r0;
    this.i6b_1 = x1;
    this.j6b_1 = y1;
    this.k6b_1 = r1;
    this.l6b_1 = stops;
    this.m6b_1 = colors;
    this.n6b_1 = cycle;
    this.o6b_1 = transform;
    this.p6b_1 = interpolationMethod;
    this.q6b_1 = units;
    this.r6b_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().z3l_1.d3n(-this.f6b_1, -this.g6b_1).y3m(1.0 / clamp_1(Companion_getInstance_7().p3r(this.f6b_1, this.g6b_1, this.i6b_1, this.j6b_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.f6b_1;
    var y0_0 = this.g6b_1;
    var x1_0 = this.i6b_1;
    var y1_0 = this.j6b_1;
    var up = Companion_getInstance_7().x3i_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.s6b_1 = tmp_0.v3m(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.t6b_1 = this.o6b_1.h3n();
    this.u6b_1 = Companion_getInstance_5().z3l_1.g3n(this.s6b_1).g3n(this.t6b_1);
    this.v6b_1 = 2 * this.h6b_1 * this.k6b_1;
    this.w6b_1 = this.i6t(this.h6b_1);
    this.x6b_1 = this.i6t(this.k6b_1);
    this.y6b_1 = this.g6b_1 - this.j6b_1;
    this.z6b_1 = this.h6b_1 - this.k6b_1;
    this.a6c_1 = this.f6b_1 - this.i6b_1;
    this.b6c_1 = 1.0 / (this.i6t(this.h6b_1 - this.k6b_1) - this.i6t(this.f6b_1 - this.i6b_1) - this.i6t(this.g6b_1 - this.j6b_1));
  }
  j6t() {
    return this.o6b_1;
  }
  l6s(out) {
    return _fillColors(Companion_instance_37, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.l6b_1, this.m6b_1, true);
  }
  c6c(stop, color) {
    return this.k6t(stop, color);
  }
  k6t(stop, color) {
    this.l6b_1.l3x(stop);
    this.m6b_1.s3w(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  o6s(p) {
    var tmp;
    switch (this.e6b_1.p3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.t6b_1;
          if (this_0.g3j()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_7().a3t(Vector2D.y3k(this.f6b_1, this.g6b_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.t6b_1;
          if (this_1.g3j()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.y3k(this_1.r3m(p.r3i_1, p.s3i_1), this_1.u3m(p.r3i_1, p.s3i_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.em();
        var y = _destruct__k2r9zo.fm();
        var tmp_0 = -this.k6b_1 * this.z6b_1 + this.a6c_1 * (this.i6b_1 - x) + this.y6b_1 * (this.j6b_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.x6b_1 * (this.i6t(this.f6b_1 - x) + this.i6t(this.g6b_1 - y)) - this.v6b_1 * ((this.f6b_1 - x) * (this.i6b_1 - x) + (this.g6b_1 - y) * (this.j6b_1 - y)) + this.w6b_1 * (this.i6t(this.i6b_1 - x) + this.i6t(this.j6b_1 - y)) - this.i6t(this.i6b_1 * this.g6b_1 - x * this.g6b_1 - this.f6b_1 * this.j6b_1 + x * this.j6b_1 + this.f6b_1 * y - this.i6b_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.b6c_1;
        break;
      default:
        tmp = this.u6b_1.q3m(p);
        break;
    }
    return this.n6b_1.n6t(tmp);
  }
  i6t(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  z27() {
    return this.m6s(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.o6b_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.e6b_1.p3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.f6b_1 + ', ' + this.g6b_1 + '], [' + this.i6b_1 + ', ' + this.j6b_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.f6b_1 + ', ' + this.g6b_1 + ', ' + this.h6b_1 + '], [' + this.i6b_1 + ', ' + this.j6b_1 + ', ' + this.k6b_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.f6b_1 + ', ' + this.g6b_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.gc(tmp);
    this_0.gc(', stops=' + this.l6b_1.toString() + ', colors=' + colorsToString_0(this, this.m6b_1) + ', cycle=' + this.n6b_1.toString() + ', transform=' + this.o6b_1.toString() + ', interpolationMethod=' + this.p6b_1.toString() + ', units=' + this.q6b_1.toString() + ')');
    return this_0.toString();
  }
  o6t(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  m6s(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.e6b_1 : kind;
    x0 = x0 === VOID ? this.f6b_1 : x0;
    y0 = y0 === VOID ? this.g6b_1 : y0;
    r0 = r0 === VOID ? this.h6b_1 : r0;
    x1 = x1 === VOID ? this.i6b_1 : x1;
    y1 = y1 === VOID ? this.j6b_1 : y1;
    r1 = r1 === VOID ? this.k6b_1 : r1;
    stops = stops === VOID ? this.l6b_1 : stops;
    colors = colors === VOID ? this.m6b_1 : colors;
    cycle = cycle === VOID ? this.n6b_1 : cycle;
    transform = transform === VOID ? this.o6b_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.p6b_1 : interpolationMethod;
    units = units === VOID ? this.q6b_1 : units;
    startAngle = startAngle === VOID ? this.r6b_1 : startAngle;
    return $super === VOID ? this.o6t(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.o6t.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.e6b_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.f6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j6b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k6b_1) | 0;
    result = imul(result, 31) + this.l6b_1.hashCode() | 0;
    result = imul(result, 31) + this.m6b_1.hashCode() | 0;
    result = imul(result, 31) + this.n6b_1.hashCode() | 0;
    result = imul(result, 31) + this.o6b_1.hashCode() | 0;
    result = imul(result, 31) + this.p6b_1.hashCode() | 0;
    result = imul(result, 31) + this.q6b_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.r6b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.e6b_1.equals(tmp0_other_with_cast.e6b_1))
      return false;
    if (!equals(this.f6b_1, tmp0_other_with_cast.f6b_1))
      return false;
    if (!equals(this.g6b_1, tmp0_other_with_cast.g6b_1))
      return false;
    if (!equals(this.h6b_1, tmp0_other_with_cast.h6b_1))
      return false;
    if (!equals(this.i6b_1, tmp0_other_with_cast.i6b_1))
      return false;
    if (!equals(this.j6b_1, tmp0_other_with_cast.j6b_1))
      return false;
    if (!equals(this.k6b_1, tmp0_other_with_cast.k6b_1))
      return false;
    if (!this.l6b_1.equals(tmp0_other_with_cast.l6b_1))
      return false;
    if (!this.m6b_1.equals(tmp0_other_with_cast.m6b_1))
      return false;
    if (!this.n6b_1.equals(tmp0_other_with_cast.n6b_1))
      return false;
    if (!this.o6b_1.equals(tmp0_other_with_cast.o6b_1))
      return false;
    if (!this.p6b_1.equals(tmp0_other_with_cast.p6b_1))
      return false;
    if (!this.q6b_1.equals(tmp0_other_with_cast.q6b_1))
      return false;
    if (!equals(this.r6b_1, tmp0_other_with_cast.r6b_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  z27() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().z3l_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.z6s_1 = bitmap;
    this.a6t_1 = transform;
    this.b6t_1 = cycleX;
    this.c6t_1 = cycleY;
    this.d6t_1 = smooth;
    this.e6t_1 = units;
    this.f6t_1 = this.z6s_1.d57();
  }
  j6t() {
    return this.a6t_1;
  }
  p6t() {
    return this.b6t_1.q6t();
  }
  r6t() {
    return this.c6t_1.q6t();
  }
  z27() {
    return this.s6t(VOID, this.a6t_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.z6s_1) + ', cycle=(' + this.b6t_1.toString() + ', ' + this.c6t_1.toString() + '), smooth=' + this.d6t_1 + ', transform=' + this.a6t_1.toString() + ')';
  }
  t6t(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  s6t(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.z6s_1 : bitmap;
    transform = transform === VOID ? this.a6t_1 : transform;
    cycleX = cycleX === VOID ? this.b6t_1 : cycleX;
    cycleY = cycleY === VOID ? this.c6t_1 : cycleY;
    smooth = smooth === VOID ? this.d6t_1 : smooth;
    units = units === VOID ? this.e6t_1 : units;
    return $super === VOID ? this.t6t(bitmap, transform, cycleX, cycleY, smooth, units) : $super.t6t.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.z6s_1);
    result = imul(result, 31) + this.a6t_1.hashCode() | 0;
    result = imul(result, 31) + this.b6t_1.hashCode() | 0;
    result = imul(result, 31) + this.c6t_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6t_1) | 0;
    result = imul(result, 31) + this.e6t_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.z6s_1, tmp0_other_with_cast.z6s_1))
      return false;
    if (!this.a6t_1.equals(tmp0_other_with_cast.a6t_1))
      return false;
    if (!this.b6t_1.equals(tmp0_other_with_cast.b6t_1))
      return false;
    if (!this.c6t_1.equals(tmp0_other_with_cast.c6t_1))
      return false;
    if (!(this.d6t_1 === tmp0_other_with_cast.d6t_1))
      return false;
    if (!this.e6t_1.equals(tmp0_other_with_cast.e6t_1))
      return false;
    return true;
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp263_font = get_DefaultTtfFont();
    tmp.i6u_1 = new Style(tmp263_font, 16.0);
  }
}
class Line {
  static s6u(nodes, defaultLineStyle) {
    defaultLineStyle = defaultLineStyle === VOID ? null : defaultLineStyle;
    var $this = createThis(this);
    $this.u6t_1 = new Mixin();
    $this.v6t_1 = nodes;
    $this.w6t_1 = defaultLineStyle;
    var tmp = $this;
    tmp.x6t_1 = lazy(RichTextData$Line$defaultStyle$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.y6t_1 = lazy(RichTextData$Line$defaultLastStyle$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.z6t_1 = lazy(RichTextData$Line$text$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.a6u_1 = lazy(RichTextData$Line$width$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.b6u_1 = lazy(RichTextData$Line$maxLineHeight$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.c6u_1 = lazy(RichTextData$Line$maxHeight$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.d6u_1 = lazy(RichTextData$Line$allFonts$delegate$lambda($this));
    return $this;
  }
  c28(_set____db54di) {
    this.u6t_1.c28(_set____db54di);
  }
  d28() {
    return this.u6t_1.d28();
  }
  static t6u(nodes) {
    return this.s6u(toList_1(nodes));
  }
  k6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x6t_1;
    defaultStyle$factory();
    return this_0.w1();
  }
  u6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y6t_1;
    defaultLastStyle$factory();
    return this_0.w1();
  }
  j6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z6t_1;
    text$factory();
    return this_0.w1();
  }
  f3u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a6u_1;
    width$factory();
    return this_0.w1();
  }
  v6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b6u_1;
    maxLineHeight$factory();
    return this_0.w1();
  }
  w6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c6u_1;
    maxHeight$factory();
    return this_0.w1();
  }
  x6u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d6u_1;
    allFonts$factory();
    return this_0.w1();
  }
  y6u() {
    var out = toDeque(this.v6t_1);
    $l$loop_2: while (true) {
      var first = firstOrNull(out);
      var last = lastOrNull_1(out);
      if (first instanceof TextNode) {
        if (isBlank(first.f6u_1)) {
          out.ql();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimStart' call
        var this_0 = first.f6u_1;
        var trimmed = toString_0(trimStart(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        if (!(trimmed === first.f6u_1)) {
          out.ql();
          out.i3y(first.z6u(trimmed));
          continue $l$loop_2;
        }
      }
      if (last instanceof TextNode) {
        if (isBlank(last.f6u_1)) {
          out.sl();
          continue $l$loop_2;
        }
        // Inline function 'kotlin.text.trimEnd' call
        var this_1 = last.f6u_1;
        var trimmed_0 = toString_0(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (!(trimmed_0 === last.f6u_1)) {
          out.sl();
          out.h3y(last.z6u(trimmed_0));
          continue $l$loop_2;
        }
      }
      break $l$loop_2;
    }
    return Line.s6u(toList(out));
  }
  toString() {
    return 'Line(nodes=' + toString_0(this.v6t_1) + ', defaultLineStyle=' + toString(this.w6t_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.v6t_1);
    result = imul(result, 31) + (this.w6t_1 == null ? 0 : this.w6t_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!equals(this.v6t_1, tmp0_other_with_cast.v6t_1))
      return false;
    if (!equals(this.w6t_1, tmp0_other_with_cast.w6t_1))
      return false;
    return true;
  }
}
class Node {}
function get_lineHeight() {
  return this.g3u();
}
class Style {
  constructor(font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_48();
    textSize = textSize === VOID ? 16.0 : textSize;
    italic = italic === VOID ? false : italic;
    bold = bold === VOID ? false : bold;
    underline = underline === VOID ? false : underline;
    color = color === VOID ? null : color;
    canBreak = canBreak === VOID ? true : canBreak;
    this.l6u_1 = font;
    this.m6u_1 = textSize;
    this.n6u_1 = italic;
    this.o6u_1 = bold;
    this.p6u_1 = underline;
    this.q6u_1 = color;
    this.r6u_1 = canBreak;
  }
  a6v(font, textSize, italic, bold, underline, color, canBreak) {
    return new Style(font, textSize, italic, bold, underline, color, canBreak);
  }
  b6v(font, textSize, italic, bold, underline, color, canBreak, $super) {
    font = font === VOID ? this.l6u_1 : font;
    textSize = textSize === VOID ? this.m6u_1 : textSize;
    italic = italic === VOID ? this.n6u_1 : italic;
    bold = bold === VOID ? this.o6u_1 : bold;
    underline = underline === VOID ? this.p6u_1 : underline;
    color = color === VOID ? this.q6u_1 : color;
    canBreak = canBreak === VOID ? this.r6u_1 : canBreak;
    var tmp;
    if ($super === VOID) {
      tmp = this.a6v(font, textSize, italic, bold, underline, color, canBreak);
    } else {
      var tmp_0 = $super.a6v;
      var tmp_1 = color;
      tmp = tmp_0.call(this, font, textSize, italic, bold, underline, tmp_1 == null ? null : new RGBA(tmp_1), canBreak);
    }
    return tmp;
  }
  toString() {
    var tmp = toString_0(this.l6u_1);
    var tmp_0 = this.q6u_1;
    return 'Style(font=' + tmp + ', textSize=' + this.m6u_1 + ', italic=' + this.n6u_1 + ', bold=' + this.o6u_1 + ', underline=' + this.p6u_1 + ', color=' + toString(tmp_0 == null ? null : new RGBA(tmp_0)) + ', canBreak=' + this.r6u_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.l6u_1);
    result = imul(result, 31) + getNumberHashCode(this.m6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6u_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.q6u_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.q6u_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Style))
      return false;
    var tmp0_other_with_cast = other instanceof Style ? other : THROW_CCE();
    if (!equals(this.l6u_1, tmp0_other_with_cast.l6u_1))
      return false;
    if (!equals(this.m6u_1, tmp0_other_with_cast.m6u_1))
      return false;
    if (!(this.n6u_1 === tmp0_other_with_cast.n6u_1))
      return false;
    if (!(this.o6u_1 === tmp0_other_with_cast.o6u_1))
      return false;
    if (!(this.p6u_1 === tmp0_other_with_cast.p6u_1))
      return false;
    var tmp = this.q6u_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.q6u_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!(this.r6u_1 === tmp0_other_with_cast.r6u_1))
      return false;
    return true;
  }
}
class TextNode {
  constructor(text, style) {
    style = style === VOID ? Companion_getInstance_48().i6u_1 : style;
    this.e6u_1 = new Mixin();
    this.f6u_1 = text;
    this.g6u_1 = style;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!contains_1(this.f6u_1, _Char___init__impl__6a9atx(10))) {
      // Inline function 'korlibs.image.text.TextNode.<anonymous>' call
      var message = 'Single RichTextData nodes cannot have line breaks';
      throw IllegalArgumentException.l(toString_0(message));
    }
    var tmp = this;
    tmp.h6u_1 = lazy(RichTextData$TextNode$bounds$delegate$lambda(this));
  }
  c28(_set____db54di) {
    this.e6u_1.c28(_set____db54di);
  }
  d28() {
    return this.e6u_1.d28();
  }
  j6u() {
    return this.f6u_1;
  }
  w6d() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h6u_1;
    bounds$factory();
    return this_0.w1();
  }
  f3u() {
    return this.w6d().f3u();
  }
  o5x() {
    return this.w6d().o5x();
  }
  g3u() {
    return this.w6d().t5z();
  }
  c6v(text, style) {
    return new TextNode(text, style);
  }
  z6u(text, style, $super) {
    text = text === VOID ? this.f6u_1 : text;
    style = style === VOID ? this.g6u_1 : style;
    return $super === VOID ? this.c6v(text, style) : $super.c6v.call(this, text, style);
  }
  toString() {
    return 'TextNode(text=' + this.f6u_1 + ', style=' + this.g6u_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.f6u_1);
    result = imul(result, 31) + this.g6u_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextNode))
      return false;
    var tmp0_other_with_cast = other instanceof TextNode ? other : THROW_CCE();
    if (!(this.f6u_1 === tmp0_other_with_cast.f6u_1))
      return false;
    if (!this.g6u_1.equals(tmp0_other_with_cast.g6u_1))
      return false;
    return true;
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_39 = this;
    this.d6v_1 = Regex.pi('\\W+');
  }
  e6v(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextNode) {
      tmp = _this__u8e3s4.z6u(VOID, _this__u8e3s4.g6u_1.b6v(VOID, VOID, VOID, VOID, VOID, VOID, false));
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  f6v(maxLineWidth, line, addNode) {
    var chunk = RichTextData.n6v([Line.s6u(plus(listOf_0(this.e6v(addNode)), line.v6t_1))]).o6v(maxLineWidth, true);
    var nodes = first_0(chunk.h6v_1).v6t_1;
    return Line.s6u(plus_1(drop(nodes, 1), first_0(nodes)));
  }
  p6v(text) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return emptyList();
    var parts = this.q6v(text);
    if (parts.g1() === 1) {
      return splitInChunks(text, 1);
    } else {
      return parts;
    }
  }
  q6v(text) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = splitKeep(text, this.d6v_1);
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.text.matches' call
      if (Companion_getInstance_49().d6v_1.qi(element)) {
        // Inline function 'kotlin.text.map' call
        // Inline function 'kotlin.text.mapTo' call
        var destination_0 = ArrayList.w(charSequenceLength(element));
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(element)) {
          var item = charSequenceGet(element, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.text.Companion.tokenize.<anonymous>.<anonymous>' call
          var tmp$ret$1 = toString_1(item);
          destination_0.h(tmp$ret$1);
        }
        tmp = destination_0;
      } else {
        tmp = listOf_0(element);
      }
      var list = tmp;
      addAll(destination, list);
    }
    return destination;
  }
}
class RichTextData {
  static r6v(lines, defaultStyle) {
    Companion_getInstance_49();
    var tmp;
    if (defaultStyle === VOID) {
      var tmp260_safe_receiver = firstOrNull_0(lines);
      var tmp0_elvis_lhs = tmp260_safe_receiver == null ? null : tmp260_safe_receiver.k6u();
      tmp = tmp0_elvis_lhs == null ? Companion_getInstance_48().i6u_1 : tmp0_elvis_lhs;
    } else {
      tmp = defaultStyle;
    }
    defaultStyle = tmp;
    var $this = createThis(this);
    $this.g6v_1 = new Mixin();
    $this.h6v_1 = lines;
    $this.i6v_1 = defaultStyle;
    var tmp_0 = $this;
    tmp_0.j6v_1 = lazy(RichTextData$text$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.k6v_1 = lazy(RichTextData$width$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.l6v_1 = lazy(RichTextData$height$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.m6v_1 = lazy(RichTextData$allFonts$delegate$lambda($this));
    return $this;
  }
  c28(_set____db54di) {
    this.g6v_1.c28(_set____db54di);
  }
  d28() {
    return this.g6v_1.d28();
  }
  s6v(element) {
    return this.h6v_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof Line))
      return false;
    return this.s6v(element instanceof Line ? element : THROW_CCE());
  }
  t6v(elements) {
    return this.h6v_1.a3(elements);
  }
  a3(elements) {
    return this.t6v(elements);
  }
  h1(index) {
    return this.h6v_1.h1(index);
  }
  j1() {
    return this.h6v_1.j1();
  }
  b1() {
    return this.h6v_1.b1();
  }
  b3() {
    return this.h6v_1.b3();
  }
  k1(index) {
    return this.h6v_1.k1(index);
  }
  q1(fromIndex, toIndex) {
    return this.h6v_1.q1(fromIndex, toIndex);
  }
  g1() {
    return this.h6v_1.g1();
  }
  static n6v(lines) {
    Companion_getInstance_49();
    return this.r6v(toList_1(lines));
  }
  static u6v(text, style) {
    Companion_getInstance_49();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(text, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.text.RichTextData.<init>.<anonymous>' call
      var tmp$ret$0 = Line.t6u([new TextNode(item, style)]);
      destination.h(tmp$ret$0);
    }
    return this.r6v(destination);
  }
  static v6v(text, font, textSize, italic, bold, underline, color, canBreak) {
    Companion_getInstance_49();
    font = font === VOID ? Companion_getInstance_48().i6u_1.l6u_1 : font;
    textSize = textSize === VOID ? Companion_getInstance_48().i6u_1.m6u_1 : textSize;
    italic = italic === VOID ? Companion_getInstance_48().i6u_1.n6u_1 : italic;
    bold = bold === VOID ? Companion_getInstance_48().i6u_1.o6u_1 : bold;
    underline = underline === VOID ? Companion_getInstance_48().i6u_1.p6u_1 : underline;
    color = color === VOID ? Companion_getInstance_48().i6u_1.q6u_1 : color;
    canBreak = canBreak === VOID ? Companion_getInstance_48().i6u_1.r6u_1 : canBreak;
    return this.u6v(text, new Style(font, textSize, italic, bold, underline, color, canBreak));
  }
  y6u() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h6v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.text.RichTextData.trimSpaces.<anonymous>' call
      var tmp$ret$0 = item.y6u();
      destination.h(tmp$ret$0);
    }
    return RichTextData.r6v(destination);
  }
  w6v(maxLineWidth, maxHeight, includePartialLines, ellipsis, trimSpaces, includeFirstLineAlways) {
    var out = this;
    var removedWords = false;
    if (!(maxLineWidth === Infinity)) {
      out = out.x6v(maxLineWidth);
    }
    if (!(maxHeight === Infinity)) {
      // Inline function 'kotlin.also' call
      var this_0 = out.y6v(maxHeight, includePartialLines, includeFirstLineAlways);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.limit.<anonymous>' call
      if (!this_0.equals(out))
        removedWords = true;
      out = this_0;
    }
    var tmp;
    if (!(maxLineWidth === Infinity) && !(ellipsis == null) && removedWords) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !out.h6v_1.j1();
    } else {
      tmp = false;
    }
    if (tmp) {
      var line = last(out.h6v_1);
      var lastLine = Companion_getInstance_49().f6v(maxLineWidth, last(out.h6v_1), new TextNode(ellipsis, line.u6u()));
      out = RichTextData.r6v(plus_1(dropLast(out, 1), lastLine));
    }
    if (trimSpaces) {
      out = out.y6u();
    }
    return out;
  }
  y6v(maxHeight, includePartialLines, includeFirstLineAlways) {
    var currentHeight = 0.0;
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.z();
    var _iterator__ex2g4s = this.h6v_1.b1();
    $l$loop: while (_iterator__ex2g4s.c1()) {
      var line = _iterator__ex2g4s.d1();
      currentHeight = currentHeight + line.v6u();
      if (currentHeight >= maxHeight) {
        if (includePartialLines || (includeFirstLineAlways && outLines.j1())) {
          // Inline function 'kotlin.collections.plusAssign' call
          outLines.h(line);
        }
        break $l$loop;
      }
      // Inline function 'kotlin.collections.plusAssign' call
      outLines.h(line);
    }
    return RichTextData.r6v(outLines);
  }
  o6v(maxLineWidth, splitLetters) {
    var maxLineWidth_0 = coerceAtLeast_0(maxLineWidth, 0.1);
    // Inline function 'kotlin.collections.arrayListOf' call
    var outLines = ArrayList.z();
    var currentLineWidth = {_v: 0.0};
    // Inline function 'kotlin.collections.arrayListOf' call
    var currentLine = ArrayList.z();
    var _iterator__ex2g4s = this.h6v_1.b1();
    done: while (_iterator__ex2g4s.c1()) {
      var line = _iterator__ex2g4s.d1();
      // Inline function 'kotlin.also' call
      var this_0 = TGenDeque.g3y();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
      this_0.j3y(line.v6t_1);
      var deque = this_0;
      $l$loop: while (true) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!!deque.j1()) {
          break $l$loop;
        }
        var node = deque.ql();
        var width = node.f3u();
        if (currentLineWidth._v >= maxLineWidth_0) {
          wordWrap$finishLine(currentLine, outLines, currentLineWidth);
        }
        var fullyFitsInLine = width <= maxLineWidth_0;
        var fitsInRemainingLine = currentLineWidth._v + width <= maxLineWidth_0;
        var tmp;
        if (node instanceof TextNode) {
          tmp = (node.g6u_1.r6u_1 && (!fullyFitsInLine || splitLetters));
        } else {
          tmp = false;
        }
        if (tmp) {
          var division = Companion_getInstance_49().p6v(node.f6u_1);
          if (division.g1() === 1) {
            if (!fitsInRemainingLine) {
              wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            }
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList.w(collectionSizeOrDefault(division, 10));
            var tmp0_iterator = division.b1();
            while (tmp0_iterator.c1()) {
              var item = tmp0_iterator.d1();
              // Inline function 'korlibs.image.text.RichTextData.wordWrap.<anonymous>' call
              var tmp$ret$4 = node.z6u(item);
              destination.h(tmp$ret$4);
            }
            deque.l3y(destination);
          }
        } else {
          if (!fitsInRemainingLine) {
            wordWrap$finishLine(currentLine, outLines, currentLineWidth);
            wordWrap$addNode(currentLine, currentLineWidth, node);
          } else {
            wordWrap$addNode(currentLine, currentLineWidth, node);
          }
        }
      }
      wordWrap$finishLine(currentLine, outLines, currentLineWidth);
    }
    return RichTextData.r6v(outLines);
  }
  x6v(maxLineWidth, splitLetters, $super) {
    splitLetters = splitLetters === VOID ? false : splitLetters;
    return $super === VOID ? this.o6v(maxLineWidth, splitLetters) : $super.o6v.call(this, maxLineWidth, splitLetters);
  }
  toString() {
    return 'RichTextData(lines=' + toString_0(this.h6v_1) + ', defaultStyle=' + this.i6v_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.h6v_1);
    result = imul(result, 31) + this.i6v_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextData))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextData ? other : THROW_CCE();
    if (!equals(this.h6v_1, tmp0_other_with_cast.h6v_1))
      return false;
    if (!this.i6v_1.equals(tmp0_other_with_cast.i6v_1))
      return false;
    return true;
  }
}
class Placement {
  constructor(text, pos, size, font, fillStyle, stroke) {
    this.z6v_1 = text;
    this.a6w_1 = pos;
    this.b6w_1 = size;
    this.c6w_1 = font;
    this.d6w_1 = fillStyle;
    this.e6w_1 = stroke;
  }
  toString() {
    return 'Placement(text=' + this.z6v_1 + ', pos=' + this.a6w_1.toString() + ', size=' + this.b6w_1 + ', font=' + toString_0(this.c6w_1) + ', fillStyle=' + toString(this.d6w_1) + ', stroke=' + toString(this.e6w_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.z6v_1);
    result = imul(result, 31) + this.a6w_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6w_1) | 0;
    result = imul(result, 31) + hashCode(this.c6w_1) | 0;
    result = imul(result, 31) + (this.d6w_1 == null ? 0 : hashCode(this.d6w_1)) | 0;
    result = imul(result, 31) + (this.e6w_1 == null ? 0 : this.e6w_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Placement))
      return false;
    var tmp0_other_with_cast = other instanceof Placement ? other : THROW_CCE();
    if (!(this.z6v_1 === tmp0_other_with_cast.z6v_1))
      return false;
    if (!this.a6w_1.equals(tmp0_other_with_cast.a6w_1))
      return false;
    if (!equals(this.b6w_1, tmp0_other_with_cast.b6w_1))
      return false;
    if (!equals(this.c6w_1, tmp0_other_with_cast.c6w_1))
      return false;
    if (!equals(this.d6w_1, tmp0_other_with_cast.d6w_1))
      return false;
    if (!equals(this.e6w_1, tmp0_other_with_cast.e6w_1))
      return false;
    return true;
  }
}
class RichTextDataPlacements {
  constructor(placements) {
    placements = placements === VOID ? fastArrayListOf([]) : placements;
    this.f6w_1 = placements;
  }
  g6w(element) {
    return this.f6w_1.z2(element);
  }
  z2(element) {
    if (!(element instanceof Placement))
      return false;
    return this.g6w(element instanceof Placement ? element : THROW_CCE());
  }
  h6w(elements) {
    return this.f6w_1.a3(elements);
  }
  a3(elements) {
    return this.h6w(elements);
  }
  h1(index) {
    return this.f6w_1.h1(index);
  }
  j1() {
    return this.f6w_1.j1();
  }
  b1() {
    return this.f6w_1.b1();
  }
  b3() {
    return this.f6w_1.b3();
  }
  k1(index) {
    return this.f6w_1.k1(index);
  }
  q1(fromIndex, toIndex) {
    return this.f6w_1.q1(fromIndex, toIndex);
  }
  g1() {
    return this.f6w_1.g1();
  }
  toString() {
    return 'RichTextDataPlacements(placements=' + this.f6w_1.toString() + ')';
  }
  hashCode() {
    return this.f6w_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RichTextDataPlacements))
      return false;
    var tmp0_other_with_cast = other instanceof RichTextDataPlacements ? other : THROW_CCE();
    if (!this.f6w_1.equals(tmp0_other_with_cast.f6w_1))
      return false;
    return true;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_40 = this;
    this.o6w_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.p6w_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.q6w_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.r6w_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s6w_1 = [new VerticalAlign(this.o6w_1), new VerticalAlign(this.p6w_1), new VerticalAlign(this.r6w_1), new VerticalAlign(this.q6w_1)];
    this.t6w_1 = toList_1(this.s6w_1);
  }
  u6w(str) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp;
    switch (str.toUpperCase()) {
      case 'TOP':
        tmp = this.o6w_1;
        break;
      case 'CENTER':
      case 'MIDDLE':
        tmp = this.p6w_1;
        break;
      case 'BOTTOM':
        tmp = this.q6w_1;
        break;
      case 'BASELINE':
        tmp = this.r6w_1;
        break;
      default:
        var tmp0_elvis_lhs = toDoubleOrNull(substringBefore(substringAfter(str, _Char___init__impl__6a9atx(40)), _Char___init__impl__6a9atx(41)));
        tmp = _VerticalAlign___init__impl__f42kfq(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
        break;
    }
    return tmp;
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_50();
    this.v6w_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.v6w_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.v6w_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.v6w_1, other);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_41 = this;
    this.i6w_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.j6w_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.k6w_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.l6w_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m6w_1 = [new HorizontalAlign(this.j6w_1), new HorizontalAlign(this.k6w_1), new HorizontalAlign(this.l6w_1), new HorizontalAlign(this.i6w_1)];
    this.n6w_1 = toList_1(this.m6w_1);
  }
  w6w(str) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp;
    switch (str.toUpperCase()) {
      case 'LEFT':
        tmp = this.j6w_1;
        break;
      case 'CENTER':
        tmp = this.k6w_1;
        break;
      case 'RIGHT':
        tmp = this.l6w_1;
        break;
      case 'JUSTIFY':
        tmp = this.i6w_1;
        break;
      default:
        var tmp0_elvis_lhs = toDoubleOrNull(substringBefore(substringAfter(str, _Char___init__impl__6a9atx(40)), _Char___init__impl__6a9atx(41)));
        tmp = _HorizontalAlign___init__impl__ad654o(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
        break;
    }
    return tmp;
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_51();
    this.x6w_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.x6w_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.x6w_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.x6w_1, other);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_42 = this;
    this.r5x_1 = listOf([new HorizontalAlign(Companion_getInstance_51().j6w_1), new HorizontalAlign(Companion_getInstance_51().k6w_1), new HorizontalAlign(Companion_getInstance_51().l6w_1), new HorizontalAlign(Companion_getInstance_51().i6w_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.r5x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.x6w_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_50().o6w_1);
      destination.h(tmp$ret$0);
    }
    tmp.s5x_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.r5x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.b1();
    while (tmp0_iterator_0.c1()) {
      var item_0 = tmp0_iterator_0.d1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.x6w_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_50().r6w_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.t5x_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.r5x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.b1();
    while (tmp0_iterator_1.c1()) {
      var item_1 = tmp0_iterator_1.d1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.x6w_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_50().p6w_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.u5x_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.r5x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.b1();
    while (tmp0_iterator_2.c1()) {
      var item_2 = tmp0_iterator_2.d1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.x6w_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_50().q6w_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.v5x_1 = destination_2;
    this.w5x_1 = plus(plus(plus(this.s5x_1, this.t5x_1), this.u5x_1), this.v5x_1);
    this.x5x_1 = this.s5x_1.h1(0);
    this.y5x_1 = this.s5x_1.h1(1);
    this.z5x_1 = this.s5x_1.h1(2);
    this.a5y_1 = this.s5x_1.h1(3);
    this.b5y_1 = this.t5x_1.h1(0);
    this.c5y_1 = this.t5x_1.h1(1);
    this.d5y_1 = this.t5x_1.h1(2);
    this.e5y_1 = this.t5x_1.h1(3);
    this.f5y_1 = this.s5x_1.h1(0);
    this.g5y_1 = this.s5x_1.h1(1);
    this.h5y_1 = this.s5x_1.h1(2);
    this.i5y_1 = this.s5x_1.h1(3);
    this.j5y_1 = this.u5x_1.h1(0);
    this.k5y_1 = this.u5x_1.h1(1);
    this.l5y_1 = this.u5x_1.h1(2);
    this.m5y_1 = this.u5x_1.h1(3);
    this.n5y_1 = this.v5x_1.h1(0);
    this.o5y_1 = this.v5x_1.h1(1);
    this.p5y_1 = this.v5x_1.h1(2);
    this.q5y_1 = this.v5x_1.h1(3);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_52();
    this.l5z_1 = horizontal;
    this.m5z_1 = vertical;
    this.n5z_1 = Anchor2D.f3i(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.l5z_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.m5z_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.m5z_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.l5z_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.l5z_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.m5z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.l5z_1, tmp0_other_with_cast.l5z_1))
      return false;
    if (!equals(this.m5z_1, tmp0_other_with_cast.m5z_1))
      return false;
    return true;
  }
}
class TextRenderer {}
class ITextRendererActions {}
function reset() {
  this.z6w(Companion_getInstance_7().t3i_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.n26();
  var that = Vector2D.y3k(x, 0.0);
  var tmp$ret$0 = Vector2D.y3k(this_0.r3i_1 + that.r3i_1, this_0.s3i_1 + that.s3i_1);
  this.z6w(tmp$ret$0);
}
function newLine(y, end) {
  this.z6w(Vector2D.y3k(0.0, this.n26().s3i_1 + y));
  var _unary__edvuaz = this.b6x();
  this.a6x(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor() {
    this.i6x_1 = new GlyphPath();
    this.j6x_1 = new GlyphMetrics();
    this.k6x_1 = new FontMetrics();
    this.l6x_1 = 0;
    this.n6x_1 = 0.0;
    this.o6x_1 = Companion_getInstance_7().t3i_1;
    this.p6x_1 = Companion_getInstance_5().z3l_1;
    this.q6x_1 = null;
    this.r6x_1 = Colors_getInstance().y57_1;
  }
  o5x() {
    return this.k6x_1.o5x();
  }
  a6x(_set____db54di) {
    this.l6x_1 = _set____db54di;
  }
  b6x() {
    return this.l6x_1;
  }
  s6x() {
    var tmp = this.m6x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  e6x(font, size) {
    this.m6x_1 = font;
    this.n6x_1 = size;
    font.i5r(size, this.k6x_1);
  }
  z6w(_set____db54di) {
    this.o6x_1 = _set____db54di;
  }
  n26() {
    return this.o6x_1;
  }
  d6x(reader, codePoint) {
    return this.s6x().u5r(this.n6x_1, codePoint, this.j6x_1, reader);
  }
  c6x(_set____db54di) {
    this.p6x_1 = _set____db54di;
  }
  j6t() {
    return this.p6x_1;
  }
  c5s(leftCodePoint, rightCodePoint) {
    return this.s6x().i5t(this.n6x_1, leftCodePoint, rightCodePoint);
  }
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_6().p3j() : bounds;
    this.p5z_1 = maxLineHeight;
    this.q5z_1 = maxX;
    this.r5z_1 = bounds;
  }
  s5z(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.q5z_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.r5z_1, 0.0);
  }
  g6x(dx) {
    this.q5z_1 = this.q5z_1 + dx;
  }
  t6x(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.p5z_1;
    var b = fontMetrics.o5x();
    tmp.p5z_1 = Math.max(a, b);
  }
  u6x() {
  }
  u1w() {
    this.q5z_1 = 0.0;
    this.r5z_1 = Companion_getInstance_6().k3j_1;
    this.p5z_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.p5z_1 + ', maxX=' + this.q5z_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.r5z_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p5z_1);
    result = imul(result, 31) + getNumberHashCode(this.q5z_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.r5z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.p5z_1, tmp0_other_with_cast.p5z_1))
      return false;
    if (!equals(this.q5z_1, tmp0_other_with_cast.q5z_1))
      return false;
    if (!equals(this.r5z_1, tmp0_other_with_cast.r5z_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.f5z_1 = Companion_getInstance_6().p3j();
    this.g5z_1 = Companion_getInstance_6().p3j();
    this.h5z_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.i5z_1 = ArrayList.z();
    this.j5z_1 = new LineStats();
  }
  k5z() {
    return this.h5z_1;
  }
  v6x() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.i5z_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.p5z_1;
    }
    return sum;
  }
  o5z(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.v6x());
  }
  u1w() {
    super.u1w();
    this.h5z_1 = 0;
    this.g5z_1 = Companion_getInstance_6().k3j_1;
    this.f5z_1 = Companion_getInstance_6().k3j_1;
    this.j5z_1.u1w();
    this.i5z_1.h3();
  }
  f6x(reader, codePoint) {
    var g = this.d6x(reader, codePoint);
    add_0(this, g.y5r_1);
    this.j5z_1.t6x(this.k6x_1);
    return g;
  }
  g6x(x) {
    super.g6x(x);
    this.j5z_1.g6x(x);
  }
  h6x(y, end) {
    super.h6x(y, end);
    this.h5z_1 = this.h5z_1 + 1 | 0;
    this.j5z_1.t6x(this.k6x_1);
    this.j5z_1.u6x();
    this.i5z_1.h(this.j5z_1);
    this.j5z_1 = new LineStats();
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.w6x_1 = $getVersion;
    this.x6x_1 = $handler;
  }
  y6x(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.u1w();
    _this__u8e3s4.e6x(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.w25()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.z25());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.x25(1));
      var startPos = reader.p25_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.h6x(_this__u8e3s4.o5x(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.p25_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.d6x(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.p25_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.c6x(Companion_getInstance_5().z3l_1);
        this.x6x_1(_this__u8e3s4, reader, c, g, g.z5r_1 + _this__u8e3s4.c5s(c, c1));
      }
      if (reader.p25_1 <= startPos) {
        reader.b26(1);
      }
    }
    _this__u8e3s4.h6x(_this__u8e3s4.o5x(), true);
  }
  y6w(_this__u8e3s4, text, size, defaultFont) {
    return this.y6x(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.z6x_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  a6y(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.z6x_1.y6w(_this__u8e3s4, Companion_getInstance_11().g26(text), size, defaultFont);
  }
  y6w(_this__u8e3s4, text, size, defaultFont) {
    return this.a6y(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_43 = this;
    this.b6y_1 = Companion_getInstance_15().u26_1;
    this.c6y_1 = _Tile___init__impl__tdix77(Companion_getInstance_15().t26_1);
    this.d6y_1 = _Tile___init__impl__tdix77(this.b6y_1);
  }
  e6y(raw) {
    return _Tile___init__impl__tdix77(raw);
  }
  f6y(tile, offsetX, offsetY, flipX, flipY, rotate) {
    return _Tile___init__impl__tdix77(Int53__insertNoClear_impl_aaadnr(Int53__insertNoClear_impl_aaadnr(Int53__insertNoClear_impl_aaadnr_0(Int53__insertNoClear_impl_aaadnr_0(Int53__insertNoClear_impl_aaadnr_0(Int53__insertNoClear_impl_aaadnr(Companion_getInstance_15().t26_1, tile, 0, 19), rotate, 19), flipY, 20), flipX, 21), offsetX, 22, 15), offsetY, 37, 15));
  }
}
class Companion_37 {
  g6y(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) {
    var tmp298_width = data.f3u();
    var tmp299_height = data.g3u();
    var tmp300_tileSet = tileSet == null ? Companion_getInstance_55().i6j_1 : tileSet;
    var map = TileMapData.n6y(tmp298_width, tmp299_height, tmp300_tileSet, VOID, repeatX, repeatY, offsetScale);
    var offsetXRange = Companion_instance_2.w27(maskOffsetX);
    var offsetYRange = Companion_instance_2.w27(maskOffsetY);
    // Inline function 'korlibs.datastructure.each' call
    var inductionVariable = 0;
    var last = data.g3u();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = data.f3u();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
            var v = data.m3u(x, y);
            var offsetX = IntMaskRange__extractSigned_impl_s8qphq(offsetXRange, v, offsetSigned);
            var offsetY = IntMaskRange__extractSigned_impl_s8qphq(offsetYRange, v, offsetSigned);
            map.o6y(x, y, Companion_getInstance_53().f6y(v & maskData, offsetX, offsetY, !((v & maskFlipX) === 0), !((v & maskFlipY) === 0), !((v & maskRotate) === 0)));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return map;
  }
  g6k(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale, $super) {
    tileSet = tileSet === VOID ? null : tileSet;
    maskData = maskData === VOID ? 268435455 : maskData;
    maskFlipX = maskFlipX === VOID ? mask(1, 31) : maskFlipX;
    maskFlipY = maskFlipY === VOID ? mask(1, 30) : maskFlipY;
    maskRotate = maskRotate === VOID ? mask(1, 29) : maskRotate;
    maskOffsetX = maskOffsetX === VOID ? 0 : maskOffsetX;
    maskOffsetY = maskOffsetY === VOID ? 0 : maskOffsetY;
    offsetSigned = offsetSigned === VOID ? true : offsetSigned;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return $super === VOID ? this.g6y(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) : $super.g6y.call(this, data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale);
  }
}
class TileMapData extends BaseDelegatedStackedArray2 {
  static p6y(data, tileSet, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_55().i6j_1 : tileSet;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    var $this = this.w43(data);
    $this.i6y_1 = data;
    $this.j6y_1 = tileSet;
    $this.k6y_1 = repeatX;
    $this.l6y_1 = repeatY;
    $this.m6y_1 = offsetScale;
    return $this;
  }
  static n6y(width, height, tileSet, empty, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_55().i6j_1 : tileSet;
    empty = empty === VOID ? Tile(0) : empty;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return this.p6y(new StackedInt53Array2(width, height, _Tile___get_raw__impl__kp6cq8(empty)), tileSet, repeatX, repeatY, offsetScale);
  }
  o6y(x, y, data) {
    return this.q6y(x, y, data);
  }
  r6y(x, y, level, data) {
    if (this.n3u(x, y)) {
      this.i6y_1.h44(x, y, level, _Tile___get_raw__impl__kp6cq8(data));
    }
  }
  s6y(x, y, level) {
    return Companion_getInstance_53().e6y(this.i6y_1.i44(x, y, level));
  }
  u43(x, y) {
    return this.i6y_1.u43(x, y);
  }
  q6y(x, y, value) {
    if (!this.n3u(x, y))
      return Unit_instance;
    var level = coerceAtLeast(this.u43(x, y) - 1 | 0, 0);
    this.r6y(x, y, level, value);
  }
  toString() {
    return 'TileMapData(data=' + toString_0(this.i6y_1) + ', tileSet=' + this.j6y_1.toString() + ', repeatX=' + this.k6y_1.toString() + ', repeatY=' + this.l6y_1.toString() + ', offsetScale=' + this.m6y_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i6y_1);
    result = imul(result, 31) + hashCode(this.j6y_1) | 0;
    result = imul(result, 31) + this.k6y_1.hashCode() | 0;
    result = imul(result, 31) + this.l6y_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.m6y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileMapData))
      return false;
    var tmp0_other_with_cast = other instanceof TileMapData ? other : THROW_CCE();
    if (!equals(this.i6y_1, tmp0_other_with_cast.i6y_1))
      return false;
    if (!equals(this.j6y_1, tmp0_other_with_cast.j6y_1))
      return false;
    if (!this.k6y_1.equals(tmp0_other_with_cast.k6y_1))
      return false;
    if (!this.l6y_1.equals(tmp0_other_with_cast.l6y_1))
      return false;
    if (!equals(this.m6y_1, tmp0_other_with_cast.m6y_1))
      return false;
    return true;
  }
}
class TileMapRepeat extends Enum {
  constructor(name, ordinal, get) {
    super(name, ordinal);
    this.v6y_1 = get;
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_45 = this;
    this.i6j_1 = new TileSet(IntMap.a41(), VOID, VOID, Unit_instance);
  }
  w6y(tilesMap, width, height, border, mipmaps) {
    if (border === 0 && !mipmaps)
      return new TileSet(tilesMap, width, height, Unit_instance);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = tilesMap.n3();
    var destination = ArrayList.z();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
      if (element == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(element);
      }
    }
    return this.x6y(width, height, destination, border, mipmaps);
  }
  j6j(tilesMap, width, height, border, mipmaps, $super) {
    width = width === VOID ? tilesMap.n40_1 === 0 ? 0 : tilesMap.c41().a6z_1.r4r_1 : width;
    height = height === VOID ? tilesMap.n40_1 === 0 ? 0 : tilesMap.c41().a6z_1.s4r_1 : height;
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    return $super === VOID ? this.w6y(tilesMap, width, height, border, mipmaps) : $super.w6y.call(this, tilesMap, width, height, border, mipmaps);
  }
  d6z(tiles, width, height, border, mipmaps) {
    return this.x6y(width, height, tiles, border, mipmaps);
  }
  e6z(tiles, width, height, border, mipmaps, $super) {
    width = width === VOID ? first_0(tiles).a6z_1.r4r_1 : width;
    height = height === VOID ? first_0(tiles).a6z_1.s4r_1 : height;
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    return $super === VOID ? this.d6z(tiles, width, height, border, mipmaps) : $super.d6z.call(this, tiles, width, height, border, mipmaps);
  }
  f6z(base, tileWidth, tileHeight, columns, totalTiles, idOffset, border, mipmaps) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var out = ArrayList.z();
    var rows = base.s4r_1 / tileHeight | 0;
    var actualColumns = columns < 0 ? base.r4r_1 / tileWidth | 0 : columns;
    var actualTotalTiles = totalTiles < 0 ? imul(rows, actualColumns) : totalTiles;
    var inductionVariable = 0;
    if (inductionVariable < rows)
      complete: do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < actualColumns)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlin.collections.plusAssign' call
            var element = new TileSetTileInfo(out.g1() + idOffset | 0, base.z4s(imul(x, tileWidth), imul(y, tileHeight), tileWidth, tileHeight));
            out.h(element);
            if (out.g1() >= actualTotalTiles)
              break complete;
          }
           while (inductionVariable_0 < actualColumns);
      }
       while (inductionVariable < rows);
    return this.x6y(tileWidth, tileHeight, out, border, mipmaps);
  }
  g6z(base, tileWidth, tileHeight, columns, totalTiles, idOffset, border, mipmaps, $super) {
    tileWidth = tileWidth === VOID ? base.r4r_1 : tileWidth;
    tileHeight = tileHeight === VOID ? base.s4r_1 : tileHeight;
    columns = columns === VOID ? -1 : columns;
    totalTiles = totalTiles === VOID ? -1 : totalTiles;
    idOffset = idOffset === VOID ? 0 : idOffset;
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    return $super === VOID ? this.f6z(base, tileWidth, tileHeight, columns, totalTiles, idOffset, border, mipmaps) : $super.f6z.call(this, base, tileWidth, tileHeight, columns, totalTiles, idOffset, border, mipmaps);
  }
  h6z(tilewidth, tileheight, bitmaps, border, mipmaps, idOffset) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.tiles.Companion.fromBitmaps.<anonymous>' call
      var tmp$ret$0 = slice_0(item);
      destination.h(tmp$ret$0);
    }
    return this.i6z(tilewidth, tileheight, destination, border, mipmaps, idOffset);
  }
  j6z(tilewidth, tileheight, bitmaps, border, mipmaps, idOffset, $super) {
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    idOffset = idOffset === VOID ? 0 : idOffset;
    return $super === VOID ? this.h6z(tilewidth, tileheight, bitmaps, border, mipmaps, idOffset) : $super.h6z.call(this, tilewidth, tileheight, bitmaps, border, mipmaps, idOffset);
  }
  i6z(tilewidth, tileheight, bmpSlices, border, mipmaps, idOffset) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = withIndex(bmpSlices);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
      var index = item.em();
      var it = item.fm();
      var tmp$ret$0 = new TileSetTileInfo(index + idOffset | 0, it);
      destination.h(tmp$ret$0);
    }
    return this.x6y(tilewidth, tileheight, destination, border, mipmaps);
  }
  x6y(tilewidth, tileheight, bmpSlices, border, mipmaps_0) {
    if (bmpSlices.j1())
      return new TileSet(IntMap.a41(), tilewidth, tileheight, Unit_instance);
    if (border === 0) {
      // Inline function 'kotlin.also' call
      var this_0 = IntMap.a41(bmpSlices.g1());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.tiles.Companion.fromTileSetTileInfo.<anonymous>' call
      var _iterator__ex2g4s = bmpSlices.b1();
      while (_iterator__ex2g4s.c1()) {
        var slice = _iterator__ex2g4s.d1();
        this_0.u40(slice.z6y_1, slice);
      }
      return new TileSet(this_0, tilewidth, tileheight, Unit_instance);
    }
    var border2 = imul(border, 2);
    var btilewidth = tilewidth + border2 | 0;
    var btileheight = tileheight + border2 | 0;
    // Inline function 'kotlin.math.sqrt' call
    var x = bmpSlices.g1();
    var tmp$ret$1 = Math.sqrt(x);
    var columns = toIntCeil_0(tmp$ret$1);
    var rows = toIntCeil_0(bmpSlices.g1() / columns);
    var minWidth = imul(columns, tilewidth + border | 0) + border | 0;
    var minHeight = imul(rows, tileheight + border | 0) + border | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = get_nextPowerOfTwo(minWidth);
    var b = get_nextPowerOfTwo(minHeight);
    var potSize = Math.max(a, b);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(bmpSlices, Collection)) {
        tmp = bmpSlices.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
      var tmp0_iterator = bmpSlices.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.image.tiles.Companion.fromTileSetTileInfo.<anonymous>' call
        if (element.a6z_1.i4r_1.x56_1) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    var premultiplied = tmp$ret$3;
    var out = mipmaps(Bitmap32.k56(potSize, potSize, VOID, premultiplied), mipmaps_0);
    var texs = IntMap.a41();
    var bmps = FastIdentityMap();
    var inductionVariable = 0;
    var last = bmpSlices.g1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = n / columns | 0;
        var x_0 = n % columns | 0;
        var px = imul(x_0, btilewidth) + border | 0;
        var py = imul(y, btileheight) + border | 0;
        var origSlice = bmpSlices.h1(n);
        out.v5g(fromTileSetTileInfo$ensureBMP32(origSlice.a6z_1, bmps), px, py);
        var tileInfo = origSlice.k6z(VOID, sliceWithSize(out, px, py, origSlice.f3u(), origSlice.g3u(), origSlice.q3()));
        texs.u40(tileInfo.z6y_1, tileInfo);
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < columns)
      do {
        var x_1 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var px_0 = imul(x_1, btilewidth) + border | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < border)
          do {
            var b_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            Companion_getInstance_16().f5g(out, px_0, 0, out, (px_0 - 1 | 0) - b_0 | 0, 0, 1, out.s56_1);
            Companion_getInstance_16().f5g(out, (px_0 + tilewidth | 0) - 1 | 0, 0, out, (px_0 + tilewidth | 0) + b_0 | 0, 0, 1, out.s56_1);
          }
           while (inductionVariable_1 < border);
      }
       while (inductionVariable_0 < columns);
    var inductionVariable_2 = 0;
    if (inductionVariable_2 < rows)
      do {
        var y_0 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var py_0 = imul(y_0, btileheight) + border | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < border)
          do {
            var b_1 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            Companion_getInstance_16().f5g(out, 0, py_0, out, 0, (py_0 - 1 | 0) - b_1 | 0, out.r56_1, 1);
            Companion_getInstance_16().f5g(out, 0, (py_0 + tileheight | 0) - 1 | 0, out, 0, (py_0 + tileheight | 0) + b_1 | 0, out.r56_1, 1);
          }
           while (inductionVariable_3 < border);
      }
       while (inductionVariable_2 < rows);
    return new TileSet(texs, tilewidth, tileheight, Unit_instance);
  }
}
class TileSet {
  constructor(tilesMap, width, height, unit) {
    Companion_getInstance_55();
    width = width === VOID ? tilesMap.n40_1 === 0 ? 0 : tilesMap.c41().a6z_1.r4r_1 : width;
    height = height === VOID ? tilesMap.n40_1 === 0 ? 0 : tilesMap.c41().a6z_1.s4r_1 : height;
    this.l6z_1 = tilesMap;
    this.m6z_1 = width;
    this.n6z_1 = height;
    var tmp = this;
    tmp.o6z_1 = lazy(TileSet$base$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p6z_1 = lazy(TileSet$hasMultipleBaseBitmaps$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.q6z_1 = lazy(TileSet$infos$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.r6z_1 = lazy(TileSet$textures$delegate$lambda(this));
  }
  s6z() {
    return SizeInt.x3s(this.m6z_1, this.n6z_1);
  }
  toString() {
    return 'TileSet(size=' + this.m6z_1 + 'x' + this.n6z_1 + ', tiles=' + toString_0(toList(this.l6z_1.f3())) + ')';
  }
  r4s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o6z_1;
    base$factory();
    return this_0.w1();
  }
  z4l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q6z_1;
    infos$factory();
    return this_0.w1();
  }
  t6z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r6z_1;
    textures$factory();
    return this_0.w1();
  }
  u6z(index) {
    return getOrNull(this.z4l(), index);
  }
}
class TileSetTileInfo {
  constructor(id, slice, frames, collision) {
    frames = frames === VOID ? emptyList() : frames;
    collision = collision === VOID ? null : collision;
    this.y6y_1 = new Mixin();
    this.z6y_1 = id;
    this.a6z_1 = slice;
    this.b6z_1 = frames;
    this.c6z_1 = collision;
  }
  c28(_set____db54di) {
    this.y6y_1.c28(_set____db54di);
  }
  d28() {
    return this.y6y_1.d28();
  }
  f3u() {
    return this.a6z_1.r4r_1;
  }
  g3u() {
    return this.a6z_1.s4r_1;
  }
  q3() {
    return this.a6z_1.m4r_1;
  }
  v6z(id, slice, frames, collision) {
    return new TileSetTileInfo(id, slice, frames, collision);
  }
  k6z(id, slice, frames, collision, $super) {
    id = id === VOID ? this.z6y_1 : id;
    slice = slice === VOID ? this.a6z_1 : slice;
    frames = frames === VOID ? this.b6z_1 : frames;
    collision = collision === VOID ? this.c6z_1 : collision;
    return $super === VOID ? this.v6z(id, slice, frames, collision) : $super.v6z.call(this, id, slice, frames, collision);
  }
  toString() {
    return 'TileSetTileInfo(id=' + this.z6y_1 + ', slice=' + this.a6z_1.toString() + ', frames=' + toString_0(this.b6z_1) + ', collision=' + toString(this.c6z_1) + ')';
  }
  hashCode() {
    var result = this.z6y_1;
    result = imul(result, 31) + this.a6z_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.b6z_1) | 0;
    result = imul(result, 31) + (this.c6z_1 == null ? 0 : hashCode(this.c6z_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetTileInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TileSetTileInfo ? other : THROW_CCE();
    if (!(this.z6y_1 === tmp0_other_with_cast.z6y_1))
      return false;
    if (!this.a6z_1.equals(tmp0_other_with_cast.a6z_1))
      return false;
    if (!equals(this.b6z_1, tmp0_other_with_cast.b6z_1))
      return false;
    if (!equals(this.c6z_1, tmp0_other_with_cast.c6z_1))
      return false;
    return true;
  }
}
class SegmentHandler {
  constructor() {
    this.w6z_1 = intArrayListOf(new Int32Array([]));
    this.x6z_1 = intArrayListOf(new Int32Array([]));
    this.u1w();
  }
  g1() {
    return this.w6z_1.g1();
  }
  u1w() {
    this.w6z_1.h3();
    this.x6z_1.h3();
  }
  x4v(x0, x1) {
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.w6z_1.x27(n);
        var xmax = this.x6z_1.x27(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.w6z_1.w3w(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.x6z_1.w3w(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.w6z_1.r3w(x0);
    this.x6z_1.r3w(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.j70_1 = $outer;
    this.y6z_1 = get_DEFAULT(Companion_getInstance_56());
    this.z6z_1 = NoneFiller_getInstance();
    this.a70_1 = -1;
    this.b70_1 = -1;
    this.c70_1 = new Float32Array(this.g1());
    this.d70_1 = new Int32Array(this.g1());
    this.e70_1 = Companion_instance_16.k5q(this.g1());
    this.f70_1 = Companion_instance_16.k5q(this.g1());
    this.g70_1 = new SegmentHandler();
    this.h70_1 = 0;
    this.i70_1 = 1.0;
  }
  g1() {
    return this.j70_1.m70_1.r56_1;
  }
  w70() {
    return this.j70_1.m70_1.r56_1 - 1 | 0;
  }
  u1w() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.g70_1;
    var inductionVariable = 0;
    var last = this_0.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.w6z_1.x27(n);
        var xmax = this_0.x6z_1.x27(n);
        fill_0(this.c70_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.d70_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.h70_1 = 0;
    this.g70_1.u1w();
  }
  x70(x0, x1, y0) {
    if (this.w70() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.w70(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.w70(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.w70());
    var i1 = coerceIn(b, 0, this.w70());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.b70_1 === y)) {
      if (y >= 0) {
        this.gd();
      }
      this.b70_1 = y;
      this.u1w();
    }
    if (!(this.a70_1 === y0)) {
      this.a70_1 = y0;
      this.h70_1 = this.h70_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.g70_1.x4v(i0, i1);
      this.y70(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.y70(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.y70(i1, i1m / 20);
      }
    }
  }
  y70(x, ratio) {
    var mask = 1 << this.h70_1;
    if ((this.d70_1[x] & mask) === 0) {
      this.d70_1[x] = this.d70_1[x] | mask;
      var _array__4zh2yp = this.c70_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  gd() {
    var containsUpper = this.j70_1.m70_1.s56_1;
    var containsArg = this.b70_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.i70_1);
    var scale_0 = 1.0 / this.h70_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.g70_1;
    var inductionVariable = 0;
    var last = this_0.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.w6z_1.x27(n);
        var xmax = this_0.x6z_1.x27(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.z6z_1.e6s(this.f70_1, 0, xmin, xmax, this.b70_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.c70_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.f70_1, xmin, this.c70_1, xmin, count);
        var index = this.j70_1.m70_1.m57(0, this.b70_1) + x | 0;
        if (this.j70_1.m70_1.x56_1) {
          arraycopy(this.j70_1.m70_1.h56_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.e70_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.j70_1.m70_1.h56_1), index, this.e70_1, x, count);
        }
        this.y6z_1.z70(this.e70_1, x, this.f70_1, x, count);
        if (this.j70_1.m70_1.x56_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.e70_1), x, this.j70_1.m70_1.h56_1, index, count);
        } else {
          depremultiply(this.e70_1, x, _RgbaArray___init__impl__oib4y4(this.j70_1.m70_1.h56_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.l71_1 = false;
    this.m71_1 = 0;
  }
  gd() {
    return Unit_instance;
  }
  o71() {
    var _unary__edvuaz = this.m71_1;
    this.m71_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  p71() {
    this.m71_1 = this.m71_1 - 1 | 0;
    if (this.m71_1 === 0) {
      this.gd();
    }
  }
  q71(state, fill, winding) {
    var rstate = state;
    if (fill && !this.s71(state.r5s_1)) {
      rstate = state.z27();
      rstate.r5s_1 = toBitmapPaint(rstate.r5s_1, state);
    }
    this.k71(rstate, fill, winding);
  }
  r71(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.q71(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.q71.call(this, state, fill, winding);
    }
    return tmp;
  }
  k71(state, fill, winding) {
    return Unit_instance;
  }
  s71(_this__u8e3s4) {
    return true;
  }
  t71(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.p3m().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.y4y(pos, size);
    } else {
      this_0.g4z(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.r71(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().z3l_1, size.g3s(toFloat(image.g1()))).b3n(pos))), true);
  }
  k2i() {
    this.gd();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.m70_1 = bmp;
    this.n70_1 = antialiasing;
    this.o70_1 = this.m70_1.j56_1.z3r();
    this.p70_1 = new Rasterizer();
    this.q70_1 = new ColorFiller();
    this.r70_1 = new GradientFiller();
    this.s70_1 = new BitmapFiller();
    this.t70_1 = new ScanlineWriter(this);
    this.u70_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.v70_1 = new StrokeToFill();
  }
  f3u() {
    return this.m70_1.r56_1;
  }
  g3u() {
    return this.m70_1.s56_1;
  }
  k71(state, fill, winding) {
    var style = fill ? state.r5s_1 : state.q5s_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.q70_1.c6s(style.o5p_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.r70_1.k6s(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.s70_1.y6s(style, state);
          } else {
            throw NotImplementedError.je();
          }
        }
      }
    }
    var filler = tmp;
    this.t70_1.y6z_1 = state.y5s_1;
    this.p70_1.u1w();
    this.p70_1.a71_1 = this.l71_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.j5s_1;
    } else {
      this.u70_1.h3();
      var tmp306_$receiver = state.j5s_1;
      var tmp307_lineWidth = state.n71();
      var tmp308_joins = state.o5s_1;
      var tmp309_startCap = state.m5s_1;
      var tmp310_endCap = state.n5s_1;
      var tmp311_miterLimit = state.p5s_1;
      var tmp312_temp = this.v70_1;
      var tmp313_outFill = this.u70_1;
      var tmp314_lineDash = state.z5s_1;
      var tmp315_lineDashOffset = state.a5t_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.i5s_1 == null)) {
      this.p70_1.e71_1.c4v_1 = ensureNotNull(state.i5s_1).p4p_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.i5s_1);
      var i = Vector2D.i3l();
      var l = Vector2D.i3l();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.p70_1.e71_1.p6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.n4p_1;
      var n_0 = 0;
      while (n_0 < this_1.g1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.x27(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.o4p_1.h1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.y3k(tmp_1, this_0.o4p_1.h1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.em();
            var y = it.fm();
            this.p70_1.e71_1.f4w(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.o4p_1.h1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.y3k(tmp_2, this_0.o4p_1.h1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.em();
            var y_0 = it_0.fm();
            this.p70_1.e71_1.f4w(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.o4p_1.h1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.y3k(tmp_3, this_0.o4p_1.h1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.o4p_1.h1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.y3k(tmp_4, this_0.o4p_1.h1(_unary__edvuaz_7));
            var sum = Companion_getInstance_7().d3t(l, c) + Companion_getInstance_7().d3t(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.i3l()};
            var prevPos = {_v: Vector2D.i3l()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_9().p27_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_1().h4n(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_1().h4n(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.em();
                var y_1 = it_1.fm();
                this.p70_1.e71_1.f4w(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.o4p_1.h1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.y3k(tmp_5, this_0.o4p_1.h1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.o4p_1.h1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.y3k(tmp_6, this_0.o4p_1.h1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.o4p_1.h1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.y3k(tmp_7, this_0.o4p_1.h1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_7().d3t(l, c0) + Companion_getInstance_7().d3t(c0, c1) + Companion_getInstance_7().d3t(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.i3l()};
            var prevPos_0 = {_v: Vector2D.i3l()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_9().p27_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_1().g4n(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_1().g4n(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.em();
                var y_2 = it_2.fm();
                this.p70_1.e71_1.f4w(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.em();
            var y_3 = destruct.fm();
            this.p70_1.e71_1.f4w(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.p70_1.e71_1.p6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.p70_1.e71_1.p6();
      }
    }
    var tmp_8 = this.p70_1.d71_1;
    tmp_8.c4v_1 = winding == null ? ensureNotNull(state.j5s_1).p4p_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.i3l();
    var l_0 = Vector2D.i3l();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.p70_1.d71_1.p6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.n4p_1;
    var n_4 = 0;
    while (n_4 < this_2.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.x27(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.o4p_1.h1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.y3k(tmp_9, fillPath.o4p_1.h1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.em();
          var y_4 = it_3.fm();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p70_1.d71_1.f4w(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.o4p_1.h1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.y3k(tmp_10, fillPath.o4p_1.h1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.em();
          var y_5 = it_4.fm();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p70_1.d71_1.f4w(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.o4p_1.h1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.y3k(tmp_11, fillPath.o4p_1.h1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.o4p_1.h1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.y3k(tmp_12, fillPath.o4p_1.h1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_7().d3t(l_0, c_0) + Companion_getInstance_7().d3t(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.i3l()};
          var prevPos_1 = {_v: Vector2D.i3l()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_9().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_1().h4n(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_1().h4n(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.em();
              var y_6 = it_5.fm();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.p70_1.d71_1.f4w(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.o4p_1.h1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.y3k(tmp_13, fillPath.o4p_1.h1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.o4p_1.h1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.y3k(tmp_14, fillPath.o4p_1.h1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.o4p_1.h1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.y3k(tmp_15, fillPath.o4p_1.h1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_7().d3t(l_0, c0_0) + Companion_getInstance_7().d3t(c0_0, c1_0) + Companion_getInstance_7().d3t(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.i3l()};
          var prevPos_2 = {_v: Vector2D.i3l()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_9().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_1().g4n(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_1().g4n(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.em();
              var y_7 = it_6.fm();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.p70_1.d71_1.f4w(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.em();
          var y_8 = destruct_0.fm();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.p70_1.d71_1.f4w(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.p70_1.d71_1.p6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.p70_1.d71_1.p6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.u71_1 = $func;
  }
  z70(dst, dstN, src, srcN, count) {
    return this.u71_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_46 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_56();
    tmp.v71_1 = tmp_0.w71(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  w71(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_40 {
  h4z() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.z71_1 = op;
  }
  z70(dst, dstN, src, srcN, count) {
    this.z71_1.z70(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.c72_1 = op;
  }
  z70(dst, dstN, src, srcN, count) {
    this.c72_1.z70(dst, dstN, src, srcN, count);
  }
}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().z3l_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_50().r6w_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_51().j6w_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.h5s_1 = transform;
    this.i5s_1 = clip;
    this.j5s_1 = path;
    this.k5s_1 = lineScaleMode;
    this.l5s_1 = lineWidth;
    this.m5s_1 = startLineCap;
    this.n5s_1 = endLineCap;
    this.o5s_1 = lineJoin;
    this.p5s_1 = miterLimit;
    this.q5s_1 = strokeStyle;
    this.r5s_1 = fillStyle;
    this.s5s_1 = fontRegistry;
    this.t5s_1 = font;
    this.u5s_1 = fontSize;
    this.v5s_1 = verticalAlign;
    this.w5s_1 = horizontalAlign;
    this.x5s_1 = globalAlpha;
    this.y5s_1 = globalCompositeOperation;
    this.z5s_1 = lineDash;
    this.a5t_1 = lineDashOffset;
    var tmp = this;
    tmp.b5t_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  d72() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b5t_1;
    transformTransform$factory();
    return this_0.w1();
  }
  n71() {
    var tmp = this.l5s_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.d72().g3o();
    return tmp * Math.abs(this_0);
  }
  e72() {
    return this.m5s_1;
  }
  z27() {
    var tmp = this.h5s_1;
    var tmp319_safe_receiver = this.i5s_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.z27();
    var tmp_1 = this.j5s_1.z27();
    var tmp320_safe_receiver = this.z5s_1;
    return this.f72(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.z27());
  }
  g72(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  f72(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.h5s_1 : transform;
    clip = clip === VOID ? this.i5s_1 : clip;
    path = path === VOID ? this.j5s_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.k5s_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.l5s_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.m5s_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.n5s_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.o5s_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.p5s_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.q5s_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.r5s_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.s5s_1 : fontRegistry;
    font = font === VOID ? this.t5s_1 : font;
    fontSize = fontSize === VOID ? this.u5s_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.v5s_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.w5s_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.x5s_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.y5s_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.z5s_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.a5t_1 : lineDashOffset;
    return $super === VOID ? this.g72(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.g72.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.h5s_1.toString() + ', clip=' + toString(this.i5s_1) + ', path=' + this.j5s_1.toString() + ', lineScaleMode=' + this.k5s_1.toString() + ', lineWidth=' + this.l5s_1 + ', startLineCap=' + this.m5s_1.toString() + ', endLineCap=' + this.n5s_1.toString() + ', lineJoin=' + this.o5s_1.toString() + ', miterLimit=' + this.p5s_1 + ', strokeStyle=' + toString_0(this.q5s_1) + ', fillStyle=' + toString_0(this.r5s_1) + ', fontRegistry=' + toString(this.s5s_1) + ', font=' + toString(this.t5s_1) + ', fontSize=' + this.u5s_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.v5s_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.w5s_1) + ', globalAlpha=' + this.x5s_1 + ', globalCompositeOperation=' + toString_0(this.y5s_1) + ', lineDash=' + toString(this.z5s_1) + ', lineDashOffset=' + this.a5t_1 + ')';
  }
  hashCode() {
    var result = this.h5s_1.hashCode();
    result = imul(result, 31) + (this.i5s_1 == null ? 0 : this.i5s_1.hashCode()) | 0;
    result = imul(result, 31) + this.j5s_1.hashCode() | 0;
    result = imul(result, 31) + this.k5s_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5s_1) | 0;
    result = imul(result, 31) + this.m5s_1.hashCode() | 0;
    result = imul(result, 31) + this.n5s_1.hashCode() | 0;
    result = imul(result, 31) + this.o5s_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.p5s_1) | 0;
    result = imul(result, 31) + hashCode(this.q5s_1) | 0;
    result = imul(result, 31) + hashCode(this.r5s_1) | 0;
    result = imul(result, 31) + (this.s5s_1 == null ? 0 : hashCode(this.s5s_1)) | 0;
    result = imul(result, 31) + (this.t5s_1 == null ? 0 : hashCode(this.t5s_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u5s_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.v5s_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.w5s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x5s_1) | 0;
    result = imul(result, 31) + hashCode(this.y5s_1) | 0;
    result = imul(result, 31) + (this.z5s_1 == null ? 0 : hashCode(this.z5s_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a5t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.h5s_1.equals(tmp0_other_with_cast.h5s_1))
      return false;
    if (!equals(this.i5s_1, tmp0_other_with_cast.i5s_1))
      return false;
    if (!this.j5s_1.equals(tmp0_other_with_cast.j5s_1))
      return false;
    if (!this.k5s_1.equals(tmp0_other_with_cast.k5s_1))
      return false;
    if (!equals(this.l5s_1, tmp0_other_with_cast.l5s_1))
      return false;
    if (!this.m5s_1.equals(tmp0_other_with_cast.m5s_1))
      return false;
    if (!this.n5s_1.equals(tmp0_other_with_cast.n5s_1))
      return false;
    if (!this.o5s_1.equals(tmp0_other_with_cast.o5s_1))
      return false;
    if (!equals(this.p5s_1, tmp0_other_with_cast.p5s_1))
      return false;
    if (!equals(this.q5s_1, tmp0_other_with_cast.q5s_1))
      return false;
    if (!equals(this.r5s_1, tmp0_other_with_cast.r5s_1))
      return false;
    if (!equals(this.s5s_1, tmp0_other_with_cast.s5s_1))
      return false;
    if (!equals(this.t5s_1, tmp0_other_with_cast.t5s_1))
      return false;
    if (!equals(this.u5s_1, tmp0_other_with_cast.u5s_1))
      return false;
    if (!equals(this.v5s_1, tmp0_other_with_cast.v5s_1))
      return false;
    if (!equals(this.w5s_1, tmp0_other_with_cast.w5s_1))
      return false;
    if (!equals(this.x5s_1, tmp0_other_with_cast.x5s_1))
      return false;
    if (!equals(this.y5s_1, tmp0_other_with_cast.y5s_1))
      return false;
    if (!equals(this.z5s_1, tmp0_other_with_cast.z5s_1))
      return false;
    if (!equals(this.a5t_1, tmp0_other_with_cast.a5t_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.p5e_1 = renderer;
    this.q5e_1 = defaultFontRegistry;
    this.r5e_1 = defaultFont;
    this.s5e_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.q5e_1, this.r5e_1);
    this.t5e_1 = _TGenStack___init__impl__yynjgt();
    this.u5e_1 = Vector2D.i3l();
    this.v5e_1 = Vector2D.i3l();
  }
  h72() {
    return this.p5e_1.f3u();
  }
  i72() {
    return this.p5e_1.g3u();
  }
  j72(state, fill, winding) {
    return this.p5e_1.q71(state, fill, winding);
  }
  k72(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.j72(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.j72.call(this, state, fill, winding);
    }
    return tmp;
  }
  l72(image, pos, size, transform) {
    return this.p5e_1.t71(image, pos, size, transform);
  }
  m72() {
    return this.p5e_1.k2i();
  }
  n72() {
    return this.p5e_1.o71();
  }
  o72() {
    return this.p5e_1.p71();
  }
  f3u() {
    return this.h72();
  }
  g3u() {
    return this.i72();
  }
  k2i() {
    this.m72();
  }
  p72() {
    return this.n72();
  }
  q72() {
    return this.o72();
  }
  r72(value) {
    this.s5e_1.k5s_1 = value;
  }
  s72(value) {
    this.s5e_1.l5s_1 = value;
  }
  t72(value) {
    this.s5e_1.p5s_1 = value;
  }
  u72(value) {
    this.s5e_1.m5s_1 = value;
  }
  v72(value) {
    this.s5e_1.n5s_1 = value;
  }
  w72(value) {
    this.s5e_1.o5s_1 = value;
  }
  x72(value) {
    this.s5e_1.q5s_1 = value;
  }
  y72() {
    return this.s5e_1.q5s_1;
  }
  e5t(value) {
    this.s5e_1.r5s_1 = value;
  }
  d5t() {
    return this.s5e_1.r5s_1;
  }
  z72(value) {
    this.s5e_1.z5s_1 = value;
  }
  a73(value) {
    this.s5e_1.a5t_1 = value;
  }
  f6g() {
    TGenStack__push_impl_9yh33t(this.t5e_1, this.s5e_1.z27());
  }
  h6g() {
    this.s5e_1 = TGenStack__pop_impl_qisxa0(this.t5e_1);
  }
  j6g(sx, sy) {
    this.s5e_1.h5s_1 = this.s5e_1.h5s_1.z3m(sx, sy);
  }
  c5t(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.j6g(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.j6g.call(this, sx, sy);
    }
    return tmp;
  }
  i6g(tx, ty) {
    this.s5e_1.h5s_1 = this.s5e_1.h5s_1.f3n(tx, ty);
  }
  f60(m) {
    this.s5e_1.h5s_1 = this.s5e_1.h5s_1.g3n(m);
  }
  b73(_set____db54di) {
    this.u5e_1 = _set____db54di;
  }
  c73() {
    return this.u5e_1;
  }
  d73(_set____db54di) {
    this.v5e_1 = _set____db54di;
  }
  v4y() {
    return this.v5e_1;
  }
  u4y() {
    return this.s5e_1.j5s_1.u4y();
  }
  p6() {
    this.s5e_1.j5s_1.p6();
    this.d73(this.c73());
  }
  k4p(p) {
    this.s5e_1.j5s_1.k4p(trans(this, p));
    this.d73(p);
    this.b73(p);
  }
  x4p(p) {
    this.s5e_1.j5s_1.x4p(trans(this, p));
    this.d73(p);
  }
  y4p(c, a) {
    this.s5e_1.j5s_1.y4p(trans(this, c), trans(this, a));
    this.d73(a);
  }
  l4p(c1, c2, a) {
    this.s5e_1.j5s_1.l4p(trans(this, c1), trans(this, c2), trans(this, a));
    this.d73(a);
  }
  g6g(path) {
    if (this.j1())
      this.s5e_1.j5s_1.p4p_1 = path.p4p_1;
    write_0(this, path);
  }
  g60(d) {
    d.e60(this);
  }
  f5t(x, y, width, height) {
    this.h60();
    this.z4y(x, y, width, height);
    this.v5z();
  }
  h60() {
    this.s5e_1.j5s_1 = new VectorPath();
  }
  u5z() {
    if (!equals(this.s5e_1.q5s_1, NonePaint_instance)) {
      this.k72(this.s5e_1, false);
    }
  }
  e73(winding) {
    if (!equals(this.s5e_1.r5s_1, NonePaint_instance)) {
      this.j72(this.s5e_1, true, winding);
    }
  }
  v5z(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.e73(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.e73.call(this, winding);
    }
    return tmp;
  }
  f73(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.d5t();
    this.e5t(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.e73(winding);
    }finally {
      this.e5t(oldStyle);
    }
  }
  e6g(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.f73(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.f73.call(this, paint, winding);
    }
    return tmp;
  }
  g73(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.y72();
    this.x72(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.u5z();
    }finally {
      this.x72(oldStyle);
    }
  }
  h73(path, winding) {
    if (!(path == null)) {
      if (this.s5e_1.i5s_1 == null) {
        this.s5e_1.i5s_1 = new VectorPath();
      }
      ensureNotNull(this.s5e_1.i5s_1).h3();
      ensureNotNull(this.s5e_1.i5s_1).p4p_1 = winding;
      ensureNotNull(this.s5e_1.i5s_1).m4z(path);
      if (path === this.s5e_1.j5s_1) {
        path.h3();
      }
    } else {
      this.s5e_1.i5s_1 = null;
    }
  }
  i73(path, winding, $super) {
    path = path === VOID ? this.s5e_1.j5s_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.h73(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.h73.call(this, path, winding);
    }
    return tmp;
  }
  g5t(image, pos, size) {
    return this.l72(image, pos, size, this.s5e_1.h5s_1);
  }
  n6q(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.g1()) : size;
    var tmp;
    if ($super === VOID) {
      this.g5t(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.g5t.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_48 = this;
    this.j73_1 = values_7();
  }
}
class CycleMethod extends Enum {
  q6t() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  n6t(ratio) {
    var tmp;
    switch (this.p3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod_0(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  k73(ratio) {
    return this.n6t(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.l73_1 = beziers;
    var tmp = this;
    tmp.m73_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.n73_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.o73_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.p73_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.q73_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.r73_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.s73_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  d74() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m73_1;
    red$factory();
    return this_0.w1();
  }
  e74() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n73_1;
    green$factory();
    return this_0.w1();
  }
  f74() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o73_1;
    blue$factory();
    return this_0.w1();
  }
  t73() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p73_1;
    allProjected$factory();
    return this_0.w1();
  }
  y73() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q73_1;
    redProjected$factory();
    return this_0.w1();
  }
  z73() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r73_1;
    greenProjected$factory();
    return this_0.w1();
  }
  a74() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s73_1;
    blueProjected$factory();
    return this_0.w1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.b74_1 = bezier;
    this.c74_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.b74_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.c74_1) + ')';
  }
  hashCode() {
    var result = this.b74_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.c74_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.b74_1.equals(tmp0_other_with_cast.b74_1))
      return false;
    if (!(this.c74_1 === tmp0_other_with_cast.c74_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.u73_1 = beziers;
    this.v73_1 = new ProjectedPoint();
    this.w73_1 = Companion_getInstance_2().c3m();
  }
  x73(point) {
    return Companion_getInstance_7().d3t(point, this.q4o(point));
  }
  q4o(point) {
    if (this.u73_1.j1())
      return Vector2D.k3l(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.u73_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.h1(_unary__edvuaz).b4o().j3k(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.i3l();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.u73_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.h1(_unary__edvuaz_0);
        if (it.b4o().i3k(point) > minDistSq) {
          break $l$block;
        }
        it.o4o(point, this.v73_1);
        if (this.v73_1.b4n_1 < bminDistSq) {
          bminDistSq = this.v73_1.b4n_1;
          out = this.v73_1.z4m_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.g74(path) : getPath(path);
}
function get_bounds() {
  return this.h74(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.d3e();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_2(Companion_getInstance_6().p3j(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().o3j() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.d3e();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.m4z(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.s5e_1.h5s_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.h60();
    var tmp348_safe_receiver = this.d3e();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.p74() == null)) {
      draw_0(ensureNotNull(this.p74()), c);
      c.i73();
    }
    c.f60(get_immutable(this.j6t()));
    this.q74(c);
  }finally {
    c.s5e_1.h5s_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().z3l_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.i74_1 = path;
    this.j74_1 = clip;
    this.k74_1 = paint;
    this.l74_1 = transform;
    this.m74_1 = globalAlpha;
    var tmp = this;
    tmp.n74_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.o74_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  d3e() {
    return this.i74_1;
  }
  p74() {
    return this.j74_1;
  }
  j6t() {
    return this.l74_1;
  }
  q74(c) {
    c.f73(this.k74_1, this.i74_1.p4p_1);
  }
  toString() {
    return 'FillShape(path=' + this.i74_1.toString() + ', clip=' + toString(this.j74_1) + ', paint=' + toString_0(this.k74_1) + ', transform=' + this.l74_1.toString() + ', globalAlpha=' + this.m74_1 + ')';
  }
  hashCode() {
    var result = this.i74_1.hashCode();
    result = imul(result, 31) + (this.j74_1 == null ? 0 : this.j74_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.k74_1) | 0;
    result = imul(result, 31) + this.l74_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.m74_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.i74_1.equals(tmp0_other_with_cast.i74_1))
      return false;
    if (!equals(this.j74_1, tmp0_other_with_cast.j74_1))
      return false;
    if (!equals(this.k74_1, tmp0_other_with_cast.k74_1))
      return false;
    if (!this.l74_1.equals(tmp0_other_with_cast.l74_1))
      return false;
    if (!equals(this.m74_1, tmp0_other_with_cast.m74_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.r74_1 = components;
  }
  h74(includeStrokes) {
    var bb = Companion_getInstance_6().p3j();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.r74_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.h1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, it.h74(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  e60(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.p72();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.r74_1;
        var n = 0;
        while (n < this_0.g1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.h1(_unary__edvuaz).e60(c);
        }
        break $l$block;
      }finally {
        c.q72();
      }
    }
    return Unit_instance;
  }
  g74(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.r74_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.h1(_unary__edvuaz).g74(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.r74_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.t74_1 = path;
    this.u74_1 = clip;
    this.v74_1 = paint;
    this.w74_1 = transform;
    this.x74_1 = strokeInfo;
    this.y74_1 = globalAlpha;
    this.z74_1 = thickness$factory(this.x74_1);
    this.a75_1 = scaleMode$factory(this.x74_1);
    this.b75_1 = startCap$factory(this.x74_1);
    this.c75_1 = endCap$factory(this.x74_1);
    this.d75_1 = join$factory(this.x74_1);
    this.e75_1 = miterLimit$factory(this.x74_1);
    this.f75_1 = dash$factory(this.x74_1);
    this.g75_1 = dashOffset$factory(this.x74_1);
    var tmp = this;
    tmp.h75_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  d3e() {
    return this.t74_1;
  }
  p74() {
    return this.u74_1;
  }
  j6t() {
    return this.w74_1;
  }
  h74(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_2(Companion_getInstance_6().p3j(), this.t74_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.x74_1.h4y_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.x50(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.y50();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().l3j_1 : tmp0_elvis_lhs;
  }
  i75(c) {
    c.r72(this.x74_1.j4y_1);
    c.s72(this.x74_1.h4y_1);
    c.u72(this.x74_1.k4y_1);
    c.v72(this.x74_1.l4y_1);
    c.w72(this.x74_1.m4y_1);
    c.t72(this.x74_1.n4y_1);
    c.z72(this.x74_1.o4y_1);
    c.a73(this.x74_1.p4y_1);
  }
  q74(c) {
    this.i75(c);
    c.g73(this.v74_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.t74_1.toString() + ', clip=' + toString(this.u74_1) + ', paint=' + toString_0(this.v74_1) + ', transform=' + this.w74_1.toString() + ', strokeInfo=' + this.x74_1.toString() + ', globalAlpha=' + this.y74_1 + ')';
  }
  hashCode() {
    var result = this.t74_1.hashCode();
    result = imul(result, 31) + (this.u74_1 == null ? 0 : this.u74_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.v74_1) | 0;
    result = imul(result, 31) + this.w74_1.hashCode() | 0;
    result = imul(result, 31) + this.x74_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.y74_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.t74_1.equals(tmp0_other_with_cast.t74_1))
      return false;
    if (!equals(this.u74_1, tmp0_other_with_cast.u74_1))
      return false;
    if (!equals(this.v74_1, tmp0_other_with_cast.v74_1))
      return false;
    if (!this.w74_1.equals(tmp0_other_with_cast.w74_1))
      return false;
    if (!this.x74_1.equals(tmp0_other_with_cast.x74_1))
      return false;
    if (!equals(this.y74_1, tmp0_other_with_cast.y74_1))
      return false;
    return true;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_59());
    var tmp = this;
    tmp.z5w_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.a5x_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.b5x_1 = ArrayList.z();
  }
  h72() {
    return this.z5w_1;
  }
  i72() {
    return this.a5x_1;
  }
  j72(state, fill, winding) {
    if (state.j5s_1.j1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.j5s_1.z27();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.p4p_1 = winding == null ? this_0.p4p_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.i5s_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.z27();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.p4p_1 = winding == null ? tmp368_safe_receiver.p4p_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.h5s_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.b5x_1;
      var element = new FillShape(path, clip, state.r5s_1.z27(), transform, state.x5s_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.b5x_1;
      var tmp_2 = state.q5s_1.z27();
      var tmp369_thickness = state.l5s_1;
      var tmp370_scaleMode = state.k5s_1;
      var tmp371_startCap = state.m5s_1;
      var tmp372_endCap = state.n5s_1;
      var tmp373_join = state.o5s_1;
      var tmp374_dash = state.z5s_1;
      var tmp375_dashOffset = state.a5t_1;
      var tmp376_miterLimit = state.p5s_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.x5s_1);
      this_2.h(element_0);
    }
  }
  l72(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.y4y(pos, size);
    this.k72(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().z3l_1, size.g3s(toFloat(image.g1()))).b3n(pos))), true);
  }
  m72() {
  }
  n72() {
    return 0;
  }
  o72() {
  }
  c5x() {
    return this.b5x_1.g1() === 1 ? first_0(this.b5x_1) : new CompoundShape(toList(this.b5x_1));
  }
  e60(c) {
    c.g60(this.c5x());
  }
}
class SvgPath {
  s74(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.z();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
          var x = destruct.em();
          var y = destruct.fm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
          var x_0 = destruct_0.em();
          var y_0 = destruct_0.fm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
          var x1 = destruct_1.em();
          var y1 = destruct_1.fm();
          var x2 = destruct_2.em();
          var y2 = destruct_2.fm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
          var x1_0 = destruct_3.em();
          var y1_0 = destruct_3.fm();
          var x2_0 = destruct_4.em();
          var y2_0 = destruct_4.fm();
          var x3 = destruct_5.em();
          var y3 = destruct_5.fm();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.a71_1 = false;
    this.b71_1 = 2;
    this.c71_1 = 1;
    this.d71_1 = new PolygonScanline();
    this.e71_1 = new PolygonScanline();
    this.f71_1 = new IntSegmentSet();
    this.g71_1 = new IntSegmentSet();
    this.h71_1 = new IntSegmentSet();
    this.i71_1 = IntArrayList.l3w(1024);
  }
  u1w() {
    this.d71_1.u1w();
    this.e71_1.u1w();
  }
  j75(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.u1w();
    }
    var xmin = this.t4v(bounds.i3j());
    var xmax = this.t4v(bounds.j3j());
    var tempRect = this.d71_1.y4l();
    // Inline function 'kotlin.math.max' call
    var a = bounds.d3q();
    var b = tempRect.d3q();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.t4v(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.c3q();
    var b_0 = tempRect.c3q();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.t4v(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.i71_1.h3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.l4w() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.l4w()) / this.c71_1 | 0) / q | 0) | 0;
        this.i71_1.r3w(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i71_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.x27(_unary__edvuaz);
      this.d71_1.g4w(y_0, winding, this.f71_1);
      edgesChecked = edgesChecked + this.d71_1.r4v_1 | 0;
      if (this.e71_1.d1t()) {
        this.e71_1.g4w(y_0, this.e71_1.c4v_1, this.g71_1);
        edgesChecked = edgesChecked + this.e71_1.r4v_1 | 0;
        this.h71_1.a4l(this.f71_1, this.g71_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.e71_1.d1t() ? this.h71_1 : this.f71_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.g1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.s4k_1.x27(n_1), this_1.t4k_1.x27(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.n75(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  j71(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.b71_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.j75(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.j75.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_59();
    super();
    this.q75_1 = width;
    this.r75_1 = height;
  }
  f3u() {
    return this.q75_1;
  }
  g3u() {
    return this.r75_1;
  }
}
class Companion_42 extends DummyRenderer {
  constructor() {
    Companion_instance_49 = null;
    super(128, 128);
    Companion_instance_49 = this;
  }
}
class HtmlCanvas {
  z54(width, height) {
    if (Companion_getInstance_10().a24()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  n76(width, height) {
    return HtmlCanvas_instance.z54(width, height);
  }
  o76(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  p76(bmp, canvas) {
    return this.o76(_RgbaArray___init__impl__oib4y4(bmp.w5h().h56_1), bmp.r56_1, bmp.s56_1, canvas);
  }
  s75(bmp) {
    return this.p76(bmp, this.n76(bmp.r56_1, bmp.s56_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  k6p(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  d6q(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  u5k(width, height, premultiplied) {
    return HtmlNativeImage.m76(HtmlCanvas_instance.z54(width, height));
  }
  t5k(bmp) {
    return HtmlNativeImage.m76(HtmlImage_instance.s75(bmp.d57()));
  }
}
class HtmlNativeImage extends NativeImage {
  static v76(texSourceBase, width, height) {
    var $this = this.s5k(width, height, texSourceBase, true);
    $this.h76_1 = texSourceBase;
    $this.i76_1 = $this.h76_1;
    var tmp = $this;
    tmp.j76_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.k76_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.l76_1 = Monotonic_instance.fk();
    return $this;
  }
  q3() {
    return 'HtmlNativeImage';
  }
  static s76(img) {
    return this.v76(img, img.width, img.height);
  }
  static m76(canvas) {
    return this.v76(canvas, canvas.width, canvas.height);
  }
  u76() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j76_1;
    lazyCanvasElement$factory();
    return this_0.w1();
  }
  w76() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k76_1;
    ctx$factory();
    return this_0.w1();
  }
  o57(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.h76_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.fk();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.l76_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.l76_1 = now;
        this.w76().clearRect(0.0, 0.0, width, height);
        this.w76().drawImage(this.h76_1, 0.0, 0.0);
      }
    }
    var idata = this.w76().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.y56_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  q57(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.w76().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.y56_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.w76().putImageData(idata, x, y);
  }
  n5e(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.u76()));
  }
  x76(type, quality) {
    return this.u76().toDataURL(type, quality);
  }
  y76(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.x76(type, quality) : $super.x76.call(this, type, quality);
  }
}
class BrowserImage {
  q76(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  a77(img) {
    return this.t76(img, img.width, img.height);
  }
  t76(img, width, height) {
    var canvas = HtmlCanvas_instance.z54(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  r76(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.q2j();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_10().a24()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.h5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.c2h();
  }
  z76(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
    return $super === VOID ? this.r76(jsUrl, props, $completion) : $super.r76.call(this, jsUrl, props, $completion);
  }
  v54(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.d77_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e77_1 = this.d77_1.getContext('2d');
    this.f77_1 = NaN;
    this.g77_1 = null;
  }
  f3u() {
    return this.d77_1.width;
  }
  g3u() {
    return this.d77_1.height;
  }
  k77(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.l6b_1.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.l6b_1.x27(n);
        var color = paint.m6b_1.x27(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  i77(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.o5p_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.e6b_1.p3_1) {
            case 0:
              tmp_0 = this.k77(this.e77_1.createLinearGradient(_this__u8e3s4.f6b_1, _this__u8e3s4.g6b_1, _this__u8e3s4.i6b_1, _this__u8e3s4.j6b_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.k77(this.e77_1.createRadialGradient(_this__u8e3s4.f6b_1, _this__u8e3s4.g6b_1, _this__u8e3s4.h6b_1, _this__u8e3s4.i6b_1, _this__u8e3s4.j6b_1, _this__u8e3s4.k6b_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.e77_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.e77_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.r6b_1), _this__u8e3s4.f6b_1, _this__u8e3s4.g6b_1);
                tmp_1 = this.k77(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.z6s_1).i76_1;
            tmp = this.e77_1.createPattern(tmp$ret$3, _this__u8e3s4.p6t() && _this__u8e3s4.r6t() ? 'repeat' : _this__u8e3s4.p6t() ? 'repeat-x' : _this__u8e3s4.r6t() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  l77(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  m77(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.o3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  h77(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.l77(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.m77(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  j77(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.e3m_1, m.f3m_1, m.g3m_1, m.h3m_1, m.i3m_1, m.j3m_1);
  }
  t71(image, pos, size, transform) {
    this.e77_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.e77_1.setTransform(transform.e3m_1, transform.f3m_1, transform.g3m_1, transform.h3m_1, transform.i3m_1, transform.j3m_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).i76_1;
      this.e77_1.drawImage(tmp$ret$2, pos.r3i_1, pos.s3i_1, size.u3j_1, size.v3j_1);
    }finally {
      this.e77_1.restore();
    }
  }
  n77(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
          var x = destruct.em();
          var y = destruct.fm();
          this.e77_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
          var x_0 = destruct_0.em();
          var y_0 = destruct_0.fm();
          this.e77_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
          var cx = destruct_1.em();
          var cy = destruct_1.fm();
          var ax = destruct_2.em();
          var ay = destruct_2.fm();
          this.e77_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
          var cx1 = destruct_3.em();
          var cy1 = destruct_3.fm();
          var cx2 = destruct_4.em();
          var cy2 = destruct_4.fm();
          var ax_0 = destruct_5.em();
          var ay_0 = destruct_5.fm();
          this.e77_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.e77_1.closePath();
          break;
      }
    }
  }
  k71(state, fill, winding) {
    if (state.j5s_1.j1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.e77_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.i5s_1;
        if (!(clip == null)) {
          this.e77_1.beginPath();
          this.n77(clip);
          this.e77_1.clip(this.o77(winding == null ? clip.p4p_1 : winding));
        }
        this.e77_1.beginPath();
        this.n77(state.j5s_1);
        this.j77(this.e77_1, state.h5s_1);
        if (fill) {
          transformPaint(this, state.r5s_1);
          this.e77_1.fill(this.o77(winding == null ? state.j5s_1.p4p_1 : winding));
        } else {
          transformPaint(this, state.q5s_1);
          var lineDash = state.z5s_1;
          if (!(lineDash == null)) {
            this.e77_1.lineDashOffset = state.a5t_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.f3x();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.b1();
            while (_iterator__ex2g4s.c1()) {
              var v = _iterator__ex2g4s.d1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.s29(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.e77_1.setLineDash(tmp$ret$3);
          }
          this.e77_1.stroke();
        }
        break $l$block;
      }finally {
        this.e77_1.restore();
      }
    }
  }
  o77(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.p3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.o46() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.r55_1);
  $this.j55_1 = Companion_instance_0.c4q(width, height);
  $this.p55_1 = Bitmap32.k56(width, height, VOID, $this.l55_1);
  $this.q55_1.h3();
  $this.q55_1.h($this.p55_1);
  $this.s55_1.h3();
  $this.r55_1.h3();
  var _iterator__ex2g4s = slices.b1();
  while (_iterator__ex2g4s.c1()) {
    var entry = _iterator__ex2g4s.d1();
    $this.l56(entry.h55_1, entry.i55_1, entry.h55_1.m4r_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.n55_1.p3_1) {
    case 0:
      reconstructWithSize($this, imul($this.f3u(), 2), imul($this.g3u(), 2));
      break;
    case 1:
      if (bmp.r4r_1 > $this.f3u() || bmp.s4r_1 > $this.g3u()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.f3u() + 'x' + $this.g3u() + ') to hold a slice of (' + bmp.r4r_1 + 'x' + bmp.s4r_1 + ')';
        throw IllegalStateException.h5(toString_0(message));
      }

      $this.j55_1 = Companion_instance_0.c4q($this.f3u(), $this.g3u());
      $this.p55_1 = Bitmap32.k56($this.f3u(), $this.g3u(), VOID, $this.l55_1);
      $this.q55_1.h($this.p55_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.r56_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.o57(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.c57_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.v56_1;
  if (false) {
    this_0.e57();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.n5e(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.k2i();
    }
  }finally {
    result = false ? this_0.g57(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.x56_1 = true;
  _this__u8e3s4.y56_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.j57();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.w5e_1.x3r();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.qm(new RGBA($this.w5e_1.x5e(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_6;
function Companion_getInstance_16() {
  if (Companion_instance_6 === VOID)
    new Companion();
  return Companion_instance_6;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.g5g($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).h56_1);
  var width = _this__u8e3s4.j3j() - _this__u8e3s4.i3j() | 0;
  var inductionVariable = _this__u8e3s4.d3q();
  var last = _this__u8e3s4.c3q();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.m57(_this__u8e3s4.i3j(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.i3j() + ', top=' + _this__u8e3s4.d3q() + ', right=' + _this__u8e3s4.j3j() + ', bottom=' + _this__u8e3s4.c3q();
        throw IllegalStateException.h5(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.d3q(), area.i3j(), area.c3q(), area.j3j(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.h56_1;
  var x0Index = _this__u8e3s4.m57(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.m57(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.r56_1 | 0;
      x1Index = x1Index + _this__u8e3s4.r56_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.m57(x, areaTop), data, _this__u8e3s4.m57(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.m57(x, areaBottom - 1 | 0), data, _this__u8e3s4.m57(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_7;
function Companion_getInstance_17() {
  return Companion_instance_7;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_8;
function Companion_getInstance_18() {
  BitmapChannel_initEntries();
  if (Companion_instance_8 === VOID)
    new Companion_1();
  return Companion_instance_8;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_18();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.j4r_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.r4s();
}
function slice_0(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.j3r(0, 0, _this__u8e3s4.r56_1, _this__u8e3s4.s56_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().y4q_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().p3l_1 : padding;
  var left = clamp(bounds.i3j(), 0, _this__u8e3s4.r56_1);
  var top = clamp(bounds.d3q(), 0, _this__u8e3s4.s56_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_1.p3q(left, top, clamp(bounds.j3j(), left, _this__u8e3s4.r56_1), clamp(bounds.c3q(), top, _this__u8e3s4.s56_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.k4r_1) ? _this__u8e3s4.j4r_1.h3r_1 : _this__u8e3s4.j4r_1.i3r_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.k4r_1) ? _this__u8e3s4.j4r_1.i3r_1 : _this__u8e3s4.j4r_1.h3r_1;
  var tmp = get_container(_this__u8e3s4).m5e(w + _this__u8e3s4.l4r_1.x3l() | 0, h + _this__u8e3s4.l4r_1.y3l() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).l5e(_this__u8e3s4.k4r_1);
  raw.z5d(0, 0, out, _this__u8e3s4.l4r_1.t3l_1, _this__u8e3s4.l4r_1.q3l_1, raw.r56_1, raw.s56_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().y4q_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().p3l_1 : padding;
  return slice_0(_this__u8e3s4, RectangleInt.j3r(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).m5e(_this__u8e3s4.j4r_1.h3r_1, _this__u8e3s4.j4r_1.i3r_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).w5d(_this__u8e3s4.j4r_1.f3r_1, _this__u8e3s4.j4r_1.g3r_1, out, 0, 0, _this__u8e3s4.j4r_1.h3r_1, _this__u8e3s4.j4r_1.i3r_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice_0(Companion_getInstance_16().z5e(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().d58_1)), VOID, 'transparent');
    Bitmaps_white = slice_0(Companion_getInstance_16().z5e(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().y57_1)), VOID, 'white');
  }
}
var Companion_instance_9;
function Companion_getInstance_19() {
  return Companion_instance_9;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.c5e(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.p57(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.x5i(x + dx | 0, y + dy | 0) + d < this$0.x5i(x, y)) {
    this$0.t5i(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.u5i(x, y) | 0;
    var y_0 = y - this$0.v5i(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.w5i(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.r56_1, _this__u8e3s4.s56_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.z5i(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.m57(x, y), 4);
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().t5k(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().u5k(width, height, premultiplied);
}
var Companion_instance_10;
function Companion_getInstance_20() {
  return Companion_instance_10;
}
function NinePatchInfo$Segment$bmp$delegate$lambda(this$0) {
  return function () {
    var tmp21_safe_receiver = this$0.z5l_1;
    return tmp21_safe_receiver == null ? null : extract_0(tmp21_safe_receiver);
  };
}
function get_length(_this__u8e3s4) {
  return (_this__u8e3s4.g2_1 - _this__u8e3s4.f2_1 | 0) + 1 | 0;
}
function asNinePatchSimple(_this__u8e3s4, left, top, right, bottom) {
  return Companion_instance_10.w5k(_this__u8e3s4, left, top, right, bottom);
}
var Companion_instance_11;
function Companion_getInstance_21() {
  if (Companion_instance_11 === VOID)
    Companion_4.d5n();
  return Companion_instance_11;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_16().a5f(_this__u8e3s4.r56_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.s56_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.x56_1);
  out.t5g(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.d5o();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.w5n_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.w5n_1);
  }
  if (!(effect.z5n_1 === 0) || !(effect.x5n_1 === 0) || !(effect.y5n_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.x5n_1, effect.y5n_1, effect.z5n_1, effect.a5o_1);
  }
  if (!(effect.b5o_1 === 0)) {
    borderInline(_this__u8e3s4, effect.b5o_1, effect.c5o_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r56_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s56_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.u5h(_this__u8e3s4.r56_1, _this__u8e3s4.s56_1);
  var t2 = Bitmap8.u5h(_this__u8e3s4.r56_1, _this__u8e3s4.s56_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_18().h1(n);
      _this__u8e3s4.y5g(channel, t1);
      arraycopy_0(t1.d5g(), 0, t2.d5g(), 0, t2.x3r());
      gaussBlur(t1.d5g(), t2.d5g(), _this__u8e3s4.r56_1, _this__u8e3s4.s56_1, r_0);
      _this__u8e3s4.x5g(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.u5h(_this__u8e3s4.r56_1 + imul(r, 2) | 0, _this__u8e3s4.s56_1 + imul(r, 2) | 0);
  Companion_instance_7.b5i(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.r56_1, _this__u8e3s4.s56_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r56_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s56_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.u5h(_this__u8e3s4.r56_1, _this__u8e3s4.s56_1);
  arraycopy_0(_this__u8e3s4.d5g(), 0, t2.d5g(), 0, _this__u8e3s4.x3r());
  gaussBlur(t2.d5g(), _this__u8e3s4.d5g(), _this__u8e3s4.r56_1, _this__u8e3s4.s56_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().z57_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.s56_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.r56_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.x5i(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.i5g(x, y, Companion_getInstance_24().e5o(rcolor, out.j5g(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().z57_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.z27();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.z5g(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.x56_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.x5f_1, n, Companion_getInstance_24().f5o(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.d57();
  _this__u8e3s4.r5g(Colors_getInstance().d58_1);
  _this__u8e3s4.u5g(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.u5g(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.p5o()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.p5o());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_24().f5o(_this__u8e3s4.q5o(c), _this__u8e3s4.r5o(c), _this__u8e3s4.s5o(c), _this__u8e3s4.t5o(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.p5o() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_12;
function Companion_getInstance_22() {
  if (Companion_instance_12 === VOID)
    new Companion_5();
  return Companion_instance_12;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__contains_impl_ofn00n_0($this, element) {
  if (!(element instanceof RGBA))
    return false;
  return RgbaArray__contains_impl_ofn00n($this.u5p_1, element instanceof RGBA ? element.o5p_1 : THROW_CCE());
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.j1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.o5p_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.u5p_1, elements);
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.u5p_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.u5p_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withRGB_impl_scofdy($this, r, g, b) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & -16777216 | clampUByte(r) << 0 | clampUByte(g) << 8 | clampUByte(b) << 16);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.mc(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.hc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.mc(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.hc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.o5p_1, other instanceof RGBA ? other.o5p_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
function RGBA__times_impl_wehs9n($this, other) {
  return Companion_getInstance_24().y5p($this, other);
}
var Companion_instance_14;
function Companion_getInstance_24() {
  if (Companion_instance_14 === VOID)
    new Companion_7();
  return Companion_instance_14;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.o5p_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().d58_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_24();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.f5o(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.l5q_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_15.j5q(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_17;
function Companion_getInstance_27() {
  return Companion_instance_17;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.p5q_1).d57();
  };
}
var Companion_instance_18;
function Companion_getInstance_28() {
  return Companion_instance_18;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.m5t_1;
    var baseline = 0.0;
    var tmp = -this$0.r5t_1;
    var tmp_0 = -this$0.r5t_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.n5t_1.n3().b1();
    while (_iterator__ex2g4s.c1()) {
      var glyph = _iterator__ex2g4s.d1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.p5q_1.r4r_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.k5t_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.n5t_1.h1(this$0.n5t_1.f3().b1().d1());
    return tmp0_elvis_lhs == null ? this$0.w5t() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.k5t_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.e3h(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.a9();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.cj('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.u2b('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.cj('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.u2b('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.cj('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.u2b('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.cj('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.v2b('fieldType');
  var _iterator__ex2g4s = get_0(xml.cj('pages'), 'page').b1();
  while (_iterator__ex2g4s.c1()) {
    var page = _iterator__ex2g4s.d1();
    var id = page.r2b('id');
    var file = page.t2b('file');
    var texFile = fntFile.z3g().cj(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.k3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_0(xml.cj('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.r2b('page');
    var tmp0_elvis_lhs_0 = textures.e3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.n3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.r2b('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.z4s(item.r2b('x'), item.r2b('y'), item.r2b('width'), item.r2b('height'));
      tmp_1 = atlas.h57(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.h55_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.z4s(item.r2b('x'), item.r2b('y'), item.r2b('width'), item.r2b('height')) : tmp1_elvis_lhs_0, item.r2b('xoffset'), item.r2b('yoffset'), item.r2b('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get_0(xml.cj('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.b1();
  while (tmp0_iterator_0.c1()) {
    var item_0 = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.r2b('first'), item_0.r2b('second'), item_0.r2b('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.b1();
  while (tmp0_iterator_1.c1()) {
    var item_1 = tmp0_iterator_1.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.o5q_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.b1();
  while (tmp0_iterator_2.c1()) {
    var item_2 = tmp0_iterator_2.d1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_17.m5q(item_2.v5q_1, item_2.w5q_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_12().i29(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.g1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.h1(n).g4a_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.z3g().cj(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.k3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.g4a_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.e3(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.n3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.z4s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.h57(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.h55_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.z4s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.b1();
  while (tmp0_iterator_0.c1()) {
    var item_0 = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.g4a_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.b1();
  while (tmp0_iterator_1.c1()) {
    var item_1 = tmp0_iterator_1.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.o5q_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.b1();
  while (tmp0_iterator_2.c1()) {
    var item_2 = tmp0_iterator_2.d1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_17.m5q(item_2.v5q_1, item_2.w5q_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.z();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.z();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).b1();
  while (_iterator__ex2g4s.c1()) {
    var rline = _iterator__ex2g4s.d1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.wc();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).b1();
    while (_iterator__ex2g4s_0.c1()) {
      var part = _iterator__ex2g4s_0.d1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.h1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.h1(1);
      // Inline function 'kotlin.collections.set' call
      map.k3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.e3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.e3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.e3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.h5(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.z3g().cj(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice_0(mipmaps(tmp_0, mipmaps_0));
      textures.k3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.e3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.e3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.e3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.e3(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.n3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.z4s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.h57(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.h55_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.z4s(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.e3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.e3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.e3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = glyphs.b1();
  while (tmp0_iterator.c1()) {
    var element_1 = tmp0_iterator.d1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.o5q_1;
    destination.k3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_17.m5q(it.v5q_1, it.w5q_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.a5r();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.g5r();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.f5r();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.w5t();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.fk();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.l5w(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.qs_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.t5r(size);
  var gmetrics = _this__u8e3s4.b5s(size, codePoint, VOID, reader);
  var gx = -gmetrics.i3j();
  var gy = gmetrics.g3u() + gmetrics.d3q();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.f3u()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.g3u()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.k56(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.v56_1;
  if (true) {
    image.e57();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.n5e(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.k2i();
    }
  }finally {
    result = true ? image.g57(rect) : 0;
  }
  var imageOut = applyEffect(image.o5e(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.y3k(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().z3l_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.c5x();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.q4p_1 = false;
    this_0.z4y(this$0.f5x_1.i3j(), -this$0.g5x_1.l5r_1, this$0.f5x_1.z5r_1, this$0.g5x_1.o5x());
    return applyTransform(this_0, Companion_getInstance_5().c3m().b3n(this$0.e5x_1).g3n(this$0.h5x_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.p5x());
    var tmp;
    if (!(curves.h4l_1.g1() === 4)) {
      println('curves=' + curves.h4l_1.g1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.q5x().h4l_1.h1(3).a4p();
    var tmp$ret$0 = Line2D.g3l(this_0.f3l_1, this_0.e3l_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.q5x().h4l_1.h1(1);
  };
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_52().x5x_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.i5r(size, out.t5y_1);
  out.u5y_1 = actions.k5z();
  var bb = Companion_getInstance_6().p3j();
  var dy = 0.0;
  var lineBounds = FastArrayList.u28();
  var offsetY = actions.o5z(align.m5z_1, out.t5y_1);
  var _iterator__ex2g4s = actions.i5z_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var line = _iterator__ex2g4s.d1();
    var offsetX = line.s5z(align.l5z_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.t5z(), line.q5z_1, line.p5z_1);
    bb = BoundsBuilder__plus_impl_cz7f7x(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.p5z_1;
  }
  out.s5y_1 = lineBounds;
  out.r5y_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.e5t($paint);
  font.h5t(_this__u8e3s4, $size, $codePoint, Vector2D.y3k(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.v5z();
  } else {
    _this__u8e3s4.u5z();
  }
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.p5x();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.q5x();
  }, null);
}
var SystemFontRegistryOrNull;
function get_lazyBitmap(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmap$delegate;
    var property = lazyBitmap$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmap$delegate;
var lazyBitmapSDF$delegate;
var Companion_instance_19;
function Companion_getInstance_29() {
  if (Companion_instance_19 === VOID)
    new Companion_12();
  return Companion_instance_19;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.r60_1.h1(this$0.r60_1.f3().b1().d1());
    return tmp0_elvis_lhs == null ? this$0.w5t() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.l60_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.o60_1.n5r_1 - this$0.o60_1.p5r_1;
    var tmp78_size = this$0.o60_1.j5r_1;
    var tmp79_top = this$0.o60_1.k5r_1;
    var tmp80_ascent = this$0.o60_1.l5r_1;
    var tmp81_baseline = this$0.o60_1.m5r_1;
    var tmp82_maxWidth = this$0.o60_1.q5r_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function get_lazyBitmap_0(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp;
  if (isInterface(_this__u8e3s4, VectorFont)) {
    tmp = get_lazyBitmap(_this__u8e3s4);
  } else {
    if (isInterface(_this__u8e3s4, BitmapFont)) {
      tmp = _this__u8e3s4;
    } else {
      throw NotImplementedError.je();
    }
  }
  return tmp;
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmap$factory() {
  return getPropertyCallableRef('lazyBitmap', 1, KProperty1, function (receiver) {
    return get_lazyBitmap(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.f5r();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.w5t();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.g5r();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_20;
function Companion_getInstance_30() {
  Op_initEntries();
  if (Companion_instance_20 === VOID)
    new Companion_13();
  return Companion_instance_20;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_30();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_21;
function Companion_getInstance_31() {
  Op_initEntries_0();
  if (Companion_instance_21 === VOID)
    new Companion_14();
  return Companion_instance_21;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_31();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_22;
function Companion_getInstance_32() {
  if (Companion_instance_22 === VOID)
    new Companion_15();
  return Companion_instance_22;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.k68_1;
  ss$factory();
  return this_0.w1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.j68_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.f30($table.h68_1, $table.i68_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_23;
function Companion_getInstance_33() {
  return Companion_instance_23;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_24;
function Companion_getInstance_34() {
  Colrv1Paint_initEntries();
  if (Companion_instance_24 === VOID)
    new Companion_17();
  return Companion_instance_24;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_34();
}
var Companion_instance_25;
function Companion_getInstance_35() {
  return Companion_instance_25;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_26;
function Companion_getInstance_36() {
  return Companion_instance_26;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
function set_onlyReadVisibleLayers(_this__u8e3s4, _set____db54di) {
  _init_properties_ASE_kt__16anup();
  var this_0 = onlyReadVisibleLayers$delegate;
  var property = onlyReadVisibleLayers$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_onlyReadVisibleLayers(_this__u8e3s4) {
  _init_properties_ASE_kt__16anup();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = onlyReadVisibleLayers$delegate;
    var property = onlyReadVisibleLayers$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var onlyReadVisibleLayers$delegate;
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function ASE$AseSlice$sortKeys$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp = a.p6g_1;
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp$ret$1 = b.p6g_1;
  return compareValues(tmp, tmp$ret$1);
}
function takeLayersByName(_this__u8e3s4, $this, name) {
  var tmp;
  if (getExtra(_this__u8e3s4, 'layers') == null) {
    tmp = true;
  } else {
    var tmp_0 = getExtra(_this__u8e3s4, 'layers');
    tmp = contains_0((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), name);
  }
  return tmp;
}
function slicingEnabled(_this__u8e3s4, $this) {
  return getExtraTyped(_this__u8e3s4, 'disableSlicing') == null || !ensureNotNull(getExtraTyped(_this__u8e3s4, 'disableSlicing'));
}
function useSlicePosition(_this__u8e3s4, $this) {
  return !(getExtraTyped(_this__u8e3s4, 'useSlicePosition') == null) && ensureNotNull(getExtraTyped(_this__u8e3s4, 'useSlicePosition'));
}
function readImageContainer$createImageFrameLayer(imageLayers, image, key, value) {
  var resolved = value.d6h();
  var layer = imageLayers.h1(key);
  var tilemap = null;
  if (resolved instanceof AseTilemapCell) {
    var tileset = image.f6k_1.h1(layer.h6i_1);
    var tmp = Companion_instance_44;
    tilemap = tmp.g6k(resolved.p6h_1, tileset == null ? null : tileset.h6j_1, resolved.q6h_1, resolved.r6h_1, resolved.s6h_1, resolved.t6h_1);
  }
  return new ImageFrameLayer(layer, slice_0(resolved.a5r()), resolved.b6h(), resolved.c6h(), false, true, tilemap);
}
var ASE_instance;
function ASE_getInstance() {
  if (ASE_instance === VOID)
    ASE.k6k();
  return ASE_instance;
}
function _Fixed32___init__impl__8jizkq(raw) {
  return raw;
}
function _Fixed32___get_raw__impl__5vhc8t($this) {
  return $this;
}
function _Fixed32___get_double__impl__wjoyf6($this) {
  return _Fixed32___get_raw__impl__5vhc8t($this) / 65536.0;
}
var Companion_instance_28;
function Companion_getInstance_38() {
  return Companion_instance_28;
}
function onlyReadVisibleLayers$delegate$lambda() {
  _init_properties_ASE_kt__16anup();
  return true;
}
function onlyReadVisibleLayers$factory() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
function onlyReadVisibleLayers$factory_0() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
var properties_initialized_ASE_kt_jtvwzh;
function _init_properties_ASE_kt__16anup() {
  if (!properties_initialized_ASE_kt_jtvwzh) {
    properties_initialized_ASE_kt_jtvwzh = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = onlyReadVisibleLayers$delegate$lambda;
    onlyReadVisibleLayers$delegate = new Property(null, default_0);
  }
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_29;
function Companion_getInstance_39() {
  DataFormat_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_22();
  return Companion_instance_29;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_39();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString_0(s, 2, Charsets_instance.n25(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.h5(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.u6m_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.r46(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.b33_1.l2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_39();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.h1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.u6m_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.q46(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.s6m_1(nComponent);
          this_1.r46(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact_0(s, dataFormat.s6m_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.u6m_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.q46(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.r46(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().y4q_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_0().c4r_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_0().a4r_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_0().e4r_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_0().f4r_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_0().z4q_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_0().d4r_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_0().b4r_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().y4q_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.k23());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.k23());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
function values_5() {
  return [Direction_ONCE_FORWARD_getInstance(), Direction_ONCE_REVERSE_getInstance(), Direction_FORWARD_getInstance(), Direction_REVERSE_getInstance(), Direction_PING_PONG_getInstance()];
}
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.m6l_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.m6l_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_ONCE_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_ONCE_FORWARD_instance;
}
function Direction_ONCE_REVERSE_getInstance() {
  Direction_initEntries();
  return Direction_ONCE_REVERSE_instance;
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
function Direction_REVERSE_getInstance() {
  Direction_initEntries();
  return Direction_REVERSE_instance;
}
function Direction_PING_PONG_getInstance() {
  Direction_initEntries();
  return Direction_PING_PONG_instance;
}
var info$delegate;
var Companion_instance_30;
function Companion_getInstance_40() {
  return Companion_instance_30;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.j6n()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.i6n().r56_1, b.i6n().s56_1), imul(b.i6n().t56_1, b.i6n().t56_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.j6n()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.i6n().r56_1, a.i6n().s56_1), imul(a.i6n().t56_1, a.i6n().t56_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
function packInMutableAtlas(_this__u8e3s4, mutableAtlas) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var this_0 = _this__u8e3s4.l6n_1;
  var destination = ArrayList.z();
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var list = element.s6l_1;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.z();
  var tmp0_iterator_0 = destination.b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    if (element_0.a6m_1) {
      destination_0.h(element_0);
    }
  }
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = packInMutableAtlas$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_2(tmp);
  var frameLayers = sortedWith(destination_0, tmp$ret$6);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < frameLayers.g1()) {
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var frameLayer = frameLayers.h1(_unary__edvuaz);
    frameLayer.x6n(mutableAtlas.l56(frameLayer.f6m_1, Unit_instance, frameLayer.f6m_1.m4r_1).h55_1);
  }
  return _this__u8e3s4;
}
function packInMutableAtlas_0(_this__u8e3s4, mutableAtlas) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.y6n_1;
  var n = 0;
  while (n < this_0.g1()) {
    // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.h1(_unary__edvuaz);
    packInMutableAtlas(it, mutableAtlas);
  }
  return _this__u8e3s4;
}
function info$delegate$lambda() {
  _init_properties_ImageData_kt__fnvt4j();
  return null;
}
function packInMutableAtlas$lambda(a, b) {
  _init_properties_ImageData_kt__fnvt4j();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
  var tmp = b.x3r();
  // Inline function 'korlibs.image.format.packInMutableAtlas.<anonymous>' call
  var tmp$ret$1 = a.x3r();
  return compareValues(tmp, tmp$ret$1);
}
var properties_initialized_ImageData_kt_3o5pbp;
function _init_properties_ImageData_kt__fnvt4j() {
  if (!properties_initialized_ImageData_kt_3o5pbp) {
    properties_initialized_ImageData_kt_3o5pbp = true;
    info$delegate = new Property(VOID, info$delegate$lambda);
  }
}
var Companion_instance_31;
function Companion_getInstance_41() {
  return Companion_instance_31;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.y6n_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.r6n_1;
      destination.k3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.d6o().e3(null);
    return tmp0_elvis_lhs == null ? first_0(this$0.y6n_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.d6o();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.e6o();
  }, null);
}
function set_tilesetBorder(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageFormat_kt__44biio();
  var this_0 = tilesetBorder$delegate;
  var property = tilesetBorder$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_tilesetBorder(_this__u8e3s4) {
  _init_properties_ImageFormat_kt__44biio();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = tilesetBorder$delegate;
    var property = tilesetBorder$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var tilesetBorder$delegate;
var Companion_instance_32;
function Companion_getInstance_42() {
  if (Companion_instance_32 === VOID)
    new Companion_25();
  return Companion_instance_32;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.j6m(tmp, props.j6o(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.i6o(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function tilesetBorder$factory() {
  return getPropertyCallableRef('tilesetBorder', 1, KMutableProperty1, function (receiver) {
    return get_tilesetBorder(receiver);
  }, function (receiver, value) {
    return set_tilesetBorder(receiver, value);
  });
}
function tilesetBorder$factory_0() {
  return getPropertyCallableRef('tilesetBorder', 1, KMutableProperty1, function (receiver) {
    return get_tilesetBorder(receiver);
  }, function (receiver, value) {
    return set_tilesetBorder(receiver, value);
  });
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.h6m();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.z();
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.t6o();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.s6o();
  }, function (receiver, value) {
    return receiver.r6o(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.s6o();
  }, function (receiver, value) {
    return receiver.r6o(value);
  });
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_34;
function Companion_getInstance_44() {
  Type_initEntries();
  if (Companion_instance_34 === VOID)
    new Companion_27();
  return Companion_instance_34;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_44();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.h4r_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.h4r_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.h4r_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.h4r_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.h6m(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.o56(result.o5e(), Unit_instance, name).h55_1 : slice_0(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  var prop = !(file == null) ? props.j6o(file) : props;
  var rformats = !prop.f6l_1 ? listOf_0(prop.g6l_1) : prop.g6l_1 == null ? listOf_0(null) : prop.e6l_1 ? listOf([prop.g6l_1, null]) : listOf([null, prop.g6l_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.b1();
  while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.o6m(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.n6m(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.je();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.b6l_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.q46(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.r46(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.h6m(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
function *_generator_readImageDataContainer__g8j6x6(_this__u8e3s4, props, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  atlas = atlas === VOID ? null : atlas;
  var tmp = props.h6m().g6o();
  var tmp_0 = _this__u8e3s4.x3g($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var out = tmp.r6k(openSync(tmp_0), props.h6m().j6o(_this__u8e3s4));
  return !(atlas == null) ? packInMutableAtlas_0(out, atlas) : out;
}
function readImageDataContainer(_this__u8e3s4, props, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_42().x5t_1 : props;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readImageDataContainer__g8j6x6.bind(VOID, _this__u8e3s4, props, atlas), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().g26('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.b6l_1 || props.a6l_1 === false) {
    return $this.i6p(get_RegisteredImageFormats().m6m(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_5, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.j6p(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.b6l_1 || props.a6l_1 === false) {
    return $this.i6p(get_RegisteredImageFormats().m6m(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_5, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.i6p($this.e6q(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.d3g(path).c3h($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.k6p(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.k6p(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.j6q_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.d6q(file.x3d(), file.d3e(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.j6q_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.h6q(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.s54());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.k56(_this__u8e3s4.n54_1, _this__u8e3s4.o54_1, _this__u8e3s4.p54_1, _this__u8e3s4.q54_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_35;
function Companion_getInstance_45() {
  Colorspace_initEntries();
  if (Companion_instance_35 === VOID)
    new Companion_28();
  return Companion_instance_35;
}
function values_6() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_45();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.q22();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.a6r_1;
  var height = header.b6r_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.h6r_1);
  var databb = uncompress(pngdata.v22(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.j6r_1.h6r_1;
  var row32 = context.m6r_1;
  var tmp_2;
  if (header.h6r_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_24().f5o(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.u5h(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.k56(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.g6r_1 === 1 ? $this.s6r_1 : $this.t6r_1;
  var _iterator__ex2g4s = passes.b1();
  while (_iterator__ex2g4s.c1()) {
    var pass = _iterator__ex2g4s.d1();
    var progression = step(until(pass.t6q_1, height), pass.v6q_1);
    var inductionVariable_0 = progression.f2_1;
    var last_0 = progression.g2_1;
    var step_0 = progression.h2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.u6q_1;
        var colIncrement = pass.w6q_1;
        var pixelsInThisRow = width >>> pass.z6q_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.h6r_1), header.c6r_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.l6r_1;
        var lastRow = context.k6r_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.v6r(filter, lastRow, currentRow, header.h6r_1);
          switch (header.c6r_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.v57(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.v57(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.v57(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.j5i(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.c6r_1;
              throw IllegalStateException.h5(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.c6r_1 === 8) {
            $this.u6r(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_22(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_24(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.je('An operation is not implemented: ' + reason);
            }
            bmp32.a5i(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.c6r_1;
            throw IllegalStateException.h5(toString_0(message_0));
          }
        }
        context.w6r();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream_0(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_45().s6q_1.e3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.o6k_1 = this_0.a6r_1;
      $info.p6k_1 = this_0.b6r_1;
      $info.q6k_1 = imul(this_0.c6r_1, this_0.d6r_1.r6q_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().l2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.w2d(asByteArray(rgbPalette), 0, data.a().l2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().l2();
      paletteCount._v = Math.max(a_0, b_0);
      data.w2d(asByteArray(aPalette), 0, data.a().l2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.t22(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.z6r();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.a6p([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_36;
function Companion_getInstance_46() {
  return Companion_instance_36;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.j6s_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.i6s_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.u6s_1 = value;
  $this.q6s_1 = $this.u6s_1.r56_1;
  $this.r6s_1 = $this.u6s_1.s56_1;
  $this.s6s_1 = 1.0 / $this.q6s_1;
  $this.t6s_1 = 1.0 / $this.r6s_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.c6s(_this__u8e3s4.o5p_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.k6s(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.y6s(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.je();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.g1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().a5a_1 : _RGBA___init__impl__lqpay5(colors.ml());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.ml()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.x27(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.x27(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_24().f5q(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.y3w()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.h1(n) * NCOLORS);
}
var Companion_instance_37;
function Companion_getInstance_47() {
  return Companion_instance_37;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.c3x()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.o5p_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().z57_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function RichTextData$Line$defaultStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.v6t_1;
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp261_safe_receiver = firstOrNull_0(destination);
    var tmp0_elvis_lhs = tmp261_safe_receiver == null ? null : tmp261_safe_receiver.g6u_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.w6t_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_48().i6u_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$defaultLastStyle$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var this_0 = this$0.v6t_1;
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      if (element instanceof TextNode) {
        destination.h(element);
      }
    }
    var tmp262_safe_receiver = lastOrNull_0(destination);
    var tmp0_elvis_lhs = tmp262_safe_receiver == null ? null : tmp262_safe_receiver.g6u_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.w6t_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Companion_getInstance_48().i6u_1 : tmp1_elvis_lhs;
  };
}
function RichTextData$Line$text$delegate$lambda$lambda(it) {
  var tmp0_elvis_lhs = it.j6u();
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function RichTextData$Line$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.v6t_1, '', VOID, VOID, VOID, VOID, RichTextData$Line$text$delegate$lambda$lambda);
  };
}
function RichTextData$Line$width$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.v6t_1.j1()) {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var tmp0_iterator = this$0.v6t_1.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        var tmp_0 = sum;
        // Inline function 'korlibs.image.text.Line.width$delegate.<anonymous>.<anonymous>' call
        sum = tmp_0 + element.f3u();
      }
      tmp = sum;
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
}
function RichTextData$Line$maxLineHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.v6t_1.j1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.v6t_1.b1();
      if (!iterator.c1())
        throw NoSuchElementException.x6();
      // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.d1().o5x();
      while (iterator.c1()) {
        // Inline function 'korlibs.image.text.Line.maxLineHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.d1().o5x();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.k6u())).o5x();
    }
    return tmp;
  };
}
function RichTextData$Line$maxHeight$delegate$lambda(this$0) {
  return function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this$0.v6t_1.j1()) {
      // Inline function 'kotlin.collections.maxOf' call
      var iterator = this$0.v6t_1.b1();
      if (!iterator.c1())
        throw NoSuchElementException.x6();
      // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
      var maxValue = iterator.d1().g3u();
      while (iterator.c1()) {
        // Inline function 'korlibs.image.text.Line.maxHeight$delegate.<anonymous>.<anonymous>' call
        var v = iterator.d1().g3u();
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp = maxValue;
    } else {
      tmp = (new TextNode('', this$0.k6u())).g3u();
    }
    return tmp;
  };
}
function RichTextData$Line$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.r1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Line.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.v6t_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var node = _iterator__ex2g4s.d1();
      if (node instanceof TextNode) {
        this_0.h(node.g6u_1.l6u_1);
      }
    }
    return this_0;
  };
}
var Companion_instance_38;
function Companion_getInstance_48() {
  if (Companion_instance_38 === VOID)
    new Companion_31();
  return Companion_instance_38;
}
function RichTextData$TextNode$bounds$delegate$lambda(this$0) {
  return function () {
    return getTextBounds(this$0.g6u_1.l6u_1, this$0.g6u_1.m6u_1, this$0.f6u_1);
  };
}
var Companion_instance_39;
function Companion_getInstance_49() {
  if (Companion_instance_39 === VOID)
    new Companion_32();
  return Companion_instance_39;
}
function wordWrap$addNode(currentLine, currentLineWidth, node) {
  var lastNode = lastOrNull_0(currentLine);
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!currentLine.j1()) {
    tmp_4 = node instanceof TextNode;
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = lastNode instanceof TextNode;
  } else {
    tmp_3 = false;
  }
  if (tmp_3) {
    tmp_2 = lastNode.z6u(node.f6u_1).equals(node);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = node.g6u_1.r6u_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = node.f6u_1;
    tmp_0 = !isBlank(this_0);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = lastNode.f6u_1;
    tmp = !isBlank(this_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    removeLast(currentLine);
    currentLineWidth._v = currentLineWidth._v - lastNode.w6d().f3u();
    return wordWrap$addNode(currentLine, currentLineWidth, node.z6u(lastNode.f6u_1 + node.f6u_1));
  } else {
    currentLine.h(node);
    currentLineWidth._v = currentLineWidth._v + node.f3u();
  }
}
function wordWrap$finishLine(currentLine, outLines, currentLineWidth) {
  if (currentLine.j1())
    return Unit_instance;
  // Inline function 'kotlin.collections.plusAssign' call
  var element = Line.s6u(toList(currentLine));
  outLines.h(element);
  currentLine.h3();
  currentLineWidth._v = 0.0;
}
function RichTextData$text$delegate$lambda$lambda(it) {
  return it.j6u();
}
function RichTextData$text$delegate$lambda(this$0) {
  return function () {
    return joinToString(this$0.h6v_1, '\n', VOID, VOID, VOID, VOID, RichTextData$text$delegate$lambda$lambda);
  };
}
function RichTextData$width$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = this$0.h6v_1.b1();
    if (!iterator.c1())
      throw NoSuchElementException.x6();
    // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
    var maxValue = iterator.d1().f3u();
    while (iterator.c1()) {
      // Inline function 'korlibs.image.text.RichTextData.width$delegate.<anonymous>.<anonymous>' call
      var v = iterator.d1().f3u();
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    return maxValue;
  };
}
function RichTextData$height$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this$0.h6v_1.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.RichTextData.height$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.v6u();
    }
    return sum;
  };
}
function RichTextData$allFonts$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet.r1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.RichTextData.allFonts$delegate.<anonymous>.<anonymous>' call
    var _iterator__ex2g4s = this$0.h6v_1.b1();
    while (_iterator__ex2g4s.c1()) {
      var line = _iterator__ex2g4s.d1();
      this_0.i1(line.x6u());
    }
    return this_0;
  };
}
function defaultStyle$factory() {
  return getPropertyCallableRef('defaultStyle', 1, KProperty1, function (receiver) {
    return receiver.k6u();
  }, null);
}
function defaultLastStyle$factory() {
  return getPropertyCallableRef('defaultLastStyle', 1, KProperty1, function (receiver) {
    return receiver.u6u();
  }, null);
}
function text$factory() {
  return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
    return receiver.j6u();
  }, null);
}
function width$factory() {
  return getPropertyCallableRef('width', 1, KProperty1, function (receiver) {
    return receiver.f3u();
  }, null);
}
function maxLineHeight$factory() {
  return getPropertyCallableRef('maxLineHeight', 1, KProperty1, function (receiver) {
    return receiver.v6u();
  }, null);
}
function maxHeight$factory() {
  return getPropertyCallableRef('maxHeight', 1, KProperty1, function (receiver) {
    return receiver.w6u();
  }, null);
}
function allFonts$factory() {
  return getPropertyCallableRef('allFonts', 1, KProperty1, function (receiver) {
    return receiver.x6u();
  }, null);
}
function bounds$factory() {
  return getPropertyCallableRef('bounds', 1, KProperty1, function (receiver) {
    return receiver.w6d();
  }, null);
}
function place(_this__u8e3s4, bounds, wordWrap, includePartialLines, ellipsis, fill, stroke, align, includeFirstLineAlways, out) {
  wordWrap = wordWrap === VOID ? true : wordWrap;
  includePartialLines = includePartialLines === VOID ? false : includePartialLines;
  ellipsis = ellipsis === VOID ? null : ellipsis;
  fill = fill === VOID ? null : fill;
  stroke = stroke === VOID ? null : stroke;
  align = align === VOID ? Companion_getInstance_52().x5x_1 : align;
  includeFirstLineAlways = includeFirstLineAlways === VOID ? true : includeFirstLineAlways;
  out = out === VOID ? new RichTextDataPlacements() : out;
  var text = _this__u8e3s4;
  out.f6w_1.h3();
  if (text.h6v_1.j1())
    return out;
  var tmp272_maxLineWidth = wordWrap ? bounds.d3j_1 : Infinity;
  var tmp273_maxHeight = bounds.e3j_1;
  var rtext = text.w6v(tmp272_maxLineWidth, tmp273_maxHeight, includePartialLines, ellipsis, true, includeFirstLineAlways);
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!rtext.h6v_1.j1()) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = dropLast(rtext.h6v_1, 1).b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      var tmp_0 = sum;
      // Inline function 'korlibs.image.text.place.<anonymous>' call
      sum = tmp_0 + element.v6u();
    }
    tmp = sum + last(rtext.h6v_1).w6u();
  } else {
    tmp = 0.0;
  }
  var totalHeight = tmp;
  var y = {_v: bounds.c3j_1 + (bounds.e3j_1 - totalHeight) * _VerticalAlign___get_ratioFake0__impl__5adpb3(align.m5z_1)};
  var _iterator__ex2g4s = rtext.h6v_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var line = _iterator__ex2g4s.d1();
    var x = {_v: bounds.b3j_1 - HorizontalAlign__getOffsetX_impl_urzzxf(align.l5z_1, line.f3u()) + HorizontalAlign__getOffsetX_impl_urzzxf(align.l5z_1, bounds.d3j_1)};
    var wordSpacing = equals(align.l5z_1, Companion_getInstance_51().i6w_1) ? (bounds.d3j_1 - line.f3u()) / (line.v6t_1.g1() - 1) : 0.0;
    y._v = y._v + line.w6u();
    var _iterator__ex2g4s_0 = line.v6t_1.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var node = _iterator__ex2g4s_0.d1();
      if (node instanceof TextNode) {
        if (node.g6u_1.o6u_1) {
          place$render(out, node, x, y, fill, stroke, 1.0, 0.0);
        }
        place$render(out, node, x, y, fill, stroke, 0.0, 0.0);
        x._v = x._v + node.f3u();
        x._v = x._v + wordSpacing;
      }
    }
    y._v = y._v + (line.v6u() - line.w6u());
  }
  return out;
}
function place$render($out, node, x, y, $fill, $stroke, dx, dy) {
  var tmp = Vector2D.y3k(x._v + dx, y._v + dy);
  var tmp0_elvis_lhs = node.g6u_1.q6u_1;
  var tmp_0;
  var tmp_1 = tmp0_elvis_lhs;
  if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
    tmp_0 = $fill;
  } else {
    var tmp_2 = tmp0_elvis_lhs;
    tmp_0 = tmp_2 == null ? null : new RGBA(tmp_2);
  }
  $out.f6w_1.h(new Placement(node.f6u_1, tmp, node.g6u_1.m6u_1, node.g6u_1.l6u_1, tmp_0, $stroke));
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_50().r6w_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function _VerticalAlign___get_ratioFake0__impl__5adpb3($this) {
  return equals($this, Companion_getInstance_50().r6w_1) ? 0.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_40;
function Companion_getInstance_50() {
  if (Companion_instance_40 === VOID)
    new Companion_33();
  return Companion_instance_40;
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_50().r6w_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.k5r_1, font.k5r_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_50().o6w_1) ? 'TOP' : equals($this, Companion_getInstance_50().p6w_1) ? 'MIDDLE' : equals($this, Companion_getInstance_50().q6w_1) ? 'BOTTOM' : equals($this, Companion_getInstance_50().r6w_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.v6w_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_51().i6w_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_41;
function Companion_getInstance_51() {
  if (Companion_instance_41 === VOID)
    new Companion_34();
  return Companion_instance_41;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_51().i6w_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_51().j6w_1) ? 'LEFT' : equals($this, Companion_getInstance_51().k6w_1) ? 'CENTER' : equals($this, Companion_getInstance_51().l6w_1) ? 'RIGHT' : equals($this, Companion_getInstance_51().i6w_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.x6w_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_42;
function Companion_getInstance_52() {
  if (Companion_instance_42 === VOID)
    new Companion_35();
  return Companion_instance_42;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.n26().r3i_1 + $this.j6t().r3m(x, y);
  var ry = $this.n26().s3i_1 + $this.j6t().u3m(x, y);
  $this.g5z_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.g5z_1, Vector2D.y3k(rx, ry));
  if ($this.h5z_1 === 0) {
    $this.f5z_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.f5z_1, Vector2D.y3k(rx, ry));
  }
  var _receiver__tnumb7 = $this.j5z_1;
  _receiver__tnumb7.r5z_1 = BoundsBuilder__plus_impl_cz7f7x_0(_receiver__tnumb7.r5z_1, Vector2D.y3k(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.i3j();
  var fy = rect.d3q();
  var w = rect.d3j_1;
  var h = rect.e3j_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.y6w(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.f6x(text, c);
  $this$CreateWStringTextRenderer.g6x(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.f6x(text, c);
  $this$CreateStringTextRenderer.g6x(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function _Tile___init__impl__tdix77(raw) {
  return raw;
}
function _Tile___get_raw__impl__kp6cq8($this) {
  return $this;
}
function _Tile___get_isInvalid__impl__yfg9ed($this) {
  return equals($this, Companion_getInstance_53().d6y_1);
}
function _Tile___get_tile__impl__nfq1aw($this) {
  return Int53__extract_impl_ikc3ev(_Tile___get_raw__impl__kp6cq8($this), 0, 19);
}
function _Tile___get_rotate__impl__5kjdv9($this) {
  return Int53__extract_impl_ikc3ev_0(_Tile___get_raw__impl__kp6cq8($this), 19);
}
function _Tile___get_flipY__impl__95aqcs($this) {
  return Int53__extract_impl_ikc3ev_0(_Tile___get_raw__impl__kp6cq8($this), 20);
}
function _Tile___get_flipX__impl__jobqpf($this) {
  return Int53__extract_impl_ikc3ev_0(_Tile___get_raw__impl__kp6cq8($this), 21);
}
function _Tile___get_offsetX__impl__qwhdsd($this) {
  return Int53__extractSigned_impl_v59qt9(_Tile___get_raw__impl__kp6cq8($this), 22, 15);
}
function _Tile___get_offsetY__impl__1x539u($this) {
  return Int53__extractSigned_impl_v59qt9(_Tile___get_raw__impl__kp6cq8($this), 37, 15);
}
var Companion_instance_43;
function Companion_getInstance_53() {
  if (Companion_instance_43 === VOID)
    new Companion_36();
  return Companion_instance_43;
}
var Companion_instance_44;
function Companion_getInstance_54() {
  return Companion_instance_44;
}
var TileMapRepeat_NONE_instance;
var TileMapRepeat_REPEAT_instance;
var TileMapRepeat_MIRROR_instance;
function TileMapRepeat$lambda(v, max) {
  return v;
}
function TileMapRepeat$lambda_0(v, max) {
  return umod(v, max);
}
function TileMapRepeat$lambda_1(v, max) {
  var r = umod(v, max);
  return ((v / max | 0) % 2 | 0) === 0 ? r : (max - 1 | 0) - r | 0;
}
var TileMapRepeat_entriesInitialized;
function TileMapRepeat_initEntries() {
  if (TileMapRepeat_entriesInitialized)
    return Unit_instance;
  TileMapRepeat_entriesInitialized = true;
  TileMapRepeat_NONE_instance = new TileMapRepeat('NONE', 0, TileMapRepeat$lambda);
  TileMapRepeat_REPEAT_instance = new TileMapRepeat('REPEAT', 1, TileMapRepeat$lambda_0);
  TileMapRepeat_MIRROR_instance = new TileMapRepeat('MIRROR', 2, TileMapRepeat$lambda_1);
}
function TileMapRepeat_NONE_getInstance() {
  TileMapRepeat_initEntries();
  return TileMapRepeat_NONE_instance;
}
function fromTileSetTileInfo$ensureBMP32(_this__u8e3s4, bmps) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var key = _this__u8e3s4.i4r_1;
    var res = get(bmps, key);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.image.tiles.Companion.fromTileSetTileInfo.ensureBMP32.<anonymous>' call
    var out = _this__u8e3s4.i4r_1.o5e();
    set(bmps, key, out);
    tmp$ret$0 = out;
  }
  var base2 = tmp$ret$0;
  if (_this__u8e3s4.i4r_1 === base2) {
    return _this__u8e3s4 instanceof RectSlice ? _this__u8e3s4 : THROW_CCE();
  }
  return new RectSlice(base2, _this__u8e3s4.j4r_1, _this__u8e3s4.k4r_1, _this__u8e3s4.l4r_1, _this__u8e3s4.m4r_1);
}
var Companion_instance_45;
function Companion_getInstance_55() {
  if (Companion_instance_45 === VOID)
    new Companion_38();
  return Companion_instance_45;
}
function TileSet$base$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.l6z_1.n40_1 === 0) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = get_bmp(this$0.l6z_1.c41().a6z_1);
    }
    return tmp;
  };
}
function TileSet$hasMultipleBaseBitmaps$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this$0.l6z_1.n3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.image.tiles.TileSet.hasMultipleBaseBitmaps$delegate.<anonymous>.<anonymous>' call
        if (!(element === null) && !(get_bmp(element.a6z_1) === this$0.r4s())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function TileSet$infos$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp301_safe_receiver = maxOrNull(this$0.l6z_1.f3());
    var tmp0_elvis_lhs = tmp301_safe_receiver == null ? null : tmp301_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this$0.l6z_1.h1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function TileSet$textures$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp302_safe_receiver = maxOrNull(this$0.l6z_1.f3());
    var tmp0_elvis_lhs = tmp302_safe_receiver == null ? null : tmp302_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp303_safe_receiver = this$0.l6z_1.h1(tmp_2);
      tmp_1[tmp_2] = tmp303_safe_receiver == null ? null : tmp303_safe_receiver.a6z_1;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function base$factory() {
  return getPropertyCallableRef('base', 1, KProperty1, function (receiver) {
    return receiver.r4s();
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.z4l();
  }, null);
}
function textures$factory() {
  return getPropertyCallableRef('textures', 1, KProperty1, function (receiver) {
    return receiver.t6z();
  }, null);
}
function Tile(tile, orientation, offsetX, offsetY) {
  var tmp;
  if (orientation === VOID) {
    // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
    tmp = Companion_getInstance_0().y4q_1;
  } else {
    tmp = orientation;
  }
  orientation = tmp;
  offsetX = offsetX === VOID ? 0 : offsetX;
  offsetY = offsetY === VOID ? 0 : offsetY;
  return Companion_getInstance_53().f6y(tile, offsetX, offsetY, get_tileFlipX(orientation), get_tileFlipY(orientation), get_tileRot(orientation));
}
function get_tileFlipX(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 1 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 4 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5;
}
function get_tileFlipY(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 3 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 6;
}
function get_tileRot(_this__u8e3s4) {
  return (_SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) % 2 | 0) === 1;
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.p70_1.d71_1.d1t()) {
    this$0.p70_1.b71_1 = this$0.n70_1 ? 4 : 1;
    this$0.t70_1.z6z_1 = filler;
    this$0.t70_1.i70_1 = $state.x5s_1;
    this$0.t70_1.u1w();
    var tmp = $winding == null ? fillPath.p4p_1 : $winding;
    this$0.p70_1.j71(this$0.o70_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.t70_1.gd();
    this$0.p70_1.d71_1.u1w();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.t70_1.x70(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.l5q_1, dstN, src.l5q_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_46;
function Companion_getInstance_56() {
  if (Companion_instance_46 === VOID)
    new Companion_39();
  return Companion_instance_46;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_47;
function Companion_getInstance_57() {
  return Companion_instance_47;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.l5q_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.l5q_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.l5q_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.l5q_1, dstN, dst.l5q_1, dstN, src.l5q_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.l5q_1, dstN, src.l5q_1, srcN, dst.l5q_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_56();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.w71(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_56().v71_1);
  var tmp_0 = Companion_getInstance_56();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.w71(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_56();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.w71(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_56().v71_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_56().v71_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_56().v71_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_56().v71_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_56().v71_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_56().v71_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_56().v71_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_56().v71_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_47.h4z();
}
var BlendMode_NORMAL_instance;
var BlendMode_MULTIPLY_instance;
var BlendMode_SCREEN_instance;
var BlendMode_OVERLAY_instance;
var BlendMode_DARKEN_instance;
var BlendMode_LIGHTEN_instance;
var BlendMode_COLOR_DODGE_instance;
var BlendMode_COLOR_BURN_instance;
var BlendMode_HARD_LIGHT_instance;
var BlendMode_SOFT_LIGHT_instance;
var BlendMode_DIFFERENCE_instance;
var BlendMode_EXCLUSION_instance;
var BlendMode_HUE_instance;
var BlendMode_SATURATION_instance;
var BlendMode_COLOR_instance;
var BlendMode_LUMINOSITY_instance;
var BlendMode_ADDITION_instance;
var BlendMode_SUBTRACT_instance;
var BlendMode_DIVIDE_instance;
var BlendMode_entriesInitialized;
function BlendMode_initEntries() {
  if (BlendMode_entriesInitialized)
    return Unit_instance;
  BlendMode_entriesInitialized = true;
  BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_56().v71_1);
  BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_56().v71_1);
  BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_56().v71_1);
  BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_56().v71_1);
  BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_56().v71_1);
  BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_56().v71_1);
  BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_56().v71_1);
  BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_56().v71_1);
  BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_56().v71_1);
  BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_56().v71_1);
  BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_56().v71_1);
  BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_56().v71_1);
  BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_56().v71_1);
  BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_56().v71_1);
  BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_56().v71_1);
  BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_56().v71_1);
  BlendMode_ADDITION_instance = new BlendMode('ADDITION', 16, Companion_getInstance_56().v71_1);
  BlendMode_SUBTRACT_instance = new BlendMode('SUBTRACT', 17, Companion_getInstance_56().v71_1);
  BlendMode_DIVIDE_instance = new BlendMode('DIVIDE', 18, Companion_getInstance_56().v71_1);
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function BlendMode_NORMAL_getInstance() {
  BlendMode_initEntries();
  return BlendMode_NORMAL_instance;
}
function BlendMode_MULTIPLY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_MULTIPLY_instance;
}
function BlendMode_SCREEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SCREEN_instance;
}
function BlendMode_OVERLAY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_OVERLAY_instance;
}
function BlendMode_DARKEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DARKEN_instance;
}
function BlendMode_LIGHTEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LIGHTEN_instance;
}
function BlendMode_COLOR_DODGE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_DODGE_instance;
}
function BlendMode_COLOR_BURN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_BURN_instance;
}
function BlendMode_HARD_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HARD_LIGHT_instance;
}
function BlendMode_SOFT_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SOFT_LIGHT_instance;
}
function BlendMode_DIFFERENCE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIFFERENCE_instance;
}
function BlendMode_EXCLUSION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_EXCLUSION_instance;
}
function BlendMode_HUE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HUE_instance;
}
function BlendMode_SATURATION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SATURATION_instance;
}
function BlendMode_COLOR_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_instance;
}
function BlendMode_LUMINOSITY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LUMINOSITY_instance;
}
function BlendMode_ADDITION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_ADDITION_instance;
}
function BlendMode_SUBTRACT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SUBTRACT_instance;
}
function BlendMode_DIVIDE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIVIDE_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.h5s_1.i3n();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.s5e_1.h5s_1;
    if (this_0.g3j()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.n4p_1;
  var n_0 = 0;
  while (n_0 < this_0.g1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.x27(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.o4p_1.h1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
        _this__u8e3s4.k4p(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
        _this__u8e3s4.x4p(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
        _this__u8e3s4.y4p(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
        _this__u8e3s4.l4p(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.p6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_6().p3j();
  bb = BoundsBuilder__plus_impl_cz7f7x(bb, state.j5s_1.y4l());
  var tmp = bb;
  var tmp333_safe_receiver = state.i5s_1;
  bb = BoundsBuilder__plus_impl_cz7f7x(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.y4l());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).m3r(state.h5s_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.k56(toIntCeil_0(bounds.d3j_1), toIntCeil_0(bounds.e3j_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.g6s(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().c3m().d3n(-bounds.i3j(), -bounds.d3q()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.d72();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_48;
function Companion_getInstance_58() {
  CycleMethod_initEntries();
  if (Companion_instance_48 === VOID)
    new Companion_41();
  return Companion_instance_48;
}
function values_7() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_58();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.p3_1, 0), y.p3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_58().j73_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_58().j73_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.y3k(_CycleMethodPair___get_x__impl__dgz5uj($this).k73(ratio.r3i_1), _CycleMethodPair___get_y__impl__fcnb7o($this).k73(ratio.s3i_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.g6g(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.g6g(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.r56_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.s56_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.m57(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.q5j(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.r5j(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.s5j(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.t5j(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.u5j(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.b5k(-1.0);
  msdf_0.d5k(-1.0, +1.0);
  msdf_0.a5k();
  var msdfBitmap = msdf_0.d57();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.n5o(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).d57(), VOID, 0);
  return newImage.g5o_1.o5e();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.o5j(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.i3l();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.h4l_1, item.i4l_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.z();
  var tmp0_iterator_0 = colorizedCurves.b1();
  while (tmp0_iterator_0.c1()) {
    var element = tmp0_iterator_0.d1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.l73_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.s56_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.r56_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.y3k(x + 0.5, y + 0.5);
          var inside = path.k4z(p);
          var allDist = allColorizedCurves.t73().x73(p);
          var redDist = allColorizedCurves.y73().x73(p);
          var greenDist = allColorizedCurves.z73().x73(p);
          var blueDist = allColorizedCurves.a74().x73(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.u5j(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.l73_1;
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.c74_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.l73_1;
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.c74_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.l73_1;
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.c74_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.l73_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.b74_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.d74();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.b74_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.e74();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.b74_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.f74();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.b74_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.g1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().y57_1;
  if (index === 0)
    return Colors_getInstance().a5a_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().o5d_1 : Colors_getInstance().y58_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().y57_1);
    if (true) {
      $this$NativeImageContext2d.h60();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.f73(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.d74();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.e74();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.f74();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.t73();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.y73();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.z73();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.a74();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.z();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.n4p_1;
  var n_0 = 0;
  while (n_0 < this_1.g1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.x27(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.y3k(tmp, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_1));
        var x = destruct.em();
        var y = destruct.fm();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.y3k(tmp_0, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_3));
        var x_0 = destruct_0.em();
        var y_0 = destruct_0.fm();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.y3k(tmp_1, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.y3k(tmp_2, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_7));
        var cx = destruct_1.em();
        var cy = destruct_1.fm();
        var ax = destruct_2.em();
        var ay = destruct_2.fm();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.y3k(tmp_3, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.y3k(tmp_4, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.y3k(tmp_5, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_13));
        var cx1 = destruct_3.em();
        var cy1 = destruct_3.fm();
        var cx2 = destruct_4.em();
        var cy2 = destruct_4.fm();
        var ax_0 = destruct_5.em();
        var ay_0 = destruct_5.fm();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.m8();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.b1();
  while (tmp0_iterator.c1()) {
    var item = tmp0_iterator.d1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.i74_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.j74_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.s74(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.t74_1, this$0.x74_1), this$0.u74_1, this$0.v74_1, this$0.w74_1, this$0.y74_1);
  };
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.h4y_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.j4y_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.k4y_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.l4y_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.m4y_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.n4y_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.o4y_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.p4y_1;
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.a71_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.y4y($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_49;
function Companion_getInstance_59() {
  if (Companion_instance_49 === VOID)
    new Companion_42();
  return Companion_instance_49;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.m76(HtmlImage_instance.s75(_this__u8e3s4.d57()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.q76(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.m76(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.r76(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.s76(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.r3h(path);
      var tmp_1 = BrowserImage_instance.r76(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.s76(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.cj(path).b3h($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.q76(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.m76(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.i76_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.i76_1;
      tmp = tmp_0.t76(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.i76_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.i76_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.u76().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_10().a24()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.h5(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.v54(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.z76(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.a77(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.jd(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.bb('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.jd(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.q3()) == $this.g77_1) {
    tmp = fontSize === $this.f77_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.g77_1 = font == null ? null : font.q3();
  $this.f77_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.q3();
  $this.e77_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.e77_1.globalAlpha = state.x5s_1;
  $this.e77_1.globalCompositeOperation = $this.h77(state.y5s_1);
  if (doSetFont) {
    setFont($this, state.t5s_1, state.u5s_1);
  }
  if (fill) {
    $this.e77_1.fillStyle = $this.i77(state.r5s_1);
  } else {
    $this.e77_1.lineWidth = state.l5s_1;
    var tmp;
    switch (state.o5s_1.p3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.e77_1.lineJoin = tmp;
    var tmp_0;
    switch (state.e72().p3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.e77_1.lineCap = tmp_0;
    $this.e77_1.strokeStyle = $this.i77(state.q5s_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.j77($this.e77_1, paint.j6t());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.u76();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.w76();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_10().b24() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_10().a24() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.n56);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForCompanion(Companion_3);
initMetadataForClass(NinePatchBmpSlice, 'NinePatchBmpSlice');
initMetadataForClass(AxisSegment, 'AxisSegment');
initMetadataForClass(AxisInfo, 'AxisInfo');
initMetadataForClass(Segment, 'Segment');
initMetadataForClass(NinePatchInfo, 'NinePatchInfo');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_4);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_5);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_7);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_10);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).i5r = getFontMetrics;
protoOf(BitmapFontImpl).t5r = getFontMetrics$default;
protoOf(BitmapFontImpl).u5r = getGlyphMetrics;
protoOf(BitmapFontImpl).b5s = getGlyphMetrics$default;
protoOf(BitmapFontImpl).i5t = getKerning;
protoOf(BitmapFontImpl).d5s = getTextScale;
protoOf(BitmapFontImpl).h1 = get_1;
protoOf(BitmapFontImpl).e5s = get_2;
protoOf(BitmapFontImpl).f5s = getGlyph;
protoOf(BitmapFontImpl).g5s = renderGlyph;
protoOf(BitmapFontImpl).h5t = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_12);
protoOf(LazyBitmapFont).i5r = getFontMetrics;
protoOf(LazyBitmapFont).t5r = getFontMetrics$default;
protoOf(LazyBitmapFont).u5r = getGlyphMetrics;
protoOf(LazyBitmapFont).b5s = getGlyphMetrics$default;
protoOf(LazyBitmapFont).i5t = getKerning;
protoOf(LazyBitmapFont).d5s = getTextScale;
protoOf(LazyBitmapFont).f29 = getOrNull_1;
protoOf(LazyBitmapFont).h1 = get_1;
protoOf(LazyBitmapFont).e5s = get_2;
protoOf(LazyBitmapFont).f5s = getGlyph;
protoOf(LazyBitmapFont).g5s = renderGlyph;
protoOf(LazyBitmapFont).h5t = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_13);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.l62, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_14);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_15, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).t5r = getFontMetrics$default;
protoOf(BaseTtfFont).b5s = getGlyphMetrics$default;
protoOf(BaseTtfFont).h66 = getGlyphPath$default;
protoOf(BaseTtfFont).g5s = renderGlyph_0;
protoOf(BaseTtfFont).h5t = renderGlyph$default;
protoOf(BaseTtfFont).f29 = getOrNull_1;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_16);
initMetadataForCompanion(Companion_17);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_18);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).n6d = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).n6d = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).c4z = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_19);
initMetadataForCompanion(Companion_20);
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(AseCell, 'AseCell');
protoOf(AseBitmapCell).d6h = resolve;
initMetadataForClass(AseBitmapCell, 'AseBitmapCell', VOID, VOID, [AseCell]);
initMetadataForClass(AseLinkedCell, 'AseLinkedCell', VOID, VOID, [AseCell]);
protoOf(AseTilemapCell).d6h = resolve;
initMetadataForClass(AseTilemapCell, 'AseTilemapCell', VOID, VOID, [AseCell]);
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(AseLayer, 'AseLayer');
initMetadataForClass(AseFrame, 'AseFrame');
initMetadataForClass(AsePalette, 'AsePalette');
initMetadataForClass(AseTileset, 'AseTileset');
initMetadataForClass(AseSliceKey, 'AseSliceKey');
initMetadataForClass(AseSlice, 'AseSlice');
initMetadataForClass(AseTag, 'AseTag');
initMetadataForClass(AseImage, 'AseImage', AseImage);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForObject(ASE, 'ASE', VOID, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_21);
initMetadataForCompanion(Companion_22);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_23);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_25);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.z6o, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_26);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_27);
initMetadataForClass(Type, 'Type');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_28);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_29);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_30);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_31);
initMetadataForClass(Line, 'Line');
initMetadataForInterface(Node, 'Node');
initMetadataForClass(Style, 'Style');
initMetadataForClass(TextNode, 'TextNode', VOID, VOID, [Node]);
initMetadataForCompanion(Companion_32);
initMetadataForClass(RichTextData, 'RichTextData', VOID, VOID, [KtList]);
initMetadataForClass(Placement, 'Placement');
initMetadataForClass(RichTextDataPlacements, 'RichTextDataPlacements', RichTextDataPlacements, VOID, [KtList]);
initMetadataForCompanion(Companion_33);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_34);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_35);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).u1w = reset;
protoOf(TextRendererActions).g6x = advance;
protoOf(TextRendererActions).h6x = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForCompanion(Companion_36);
initMetadataForCompanion(Companion_37);
initMetadataForClass(TileMapData, 'TileMapData', VOID, VOID, [BaseDelegatedStackedArray2, IStackedArray2Base]);
initMetadataForClass(TileMapRepeat, 'TileMapRepeat');
initMetadataForCompanion(Companion_38);
initMetadataForClass(TileSet, 'TileSet');
initMetadataForClass(TileSetTileInfo, 'TileSetTileInfo');
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).w4y = line;
protoOf(Context2d).j1 = isEmpty;
protoOf(Context2d).x4y = rect;
protoOf(Context2d).y4y = rect_0;
protoOf(Context2d).z4y = rect_1;
protoOf(Context2d).a4z = rect_2;
protoOf(Context2d).b4z = arc;
protoOf(Context2d).c4z = arc$default;
protoOf(Context2d).d4z = circle;
protoOf(Context2d).e4z = rMoveTo;
protoOf(Context2d).f4z = rLineTo;
protoOf(Context2d).m3r = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_41);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).h74 = getBounds;
protoOf(FillShape).g74 = getPath_0;
protoOf(FillShape).z60 = getPath$default;
protoOf(FillShape).e60 = draw;
protoOf(FillShape).w6d = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).z60 = getPath$default;
protoOf(CompoundShape).w6d = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).g74 = getPath_0;
protoOf(PolylineShape).z60 = getPath$default;
protoOf(PolylineShape).e60 = draw;
protoOf(PolylineShape).w6d = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_42);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_7 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_9 = new Companion_2();
Companion_instance_10 = new Companion_3();
NewSDF_instance = new NewSDF();
Companion_instance_13 = new Companion_6();
Companion_instance_15 = new Companion_8();
Companion_instance_16 = new Companion_9();
Companion_instance_17 = new Companion_10();
Companion_instance_18 = new Companion_11();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_23 = new Companion_16();
Companion_instance_25 = new Companion_18();
Companion_instance_26 = new Companion_19();
Companion_instance_27 = new Companion_20();
Companion_instance_28 = new Companion_21();
Companion_instance_30 = new Companion_23();
Companion_instance_31 = new Companion_24();
Companion_instance_33 = new Companion_26();
WEBP_WASM_BASE64_ZLIB = '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';
Companion_instance_36 = new Companion_29();
Companion_instance_37 = new Companion_30();
NonePaint_instance = new NonePaint();
Companion_instance_44 = new Companion_37();
Companion_instance_47 = new Companion_40();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  Direction_FORWARD_getInstance as Direction_FORWARD_getInstance1t5ovwsbek0pm,
  Direction_ONCE_FORWARD_getInstance as Direction_ONCE_FORWARD_getInstance3k0ums5clxkab,
  Direction_ONCE_REVERSE_getInstance as Direction_ONCE_REVERSE_getInstance23nmrkk0oltbk,
  Direction_REVERSE_getInstance as Direction_REVERSE_getInstance1vyfjipij2sd,
  TileMapRepeat_NONE_getInstance as TileMapRepeat_NONE_getInstance3oqt3h9ign48,
  readBitmapFont as readBitmapFont83t9y5crcd59,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  readImageDataContainer as readImageDataContainer2lprlqcbjs9rp,
  _RGBA___init__impl__lqpay5 as _RGBA___init__impl__lqpay52mmt2z5w8x6du,
  _RGBA___get_a__impl__6msvu7 as _RGBA___get_a__impl__6msvu7bgji1ly0wy68,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_b__impl__m6tl80 as _RGBA___get_b__impl__m6tl80qg881mr99i7e,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_g__impl__o8pukr as _RGBA___get_g__impl__o8pukr1q8mr1galt839,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  _RGBA___get_r__impl__duz7mo as _RGBA___get_r__impl__duz7mojwqekabyzvum,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__times_impl_wehs9n as RGBA__times_impl_wehs9n2bi9iz06j1oam,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  RGBA__withAf_impl_dpdu32 as RGBA__withAf_impl_dpdu32g4ua5xko755s,
  RGBA__withRGB_impl_scofdy as RGBA__withRGB_impl_scofdy1vl1fsxm1vhyf,
  _HorizontalAlign___init__impl__ad654o as _HorizontalAlign___init__impl__ad654o328mfz7v8v6wh,
  HorizontalAlign__hashCode_impl_7x9oj5 as HorizontalAlign__hashCode_impl_7x9oj53lm7edsae0frk,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  HorizontalAlign__toString_impl_toflc0 as HorizontalAlign__toString_impl_toflc02g25ounfaowz6,
  _VerticalAlign___init__impl__f42kfq as _VerticalAlign___init__impl__f42kfqeutpzsxwen37,
  VerticalAlign__hashCode_impl_vx8hj7 as VerticalAlign__hashCode_impl_vx8hj7r7mt6hnnkjo9,
  _VerticalAlign___get_ratio__impl__b3ilr8 as _VerticalAlign___get_ratio__impl__b3ilr836byhppoe4oz1,
  VerticalAlign__toString_impl_hcpnn2 as VerticalAlign__toString_impl_hcpnn21fyiif9yt4pio,
  _Tile___get_flipX__impl__jobqpf as _Tile___get_flipX__impl__jobqpf1knv3g6l37hhc,
  _Tile___get_flipY__impl__95aqcs as _Tile___get_flipY__impl__95aqcs3eosz51c5luh5,
  _Tile___get_isInvalid__impl__yfg9ed as _Tile___get_isInvalid__impl__yfg9ed6fzn22khx1pq,
  _Tile___get_offsetX__impl__qwhdsd as _Tile___get_offsetX__impl__qwhdsd1rggj0on9yzfy,
  _Tile___get_offsetY__impl__1x539u as _Tile___get_offsetY__impl__1x539u1dbavim42f9wo,
  _Tile___get_raw__impl__kp6cq8 as _Tile___get_raw__impl__kp6cq829wdyvsj2ufu1,
  _Tile___get_rotate__impl__5kjdv9 as _Tile___get_rotate__impl__5kjdv930g6fje0up0rl,
  _Tile___get_tile__impl__nfq1aw as _Tile___get_tile__impl__nfq1aw1gqd94vgk0ayk,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  Companion_getInstance_24 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_18 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_17 as Companion_instance1sgltfeqg9bxt,
  ASE_getInstance as ASE_getInstanceocshgtiexxqz,
  Companion_instance_30 as Companion_instance2dz6ggjmyv23a,
  Companion_getInstance_51 as Companion_getInstance1fkxm1hmgpvgy,
  Companion_getInstance_50 as Companion_getInstance2w9pdpq8h2ue0,
  Companion_getInstance_53 as Companion_getInstance1xsohje9yg2sq,
  Companion_getInstance_55 as Companion_getInstance3ctl2vl10i40x,
  MutableAtlas as MutableAtlas41tbjanvwcb0,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  extract_0 as extractrn4rijx1x4kx,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice_0 as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  get_lazyBitmap_0 as get_lazyBitmap3pyj425xl7cp4,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  values_5 as valuesqjo9iwejchbd,
  Direction as Directionr5it5sg7m2hk,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  ImageFrame as ImageFrame1n3b6yvrbbt3z,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  packInMutableAtlas_0 as packInMutableAtlas1obu6aohcwnbg,
  packInMutableAtlas as packInMutableAtlasrmu7ot63k72n,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  toProps as toPropsuld7zaezrb2a,
  HorizontalAlign as HorizontalAlignngoyss7iwb4p,
  RichTextData as RichTextData1m4oei1jdcuz5,
  TextAlignment as TextAlignment3ini4ufbvmn40,
  VerticalAlign as VerticalAlign3haa5uafdkdst,
  place as placem8wpiy4fm4tw,
  TileMapData as TileMapData285v3okd3krdh,
  TileSetTileInfo as TileSetTileInfo253o60hp1pekl,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
